// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Gilroy-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Gilroy-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Gilroy-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/icons/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/images/icons/cross.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Assistant:regular,600,700,800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poiret+One:regular&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Gilroy;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: Gilroy;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: Gilroy;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: 400;
  font-style: normal;
}
body {
  --scaleY: 0;
  --scaleX: 0;
  --opacity: 0;
  --progress: 0;
  --transition: "none";
  --x: translateX(-100%);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: "Gilroy";
  font-size: 0.5208335vw;
  font-style: normal;
  font-weight: normal;
  -webkit-animation: bugfix infinite 1s;
  line-height: 1.2;
  margin: 0;
  padding: 0;
}

body {
  font-style: normal;
  font-weight: normal;
  font-size: 2.5rem;
  -webkit-animation: bugfix infinite 1s;
  line-height: 1.2;
  margin: 0;
  padding: 0;
  color: #ffffff;
  background-color: #242424;
}

input,
textarea {
  -webkit-animation: bugfix infinite 1s;
  line-height: inherit;
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;
  color: inherit;
}

a {
  color: unset;
}

a,
a:hover {
  -webkit-text-decoration: none;
  text-decoration: none;
}

button,
input,
a,
textarea {
  outline: none;
  cursor: pointer;
  font: inherit;
}
button:focus,
input:focus,
a:focus,
textarea:focus {
  outline: none;
}
button:active,
input:active,
a:active,
textarea:active {
  outline: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font: inherit;
  margin: 0;
  padding: 0;
}

p {
  margin-top: 0;
  margin-bottom: 0;
}

img {
  width: 100%;
  height: auto;
  display: block;
}

button {
  border: none;
  color: inherit;
  font: inherit;
  text-align: inherit;
  padding: 0;
  background-color: transparent;
}

ul {
  padding: 0;
  margin: 0;
}

ul li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.container {
  width: 145.6rem;
  margin: 0 auto;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

@media (min-width: 1920px) {
  html {
    font-size: 10px;
  }
}
@media (max-width: 48em) {
  html {
    font-size: 5px;
    font-size: 1.5625vw;
    font-size: 1.3333333333vw;
    -webkit-text-size-adjust: none;
  }
  body {
    -webkit-text-size-adjust: none;
  }
  .container {
    padding: 0 4rem;
    width: 100%;
  }
}
.form__error {
  position: absolute;
  top: 100%;
  left: 0;
  font-size: 1.5rem;
  font-weight: 500;
  color: #f05757;
  transform: translateY(0.3rem);
}
@media (max-width: 48em) {
  .form__error {
    font-size: 2.4rem;
  }
}

.btn {
  display: inline-flex;
  align-items: center;
}
.btn_primary {
  position: relative;
  padding: 1.6rem 2.4rem;
  justify-content: space-between;
  column-gap: 1rem;
  min-width: 19.6rem;
  height: 4.9rem;
  border-radius: 10rem;
  background-color: #1a1a1a;
  overflow: hidden;
}
.btn_primary::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  transition: all 0.3s ease;
}
.btn_primary svg {
  position: relative;
  z-index: 2;
  width: 1.6rem;
  height: 1.6rem;
}
.btn_primary path {
  transition: stroke 0.3s ease;
}
@media (any-hover: hover) {
  .btn_primary:hover::after {
    opacity: 0;
    transform: scaleY(0);
  }
  .btn_primary:hover path {
    stroke: #ffffff;
  }
  .btn_primary:hover .btn__text {
    color: #ffffff;
  }
}
@media (max-width: 48em) {
  .btn_primary {
    padding: 2.2rem 3.2rem 2rem 3.2rem;
    column-gap: 2rem;
    height: 7.8rem;
    min-width: 32rem;
    border-radius: 20rem;
  }
  .btn_primary svg {
    width: 2.2rem;
    height: 2.2rem;
  }
}
.btn_link {
  transform: translateX(1.6rem);
}
.btn_link .btn__text {
  color: #ffffff;
}
.btn_link svg {
  width: 1.6rem;
  height: 1.6rem;
  transform: translateX(1.6rem);
  transition: transform 0.3s ease;
}
.btn_link:hover svg {
  transform: translateX(0.8rem);
}
@media (max-width: 48em) {
  .btn_link svg {
    width: 2rem;
    height: 2rem;
  }
}
.btn__text {
  position: relative;
  z-index: 2;
  padding-top: 0.1rem;
  color: #1a1a1a;
  white-space: nowrap;
  transition: color 0.3s ease;
}
@media (max-width: 48em) {
  .btn__text {
    padding-top: 0.4rem;
  }
  .btn__text.txt, .btn__text.input__field {
    font-size: 2.8rem;
  }
}

input[type=text],
input[type=email],
input[type=tel],
textarea {
  -webkit-appearance: none;
  appearance: none;
}

textarea:focus,
input:focus {
  outline: none;
}

.input {
  position: relative;
}
.input__field {
  display: block;
  width: 100%;
  padding: 1.6rem 0;
  border-radius: 0 !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  font-size: 1.8rem;
  transition: all 0.3s ease;
}
.input__field::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.input__field._form-focus {
  border-bottom: 2px solid #ffffff;
}
.input__field._form-error {
  color: #f05757;
  border-bottom: 2px solid #f05757;
}
.input__field._form-error::placeholder {
  color: #f05757;
}
.input__field._filled {
  color: #ffffff;
  border-bottom: 2px solid #ffffff;
}
@media (max-width: 48em) {
  .input__field {
    padding: 1.6rem 0;
  }
}

textarea.input {
  padding: 0;
  resize: none;
}

.checkbox {
  position: relative;
}
.checkbox._form-error .checkbox__text {
  color: #f05757;
}
.checkbox__input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}
.checkbox__input._form-error + .checkbox__label::before {
  border: 1px solid #f05757;
}
.checkbox__input:checked + .checkbox__label:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: center;
  background-size: 1.4rem;
  background-repeat: no-repeat;
}
@media (max-width: 48em) {
  .checkbox__input:checked + .checkbox__label:before {
    background-size: 3rem;
  }
}
.checkbox__label {
  display: inline-flex;
  align-items: center;
  position: relative;
  column-gap: 2.4rem;
  cursor: pointer;
}
.checkbox__label:before {
  content: "";
  flex: 0 0 2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  border: 1px solid #ffffff;
  transition: border 1px solid;
}
@media (max-width: 48em) {
  .checkbox__label {
    column-gap: 2.5rem;
  }
  .checkbox__label::before {
    flex: 0 0 4.8rem;
    width: 4.8rem;
    height: 4.8rem;
  }
}
.checkbox__text {
  transition: color 0.3s ease;
}
.checkbox__text.txt, .checkbox__text.input__field {
  line-height: 155%;
}
@media (max-width: 48em) {
  .checkbox__text.txt, .checkbox__text.input__field {
    font-size: 2.7rem;
  }
}

body::before {
  content: "";
  position: fixed;
  z-index: 90;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background-color: #1a1a1a;
  pointer-events: none;
  transition: opacity 0.8s ease 0s;
}
@media (min-width: 48em) {
  body::before {
    background: rgba(106, 106, 106, 0.2);
    -webkit-backdrop-filter: blur(1.9rem);
            backdrop-filter: blur(1.9rem);
  }
}

.popup-show body::before {
  opacity: 1;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 3rem 1rem;
  visibility: hidden;
  pointer-events: none;
  transition: visibility 0.8s ease 0s;
}
@media (max-width: 48em) {
  .popup.request-modal {
    padding: 0;
  }
}

.popup_show {
  z-index: 150;
  visibility: visible;
  overflow: auto;
  pointer-events: auto;
}

.popup_show .popup__content {
  visibility: visible;
  transform: scale(1);
}

.popup__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  min-height: 100%;
  width: 100%;
}

.popup__content {
  padding: 2rem;
  width: 100%;
  max-width: 127.8rem;
  background-color: #242424;
  visibility: hidden;
  transform: scale(0);
  transition: transform 0.3s ease 0s;
}
.lock .popup__content {
  visibility: visible;
}
.request-modal .popup__content {
  padding: 0;
  display: grid;
}
@media (min-width: 48em) {
  .request-modal .popup__content {
    grid-template-columns: 59.9rem 1fr;
  }
}

@media (max-width: 48em) {
  .request-modal .popup__wrapper {
    justify-content: stretch;
  }
  .request-modal .popup__content {
    flex: 1 1 auto;
  }
}
@media (max-width: 48em) {
  .request-modal__image-wrap {
    margin-bottom: 6.3rem;
    width: 100%;
    height: 46rem;
  }
}
.request-modal__image {
  height: 100%;
  object-fit: cover;
}
.request-modal__body {
  padding: 2.5rem 2.5rem 9.7rem 8rem;
  display: flex;
  flex-direction: column;
}
@media (max-width: 48em) {
  .request-modal__body {
    padding: 5rem 0 21.4rem 0;
  }
  .request-modal_sent .request-modal__body {
    align-items: center;
    text-align: center;
  }
}
@media (min-width: 48em) {
  .request-modal_sent .request-modal__body {
    padding: 2.5rem 2.5rem 23.6rem 8rem;
  }
}
.request-modal__close-btn {
  margin-bottom: 4.9rem;
  width: 3rem;
  height: 3rem;
  align-self: flex-end;
}
@media (max-width: 48em) {
  .request-modal__close-btn {
    margin-bottom: 11rem;
    width: 5rem;
    height: 5rem;
    transform: translateX(-3.2rem);
  }
}
@media (min-width: 48em) {
  .request-modal_sent .request-modal__close-btn {
    margin-bottom: 18.8rem;
  }
}
.request-modal__title {
  margin-bottom: 3.2rem;
}
@media (max-width: 48em) {
  .request-modal__title {
    padding: 0 3.2rem;
  }
}
@media (min-width: 48em) {
  .request-modal_sent .request-modal__title {
    max-width: 53.3rem;
  }
}
.request-modal__text {
  margin-bottom: 6rem;
}
.request-modal_sent .request-modal__text {
  margin-bottom: 3.2rem;
}
@media (max-width: 48em) {
  .request-modal__text {
    margin-bottom: 5rem;
    padding: 0 3.2rem;
    max-width: 58.2rem;
  }
}
.request-modal__form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (max-width: 48em) {
  .request-modal__form {
    padding: 0 3.2rem;
  }
}
.request-modal__fields {
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  row-gap: 2.4rem;
  width: 50rem;
}
@media (max-width: 48em) {
  .request-modal__fields {
    margin-bottom: 5rem;
    row-gap: 5rem;
    width: 100%;
  }
}
@media (max-width: 48em) {
  .request-modal__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 2rem;
  }
}
@media (min-width: 48em) {
  .request-modal__checkbox {
    margin-bottom: 5.6rem;
  }
}
.request-modal__btn {
  min-width: 15.3rem;
}
@media (max-width: 48em) {
  .request-modal__btn {
    min-width: 24.6rem;
  }
}
@media (min-width: 48em) {
  .request-modal__btn {
    align-self: flex-start;
  }
}

.ymaps3x0--main-engine-container {
  filter: grayscale(1);
  -ms-filter: grayscale(1);
  -webkit-filter: grayscale(1);
  -moz-filter: grayscale(1);
  -o-filter: grayscale(1);
}

.marker {
  position: relative;
  box-sizing: border-box;
  width: 8.2rem;
  transform: translate(-50%, calc(-50% - 24px));
  cursor: pointer;
}
@media (max-width: 48em) {
  .marker {
    width: 10rem;
  }
}

[class*=-ibg] {
  position: relative;
}
[class*=-ibg] img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
}

[class*=-ibg_contain] img {
  object-fit: contain;
}

.wrapper::after, .wrapper::before, .hero-portfolio__container::before, .company-methods__body::before, .company-methods__body::after, .company-methods__container::before, .privileges-company-info__text-wrap .privileges-company-info__text::after, .privileges-company-info__column:last-child::before, .privileges-company-info::after, .privileges-company-info::before, .numbers-company-info__row_left::after, .numbers-company-info::after, .numbers-company-info::before, .info-company-info__text-wrap::before, .info-company-info::after, .info-company-info::before, .contacts__content::after, .contacts__container::after, .contacts__container::before, .portfolio__footer::after, .portfolio__cell:not(:last-child)::after, .portfolio__row:last-child::after, .portfolio__row::before, .portfolio__body::after, .portfolio__head::after, .portfolio__container::before, .project-interiors__body::before, .project-interiors__body::after, .project-interiors__container::before, .project-layout__slider::after, .project-layout__head::after, .project-layout__content::before, .project-layout__content::after, .project-layout__container::before, .project-layout__container::after, .project-info__body::before, .project-info__body::after, .project-info__container::before, .hero-project__container::before, .image-text__body::before, .image-text__head::before, .image-text__head::after, .image-text__text-wrap::after, .image-text__container::before, .projects__body::before, .projects__body::after, .projects__tabs-wrapper::before, .projects__tabs-wrapper::after, .projects__container::before, .our-team__slider::before, .our-team__slider::after, .our-team__container::before, .projects-page .request__content::after, .contacts-page .request__content::after, .contacts-page .request__content::before, .request__image-wrap::before, .request__container::after, .request__container::before, .team__body::after, .team__head::after, .team__container::before, .team__container::after, .privileges__row:not(:last-child)::after, .privileges__cards::after, .privileges__image-wrap::after, .privileges__head::after, .privileges__container::after, .privileges__container::before, .card-services::before, .card-services::after, .services__container::after, .about-company__column:first-child::after, .about-company__head::after, .about-company__text-wrap::before, .about-company__text-wrap::after, .about-company__container::after, .hero__info-txt::after, .about-company-page .hero__title::after, .hero__text-wrap::before, .hero__text-wrap::after, .hero__container::before, .footer__container::after, .footer::after, .section-footer::before, .section-footer::after, .tab__text::after {
  content: "";
  position: absolute;
  width: 2px;
  height: 100%;
  background-color: #505050;
  transform-origin: left top;
}

.swiper-slide.hero-portfolio__slide {
  opacity: 0 !important;
  visibility: hidden !important;
}
.swiper-slide-active.hero-portfolio__slide {
  opacity: 1 !important;
  visibility: visible !important;
}

body {
  position: relative;
}
body::after {
  content: "";
  position: fixed;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.05);
  -webkit-backdrop-filter: blur(4rem);
          backdrop-filter: blur(4rem);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}
@media (max-width: 48em) {
  .menu-open body::after {
    opacity: 1;
    visibility: visible;
  }
}

.main {
  position: relative;
}
@media (max-width: 48em) {
  .main::before {
    content: "";
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 16.4rem;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.05);
    -webkit-backdrop-filter: blur(4.6rem);
            backdrop-filter: blur(4.6rem);
    transition: transform 0.3s ease;
  }
  ._header-scroll .main::before {
    transform: translateY(-110%);
  }
  ._header-show .main::before {
    transform: translateY(0);
  }
  .menu-open .main::before {
    transform: translateY(-110%);
  }
}

.sidebar {
  position: absolute;
  z-index: 100;
  top: 0;
  left: auto;
  padding: 3.6rem 2.3rem 9rem 2.3rem;
  height: 100%;
  background-color: rgba(106, 106, 106, 0.2);
  -webkit-backdrop-filter: blur(1.9rem);
          backdrop-filter: blur(1.9rem);
}
@media (max-width: 48em) {
  .sidebar {
    position: fixed;
    left: 0;
    padding: 4rem 0;
    width: 100%;
    height: 16.4rem;
    background-color: transparent;
    -webkit-backdrop-filter: blur(0);
            backdrop-filter: blur(0);
    transition: all 0.3s ease;
  }
  ._header-scroll .sidebar {
    transform: translateY(-110%);
  }
  ._header-show .sidebar {
    transform: translateY(0);
  }
}
@media (min-width: 48em) {
  .sidebar {
    position: fixed;
    width: 15rem;
    transition: width 0.4s ease;
  }
  .menu-open .sidebar {
    width: 30.7rem;
  }
}
.sidebar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
@media (min-width: 48em) {
  .sidebar__inner {
    flex-direction: column;
  }
}
@media (max-width: 48em) {
  .sidebar__inner {
    padding: 0 3.2rem;
  }
}
.sidebar__logo-wrap {
  width: 10.4rem;
}
@media (max-width: 48em) {
  .sidebar__logo-wrap {
    position: relative;
    z-index: 105;
    width: 13.6rem;
  }
}
@media (min-width: 48em) {
  .sidebar__logo-wrap {
    margin-bottom: 8.6rem;
  }
}
.sidebar__logo {
  object-fit: contain;
}
.sidebar__socials {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.9rem;
}
@media (max-width: 48em) {
  .sidebar__socials {
    margin-bottom: 2rem;
    flex-direction: row;
    column-gap: 5rem;
  }
}
@media (min-width: 48em) {
  .sidebar__socials-item._mobile-only {
    display: none;
  }
}
.sidebar__socials-link {
  display: inline-block;
  width: 3.2rem;
}
@media (max-width: 48em) {
  .sidebar__socials-link {
    width: 6rem;
  }
}
.sidebar__socials-icon {
  object-fit: contain;
}
.sidebar__tel {
  font-family: Assistant;
  opacity: 0;
  visibility: hidden;
  white-space: nowrap;
  transition: all 0.4s ease;
}
.menu-open .sidebar__tel {
  opacity: 1;
  visibility: visible;
}
@media (max-width: 48em) {
  .sidebar__tel {
    margin-bottom: 5rem;
  }
  .sidebar__tel.txt, .sidebar__tel.input__field {
    font-size: 6rem;
    font-weight: 700;
  }
}

.hamburger {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.6rem;
  width: 3.4rem;
}
.hamburger::before, .hamburger::after {
  content: "";
}
.hamburger::before, .hamburger::after,
.hamburger span {
  width: 100%;
  height: 0.2rem;
  background-color: #ffffff;
}
.hamburger span {
  transform: scaleX(0.7);
  transition: transform 0.4s ease;
}
@media (max-width: 48em) {
  .hamburger {
    row-gap: 1.2rem;
    width: 6.5rem;
  }
  .hamburger::before, .hamburger::after,
  .hamburger span {
    height: 0.4rem;
    transition: all 0.3s ease;
  }
  .menu-open .hamburger {
    position: absolute;
  }
  .menu-open .hamburger::before, .menu-open .hamburger::after,
  .menu-open .hamburger span {
    opacity: 0;
    visibility: hidden;
  }
}
@media (min-width: 48em) {
  .hamburger {
    transition: all 0.3s ease;
  }
  .menu-open .hamburger {
    opacity: 0;
    visibility: hidden;
  }
}

.menu {
  position: relative;
}
@media (min-width: 48em) {
  .menu {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
  }
}
@media (any-hover: hover) {
  .menu__hamburger-wrap:hover .hamburger span {
    transform: scaleX(0.99);
  }
}
@media (max-width: 48em) {
  .menu__hamburger-wrap {
    position: relative;
    z-index: 105;
    display: flex;
    align-items: center;
  }
  .menu__hamburger-wrap::after {
    content: "";
    position: absolute;
    width: 6.5rem;
    height: 6.5rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }
  .menu-open .menu__hamburger-wrap::after {
    position: static;
    opacity: 1;
    visibility: visible;
  }
}
@media (min-width: 48em) {
  .menu__hamburger-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1.6rem;
    transform: translate(-50%, -50%);
  }
  .menu-open .menu__hamburger-wrap {
    opacity: 0;
    visibility: hidden;
  }
}
.menu__hamburger-txt {
  text-transform: uppercase;
  color: #ffffff;
}
.menu__body {
  opacity: 0;
  visibility: hidden;
}
@media (max-width: 48em) {
  .menu__body {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding-top: 40rem;
    padding-bottom: 12rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    overflow: auto;
  }
}
.menu-open .menu__body {
  opacity: 1;
  visibility: visible;
}
.menu__list {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 4.8rem;
  text-align: center;
}
@media (max-width: 48em) {
  .menu__list {
    margin-bottom: 39.6rem;
    row-gap: 6.4rem;
  }
}
.menu__link, .footer__navigation-link {
  position: relative;
  text-transform: uppercase;
}
.menu__link::after, .footer__navigation-link::after {
  content: "";
  position: absolute;
  bottom: -0.3rem;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #ffffff;
  opacity: 0;
  transform: scaleX(0);
  transform-origin: center;
  transition: all 0.5s ease;
}
@media (any-hover: hover) {
  .menu__link:hover::after, .footer__navigation-link:hover::after {
    opacity: 1;
    transform: scaleX(1);
  }
}
@media (max-width: 48em) {
  .menu__link, .footer__navigation-link {
    font-size: 4rem;
  }
}

.nav-btn {
  flex: 0 0 6rem;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
}
.nav-btn svg {
  width: 6rem;
  height: 6rem;
  transition: fill 0.4s ease;
}
.nav-btn svg path {
  transition: stroke 0.4s ease;
}
@media (any-hover: hover) {
  .nav-btn:hover svg {
    fill: #ffffff;
  }
  .nav-btn:hover svg path {
    stroke: #1a1a1a;
  }
}
@media (max-width: 48em) {
  .nav-btn {
    flex: 0 0 8rem;
    width: 8rem;
    height: 8rem;
  }
  .nav-btn svg {
    width: 8rem;
    height: 8rem;
  }
}

.sl-fraction {
  display: flex;
  align-items: center;
  column-gap: 5rem;
}
.sl-fraction__progress {
  display: none;
}
@media (min-width: 48em) {
  .sl-fraction__progress {
    position: relative;
    display: block;
    flex: 0 0 36.8rem;
    width: 36.8rem;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.6);
  }
  .sl-fraction__progress::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    top: 0;
    left: 0;
    background-color: #ffffff;
    transform-origin: left;
    transform: scaleX(var(--progress));
  }
}
.sl-fraction__content {
  white-space: nowrap;
}

.tab {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}
.tab._active .tab__text {
  background-color: rgba(255, 255, 255, 0.2);
}
.tab._active .tab__text::after {
  opacity: 0;
}
@media (max-width: 48em) {
  .tab {
    border-top: 2px solid rgba(255, 255, 255, 0.2);
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
    border-right: 2px solid rgba(255, 255, 255, 0.2);
  }
  .tab_fc {
    border-left: 2px solid rgba(255, 255, 255, 0.2);
  }
}
.tab__text {
  position: relative;
  padding: 3.2rem 3.8rem;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  transition: all 0.3s ease;
}
.tab__text::after {
  top: 0;
  right: 0;
  height: 100%;
  transition: opacity 0.3s ease;
}
@media (max-width: 48em) {
  .tab__text {
    padding: 2.8rem 4rem;
  }
  .tab__text::after {
    display: none;
  }
  .tab__text.txt, .tab__text.input__field {
    font-size: 2.8rem;
  }
}

.image-gradient {
  position: relative;
}
.image-gradient::after {
  content: "";
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(36, 36, 36, 0) 0%, rgb(36, 36, 36) 100%);
  opacity: var(--opacity);
  transform: var(--x);
}

.section-footer::before, .section-footer::after {
  left: 0;
  width: 100%;
  height: 2px;
}
.section-footer::before {
  top: 0;
}
.section-footer::after {
  bottom: 0;
}
@media (max-width: 48em) {
  .section-footer {
    position: relative;
    padding: 3.2rem 0;
  }
}

.page-nav {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.page-nav__num:not(:last-child) {
  margin-right: 2.4rem;
}
.page-nav__num:not(:last-child)._active {
  margin-right: 12rem;
}
.page-nav__num:not(.page-nav__num._active) {
  color: #9a9a9a;
}
@media (max-width: 48em) {
  .page-nav__num:not(:last-child) {
    margin-right: 1rem;
  }
  .page-nav__num:not(:last-child)._active {
    margin-right: 5rem;
  }
}

.tl1 {
  font-size: 5.4rem;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.2rem;
  line-height: 130%;
}
@media (max-width: 48em) {
  .tl1 {
    font-size: 6rem;
  }
}

.tl2 {
  font-size: 3rem;
  font-weight: 600;
  text-transform: uppercase;
  line-height: 120%;
  letter-spacing: 0.1rem;
}
@media (max-width: 48em) {
  .tl2 {
    font-size: 4.2rem;
  }
}

.tl3 {
  font-size: 2.6rem;
  font-weight: 600;
}
@media (max-width: 48em) {
  .tl3 {
    font-size: 4rem;
  }
}

.reg {
  font-weight: 400;
}

.txt, .input__field {
  font-family: Gilroy;
  line-height: 130%;
}
@media (max-width: 48em) {
  .txt, .input__field {
    font-size: 3.2rem;
  }
}
.txt_16 {
  font-size: 1.6rem;
}
@media (max-width: 48em) {
  .txt_16 {
    font-size: 3.2rem;
  }
}
.txt_18 {
  font-size: 1.8rem;
}
@media (max-width: 48em) {
  .txt_18 {
    font-size: 3.2rem;
  }
}

.grid {
  display: grid;
}
@media (min-width: 48em) {
  .grid {
    grid-template-columns: 15rem 1fr;
  }
}

@media (max-width: 48em) {
  .desktop-only {
    display: none;
  }
}

@media (min-width: 48em) {
  .mobile-only {
    display: none;
  }
}

.footer {
  position: relative;
  margin-bottom: 2.8rem;
}
.footer::after {
  bottom: 0;
  left: 2px;
  width: 100%;
  height: 2px;
}
.scroll-trigger .footer::after {
  transform: scaleX(var(--scaleX));
}
@media (max-width: 48em) {
  .footer {
    margin: 0;
    padding: 0 3.2rem;
  }
  .footer::after {
    display: none;
  }
}
.footer__container {
  padding: 8.8rem 0 8rem 3rem;
  display: flex;
  flex-direction: column;
}
.footer__container::after {
  left: 0;
  top: -18rem;
  height: calc(100% + 18rem + 2.8rem);
}
.scroll-trigger .footer__container::after {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .footer__container {
    position: relative;
    grid-column: 2/3;
    row-gap: 6.4rem;
  }
}
@media (max-width: 48em) {
  .footer__container {
    padding: 3.2rem 0 6rem 0;
    border-top: 2px solid rgba(255, 255, 255, 0.2);
  }
  .footer__container::after {
    display: none;
  }
}
.footer__row {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 48em) {
  .footer__row_upper {
    margin-bottom: 6.4rem;
  }
}
@media (max-width: 48em) {
  .footer__row_lower {
    margin-bottom: 8rem;
    flex-direction: column;
  }
}
.footer__contacts {
  display: flex;
  flex-direction: column;
  row-gap: 1.6rem;
}
@media (min-width: 48em) {
  .footer__contacts {
    align-items: flex-start;
    row-gap: 0.8rem;
  }
}
.footer__tel {
  font-family: Assistant;
}
@media (max-width: 48em) {
  .footer__tel {
    font-size: 700;
  }
}
.footer__mail {
  font-size: 2.4rem;
  color: #9a9a9a;
}
@media (max-width: 48em) {
  .footer__mail {
    font-size: 3.2rem;
  }
}
.footer__socials {
  display: flex;
  align-items: center;
  align-self: flex-start;
  column-gap: 3rem;
}
@media (max-width: 48em) {
  .footer__socials {
    column-gap: 6rem;
  }
}
.footer__socials-link {
  display: inline-block;
  width: 5rem;
}
@media (max-width: 48em) {
  .footer__socials-link {
    width: 7rem;
  }
}
.footer__socials-icon {
  object-fit: contain;
}
.footer__address {
  display: flex;
  flex-direction: column;
  row-gap: 0.8rem;
}
@media (max-width: 48em) {
  .footer__address {
    margin-bottom: 9rem;
    row-gap: 1.6rem;
  }
}
.footer__address-text {
  color: #9a9a9a;
}
@media (min-width: 48em) {
  .footer__navigation {
    align-self: flex-end;
  }
}
.footer__navigation-list {
  display: flex;
  column-gap: 4.8rem;
}
@media (max-width: 48em) {
  .footer__navigation-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 5rem;
    row-gap: 5rem;
  }
}
.footer__navigation-link {
  font-size: 1.6rem;
}
@media (max-width: 48em) {
  .footer__navigation-link {
    font-size: 3.2rem;
  }
}

.hero {
  position: relative;
  margin-bottom: 18rem;
}
@media (max-width: 48em) {
  .about-company-page .hero {
    margin-bottom: 28rem;
  }
}
.hero__container {
  position: relative;
  z-index: 2;
  display: grid;
  height: 100%;
}
.hero__container::before {
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.2);
}
.scroll-trigger .hero__container::before {
  transform: scaleY(var(--scaleY));
}
.mainpage .hero__container::before {
  display: none;
}
@media (max-width: 48em) {
  .hero__container {
    padding: 22.7rem 3.2rem 6.4rem 3.2rem;
    row-gap: 26.2rem;
  }
  .projects-page .hero__container {
    padding: 63.4rem 3.2rem 0 3.2rem;
    row-gap: normal;
  }
  .about-company-page .hero__container {
    padding: 0;
    row-gap: normal;
    height: auto;
  }
  .about-company-page .hero__container::before {
    display: none;
  }
}
@media (min-width: 48em) {
  .hero__container {
    grid-template-columns: 6fr 5fr;
  }
  .about-company-page .hero__container {
    grid-template-columns: 62.2rem 1fr;
  }
}
@media (min-width: 48em) {
  .hero__body {
    grid-column: 2/3;
    min-height: 100rem;
  }
}
.hero__text-wrap {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
}
.about-company-page .hero__text-wrap {
  padding-top: 39.8rem;
  justify-content: flex-start;
}
.hero__text-wrap::before, .hero__text-wrap::after {
  top: 0;
  background-color: rgba(255, 255, 255, 0.2);
}
.scroll-trigger .hero__text-wrap::before, .scroll-trigger .hero__text-wrap::after {
  transform: scaleY(var(--scaleY));
}
.hero__text-wrap::before {
  left: 0;
}
.hero__text-wrap::after {
  right: -2.5rem;
}
.about-company-page .hero__text-wrap::after {
  right: 0;
}
@media (min-width: 48em) {
  .hero__text-wrap {
    padding: 5rem 0 8.8rem 3rem;
  }
}
@media (max-width: 48em) {
  .projects-page .hero__text-wrap {
    margin-bottom: 26rem;
    justify-content: flex-start;
    height: auto;
  }
  .about-company-page .hero__text-wrap {
    padding: 0 3.2rem;
  }
  .hero__text-wrap::before, .hero__text-wrap::after {
    display: none;
  }
}
.hero__title {
  margin-bottom: 3.2rem;
  display: flex;
  flex-direction: column;
}
.about-company-page .hero__title {
  position: relative;
  margin-bottom: 4rem;
  flex-direction: row;
  column-gap: 1rem;
}
.about-company-page .hero__title::after {
  left: -49.7rem;
  bottom: -1.4rem;
  width: 192rem;
  height: 2px;
  background-color: rgba(255, 255, 255, 0.2);
}
.scroll-trigger .about-company-page .hero__title::after {
  transform: scaleX(var(--scaleX));
}
@media (max-width: 48em) {
  .hero__title {
    margin-bottom: 4.8rem;
  }
  .about-company-page .hero__title {
    margin-bottom: 5rem;
    column-gap: 2rem;
  }
  .about-company-page .hero__title::after {
    display: none;
  }
}
.hero__text {
  margin-bottom: 3.2rem;
}
.about-company-page .hero__text {
  max-width: 37.5rem;
}
@media (max-width: 48em) {
  .hero__text {
    margin-bottom: 4.8rem;
    max-width: 57.8rem;
  }
  .about-company-page .hero__text {
    margin-bottom: 10rem;
    max-width: 61.5rem;
  }
}
.hero__btn {
  align-self: flex-start;
}
@media (max-width: 48em) {
  .hero__facts {
    order: -1;
  }
}
@media (min-width: 48em) {
  .hero__facts {
    padding-top: 5rem;
  }
}
.hero__slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 0;
}
.hero__slider.swiper {
  overflow: visible;
}
.hero__slide {
  position: relative;
}
.hero__slide .hero__slide-text {
  display: none;
}
.hero__slide.swiper-slide {
  opacity: 0 !important;
  visibility: hidden !important;
}
.hero__slide.swiper-slide-active {
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 48em) {
  .hero__slide {
    padding: 65rem 0 6.4rem 0;
  }
  .hero__slide .hero__text-wrap {
    position: relative;
    z-index: 2;
    margin-bottom: 26rem;
    justify-content: flex-start;
    height: auto;
  }
}
.hero__video-wrap, .hero__bg-image {
  z-index: -1;
  top: 0;
  width: 192rem;
  height: 100%;
}
.hero__video-wrap::after, .hero__bg-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(70deg, rgba(46, 46, 46, 0.2) 20.45%, rgba(0, 0, 0, 0) 63.6%), linear-gradient(0deg, rgba(70, 74, 80, 0.2) 0%, rgba(70, 74, 80, 0.2) 100%);
}
@media (max-width: 48em) {
  .hero__video-wrap, .hero__bg-image {
    left: 0;
  }
}
.hero__video-wrap {
  position: absolute;
  left: 0;
}
.hero__video-wrap video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero__bg-image {
  position: absolute;
  left: -30.7rem;
  display: flex;
}
.about-company-page .hero__bg-image {
  left: 0;
}
.about-company-page .hero__bg-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(70deg, rgba(46, 46, 46, 0.2) 20.45%, rgba(0, 0, 0, 0) 63.6%), linear-gradient(0deg, rgba(70, 74, 80, 0.2) 0%, rgba(70, 74, 80, 0.2) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%);
}
.hero__bg-image picture {
  display: flex;
  width: 100%;
}
@media (max-width: 48em) {
  .hero__bg-image {
    top: -16.4rem;
    left: -3.2rem;
    width: calc(100% + 6.4rem);
    height: calc(16.4rem + 100%);
  }
  .about-company-page .hero__bg-image {
    position: relative;
    margin-bottom: 3.2rem;
    height: 92.4rem;
    width: 100%;
    top: 0;
    left: 0;
    transform: none;
  }
}
.hero__image {
  object-fit: cover;
}
.hero__slider-control {
  z-index: 2;
  padding-top: 5rem;
  padding-bottom: 18.1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.hero__slider-control .hero__text {
  margin-bottom: 37.8rem;
  max-width: 23.5rem;
  text-align: right;
}
@media (min-width: 48em) {
  .hero__slider-control {
    padding-left: 2.5rem;
  }
}
@media (max-width: 48em) {
  .hero__slider-control {
    position: static;
    padding: 0;
    display: block;
    width: 0;
    height: 0;
  }
  .hero__slider-control .hero__text {
    position: absolute;
    top: 22.8rem;
    right: 3.2rem;
    margin: 0;
    max-width: 35.4rem;
  }
}
.hero__slider-nav {
  display: flex;
  align-items: center;
  column-gap: 1.6rem;
}
.hero__slide-text span {
  display: block;
}
.hero__slider-nav-wrap {
  display: flex;
  align-items: center;
  column-gap: 3rem;
}
@media (min-width: 48em) {
  .hero__slider-nav-wrap {
    margin-bottom: 27rem;
  }
}
@media (max-width: 48em) {
  .hero__slider-nav-wrap {
    position: absolute;
    left: 3.2rem;
    right: 3.2rem;
    bottom: 6.4rem;
    flex-direction: row-reverse;
    justify-content: space-between;
    column-gap: 0.8rem;
  }
}
@media (max-width: 48em) {
  .hero__slider-fraction {
    position: absolute;
    right: 3.2rem;
    bottom: 18rem;
  }
}
.hero__info {
  position: relative;
  padding-top: 41.6rem;
  padding-right: 10rem;
  display: inline-flex;
  flex-direction: column;
  justify-self: flex-end;
  align-items: flex-end;
  text-align: right;
}
@media (max-width: 48em) {
  .hero__info {
    padding: 0 10.2rem 0 0;
  }
}
.hero__info-ellipse {
  position: absolute;
  z-index: -1;
  top: 50%;
  right: 0;
  width: 26.9rem;
  height: 26.9rem;
  transform: translateY(-50%);
}
@media (max-width: 48em) {
  .hero__info-ellipse {
    right: 3.2rem;
    width: 37.4rem;
    height: 37.4rem;
  }
}
.hero__info-txt {
  margin-bottom: 5.5rem;
  max-width: 23.2rem;
}
.hero__info-txt::after {
  right: -10.2rem;
  bottom: -3.2rem;
  display: none;
  width: 100vw;
  height: 1px;
}
@media (max-width: 48em) {
  .hero__info-txt {
    position: relative;
    margin-bottom: 6.4rem;
    max-width: 46.2rem;
  }
  .hero__info-txt::after {
    display: inline-block;
  }
}

.facts-hero {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: start;
  justify-self: end;
  row-gap: 4.8rem;
}
@media (max-width: 48em) {
  .facts-hero {
    row-gap: 6.4rem;
  }
}
.facts-hero__item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  row-gap: 0.8rem;
  text-align: right;
}
.facts-hero__heading {
  font-family: Assistant;
}
@media (max-width: 48em) {
  .facts-hero__heading {
    font-size: 4rem;
  }
}
.facts-hero__text {
  letter-spacing: 0.05rem;
  color: #9a9a9a;
}
@media (max-width: 48em) {
  .facts-hero__text {
    color: rgba(255, 255, 255, 0.6);
  }
}

.about-company {
  margin-bottom: 18rem;
}
.about-company__container {
  position: relative;
  display: grid;
}
.about-company__container::after {
  bottom: 0;
  width: 161rem;
  height: 2px;
}
.scroll-trigger .about-company__container::after {
  transform: scaleX(var(--scaleX));
}
@media (max-width: 48em) {
  .about-company__container {
    padding: 0 3.2rem;
  }
  .about-company__container::after {
    display: none;
  }
}
@media (min-width: 48em) {
  .about-company__container {
    grid-template-columns: 6fr 5fr;
    grid-column: 2/3;
  }
}
.about-company__text-wrap {
  position: relative;
  display: grid;
}
.about-company__text-wrap::before, .about-company__text-wrap::after {
  top: -18rem;
  height: calc(100% + 18rem - 2px);
}
.scroll-trigger .about-company__text-wrap::before, .scroll-trigger .about-company__text-wrap::after {
  transform: scaleY(var(--scaleY));
}
.about-company__text-wrap::before {
  left: 0;
}
.about-company__text-wrap::after {
  right: -2.5rem;
}
@media (max-width: 48em) {
  .about-company__text-wrap::before, .about-company__text-wrap::after {
    display: none;
  }
}
.about-company__head {
  position: relative;
  padding: 0 2.6rem 2rem 3rem;
  display: flex;
  align-items: flex-end;
}
.about-company__head::after {
  left: 2px;
  bottom: 0;
  width: calc(100% + 2.5rem - 4px);
  height: 2px;
}
.scroll-trigger .about-company__head::after {
  transform: scaleX(var(--scaleX));
}
@media (max-width: 48em) {
  .about-company__head {
    padding: 0 0 3.2rem 0;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
  .about-company__head::after {
    display: none;
  }
}
.about-company__body {
  display: grid;
}
@media (min-width: 48em) {
  .about-company__body {
    grid-template-columns: 4fr 2fr;
    min-height: 54.8rem;
  }
}
@media (max-width: 48em) {
  .about-company__body {
    margin-bottom: 3.2rem;
  }
}
.about-company__column {
  padding: 3.2rem;
  display: flex;
  flex-direction: column;
}
.about-company__column:first-child::after {
  right: 0;
  top: 0;
}
.scroll-trigger .about-company__column:first-child::after {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .about-company__column {
    position: relative;
    margin-bottom: 2px;
  }
}
@media (max-width: 48em) {
  .about-company__column {
    padding: 3.2rem 0;
    row-gap: 2rem;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
  .about-company__column:first-child::after {
    display: none;
  }
}
.about-company__txt-wrap {
  row-gap: 1rem;
}
.about-company__link {
  align-self: flex-start;
}
@media (min-width: 48em) {
  .about-company__link {
    margin-top: auto;
    align-self: center;
  }
}
.about-company__image-wrap {
  width: 100%;
  height: 52.8rem;
}
@media (min-width: 48em) {
  .about-company__image-wrap {
    width: calc(100% + 23.2rem);
    height: 63.8rem;
    align-self: end;
    transform: translate(6rem, -3.4rem);
    transform: translate(6rem, -3.4rem);
  }
}
.about-company__image {
  height: 100%;
  object-fit: cover;
}

.services {
  margin-bottom: 18rem;
}
.scroll-trigger .services {
  --l1: 0;
  --l2: 0;
  --l3: 0;
}
.services__container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.services__container::after {
  bottom: 0;
  left: 2px;
  height: 2px;
  width: calc(161rem - 2px);
}
.scroll-trigger .services__container::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .services__container {
    grid-column: 2/3;
  }
}
@media (max-width: 48em) {
  .services__container {
    padding: 0 3.2rem;
  }
  .services__container::after {
    display: none;
  }
}
.services__head {
  position: relative;
  margin-bottom: 2.4rem;
  padding-left: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 6.5rem;
}
@media (max-width: 48em) {
  .services__head {
    margin-bottom: 3.2rem;
    padding: 0;
  }
}
.services__btn {
  min-width: 20.5rem;
}
@media (max-width: 48em) {
  .services__btn {
    display: none;
  }
}
.services__body {
  display: flex;
  flex-direction: column;
}
@media (max-width: 48em) {
  .services__body {
    row-gap: 9.8rem;
  }
}
.card-services {
  position: relative;
  display: grid;
}
.card-services::after {
  top: 0;
  left: 0;
}
.scroll-trigger .card-services::after {
  transform: scaleY(var(--scaleY));
}
.card-services::before {
  top: 0;
  left: 2px;
  width: 161rem;
  height: 2px;
}
.scroll-trigger .card-services::before {
  transform: scaleX(var(--scaleX));
}
.card-services:first-child::after {
  top: -26.9rem;
  height: calc(100% + 26.9rem);
}
.scroll-trigger .card-services:first-child::after {
  transform: scaleY(var(--scaleY));
}
.card-services:not(.card-services_reversed) .card-services__image {
  transform: translateX(2px);
}
@media (min-width: 48em) {
  .card-services {
    grid-template-columns: 62.2rem 1fr;
  }
  .card-services_reversed {
    grid-template-columns: 1fr 62.2rem;
  }
  .card-services_reversed .card-services__image-wrap {
    justify-self: end;
    grid-column: 2/3;
  }
  .card-services_reversed .card-services__text-wrap {
    padding-left: 16.3rem;
    grid-column: 1/2;
    grid-row: 1/2;
  }
  .card-services_reversed .card-services__num {
    left: 3rem;
  }
}
@media (max-width: 48em) {
  .card-services {
    padding-bottom: 3.2rem;
    row-gap: 8rem;
  }
  .card-services::before {
    top: auto;
    bottom: 0;
    width: 100%;
  }
  .card-services:last-child::after {
    display: none;
  }
}
.card-services__image-wrap {
  position: relative;
  min-height: 50rem;
  overflow: hidden;
}
@media (max-width: 48em) {
  .card-services__image-wrap {
    min-height: none;
    height: 40rem;
  }
}
.card-services__image {
  height: 100%;
  object-fit: cover;
}
.card-services__text-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: left;
}
@media (min-width: 48em) {
  .card-services__text-wrap {
    padding-left: 20.3rem;
    justify-content: center;
    align-self: center;
    height: 100%;
  }
}
.card-services__heading {
  margin-bottom: 2.4rem;
}
@media (max-width: 48em) {
  .card-services__heading {
    margin-bottom: 3.2rem;
  }
}
.card-services__text {
  max-width: 56.9rem;
}
@media (max-width: 48em) {
  .card-services__text {
    max-width: 68rem;
  }
}
.card-services__num {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 7rem;
  font-family: Assistant;
  font-size: 22.4rem;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 129%;
  color: rgba(255, 255, 255, 0.1);
}
@media (max-width: 48em) {
  .card-services__num {
    top: -12rem;
    left: -5.4rem;
    font-size: 18rem;
  }
}

.privileges {
  margin-bottom: 18rem;
}
.privileges__container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.privileges__container::before {
  top: -18rem;
  height: calc(100% + 18rem - 2px);
}
.scroll-trigger .privileges__container::before {
  transform: scaleY(var(--scaleY));
}
.privileges__container::after {
  bottom: 0;
  left: 0;
  height: 2px;
  width: 161rem;
}
.scroll-trigger .privileges__container::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .privileges__container {
    grid-column: 2/3;
  }
}
@media (max-width: 48em) {
  .privileges__container::before {
    display: none;
  }
}
.privileges__head {
  position: relative;
  padding-left: 3rem;
  padding-bottom: 2.4rem;
}
.privileges__head::after {
  bottom: 0;
  left: 2px;
  width: 161rem;
  height: 2px;
}
.scroll-trigger .privileges__head::after {
  transform: scaleX(var(--scaleX));
}
@media (max-width: 48em) {
  .privileges__head {
    margin-bottom: 3.2rem;
    padding-left: 0;
    padding-bottom: 3.2rem;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
  .privileges__head::after {
    display: none;
  }
}
@media (max-width: 48em) {
  .privileges__title {
    display: block;
    max-width: 50rem;
  }
}
.privileges__body {
  display: grid;
}
@media (min-width: 48em) {
  .privileges__body {
    grid-template-columns: 4fr 7fr;
  }
}
.privileges__image-wrap::after {
  top: 0;
  right: 0;
}
.scroll-trigger .privileges__image-wrap::after {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .privileges__image-wrap {
    position: relative;
    padding: 3.6rem 3rem;
  }
}
@media (max-width: 48em) {
  .privileges__image-wrap {
    padding-bottom: 3.2rem;
    height: 37rem;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
  .privileges__image-wrap::after {
    display: none;
  }
}
.privileges__image, .privileges__card-image {
  height: 100%;
  object-fit: cover;
}
.privileges__cards {
  position: relative;
  display: grid;
}
.privileges__cards::after {
  top: 0;
  right: 50%;
  width: 2px;
}
.scroll-trigger .privileges__cards::after {
  transform: scaleY(var(--scaleY));
}
.privileges__row {
  position: relative;
  display: grid;
}
.privileges__row:not(:last-child)::after {
  bottom: 0;
  left: 0;
  width: calc(50% - 2px);
  height: 2px;
}
.scroll-trigger .privileges__row:not(:last-child)::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .privileges__row {
    grid-template-columns: repeat(2, 50%);
  }
}
.privileges__card {
  position: relative;
  justify-content: center;
  height: 100%;
}
.privileges__card_text {
  display: flex;
  flex-direction: column;
  align-self: center;
}
@media (min-width: 48em) {
  .privileges__card_text {
    padding: 10.4rem 3rem;
  }
}
@media (max-width: 48em) {
  .privileges__card {
    padding: 3.2rem 0;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
  .privileges__card::before, .privileges__card::after {
    display: none;
  }
}
.privileges__card_img {
  width: calc(100% + 23.2rem);
  height: 34.7rem;
  transform: translateY(-2px);
}
@media (max-width: 48em) {
  .privileges__card_img {
    display: none;
  }
}
.privileges__heading {
  margin-bottom: 2.4rem;
}
@media (max-width: 48em) {
  .privileges__heading {
    margin-bottom: 1.6rem;
  }
}
@media (min-width: 48em) {
  .privileges__text {
    max-width: 32.4rem;
  }
}

.team {
  margin-bottom: 18rem;
}
.team__container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.team__container::before, .team__container::after {
  top: -18rem;
  height: calc(100% + 18rem);
}
.scroll-trigger .team__container::before, .scroll-trigger .team__container::after {
  transform: scaleY(var(--scaleY));
}
.team__container::before {
  right: 63.2rem;
}
.team__container::after {
  left: 0;
}
.scroll-trigger .team__container::after {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .team__container {
    grid-column: 2/3;
  }
}
@media (max-width: 48em) {
  .team__container {
    padding: 0 3.2rem;
  }
  .team__container::before, .team__container::after {
    display: none;
  }
}
.team__head {
  position: relative;
}
.team__head::after {
  bottom: 0;
  left: 2px;
  width: 161rem;
  height: 2px;
}
.scroll-trigger .team__head::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .team__head {
    padding-left: 3rem;
    padding-bottom: 2.4rem;
  }
}
@media (max-width: 48em) {
  .team__head {
    margin-bottom: 3.2rem;
  }
  .team__head::after {
    display: none;
  }
}
.team__title {
  font-family: Assistant;
}
.team__body {
  position: relative;
  display: grid;
}
.team__body::after {
  bottom: 0;
  left: 0;
  width: 161rem;
  height: 2px;
}
.scroll-trigger .team__body::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .team__body {
    grid-template-columns: 6fr 63.2rem;
  }
}
@media (max-width: 48em) {
  .team__body::after {
    display: none;
  }
}
.team__content {
  display: flex;
  flex-direction: column;
}
@media (min-width: 48em) {
  .team__content {
    padding: 3rem;
  }
}
.team__info {
  display: flex;
  justify-content: space-between;
}
@media (min-width: 48em) {
  .team__info {
    margin-bottom: 40rem;
    max-width: 66.3rem;
  }
}
@media (max-width: 48em) {
  .team__info {
    padding-bottom: 3rem;
    justify-content: flex-start;
    column-gap: 16rem;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
}
.team__group {
  display: flex;
  flex-direction: column;
}
.team__group-heading {
  text-transform: uppercase;
}
.team__group-txt {
  color: #9a9a9a;
}
@media (max-width: 48em) {
  .team__text {
    padding: 3rem 0;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
}
@media (min-width: 48em) {
  .team__image-wrap {
    padding: 3rem 0 3rem 3rem;
    min-height: 70rem;
    width: calc(100% + 23.2rem);
  }
}
@media (max-width: 48em) {
  .team__image-wrap {
    margin-bottom: 3.2rem;
    height: 58rem;
    grid-row: 1/2;
  }
}
.team__image {
  height: 100%;
  object-fit: cover;
}

.request {
  margin-bottom: 18rem;
}
.request__container {
  position: relative;
  padding: 0 3.2rem;
  display: grid;
}
.request__container::before {
  left: 0;
  top: -18rem;
  height: calc(100% + 18rem);
}
.scroll-trigger .request__container::before {
  transform: scaleY(var(--scaleY));
}
.request__container::after {
  bottom: 0;
  left: 2px;
  width: 161rem;
  height: 2px;
}
.scroll-trigger .request__container::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .request__container {
    padding: 3rem;
    grid-column: 2/3;
    grid-template-columns: 5fr 6fr;
  }
}
@media (max-width: 48em) {
  .request__container::before, .request__container::after {
    display: none;
  }
}
.request__image-wrap::before {
  top: -3rem;
  left: calc(2px - 3rem);
  width: 161rem;
  height: 2px;
}
.scroll-trigger .request__image-wrap::before {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .request__image-wrap {
    position: relative;
    min-height: 54.2rem;
  }
}
@media (max-width: 48em) {
  .request__image-wrap {
    margin-bottom: 3.2rem;
    height: 39rem;
  }
  .request__image-wrap::before {
    display: none;
  }
}
.request__image {
  height: 100%;
  object-fit: cover;
}
.request__content {
  display: flex;
  flex-direction: column;
}
.contacts-page .request__content {
  position: relative;
}
.contacts-page .request__content::before {
  top: -21rem;
  right: calc(69.8rem - 2px);
  height: calc(100% + 6rem + 18rem);
}
.contacts-page .request__content::after {
  top: -21rem;
  right: -3rem;
  height: calc(100% + 6rem + 18rem);
}
.projects-page .request__content {
  position: relative;
}
.projects-page .request__content::after {
  top: -21rem;
  right: 0;
  height: calc(100% + 24rem - 2px);
}
.scroll-trigger .projects-page .request__content::after {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .request__content {
    padding-left: 15.6rem;
  }
}
@media (max-width: 48em) {
  .contacts-page .request__content::before, .contacts-page .request__content::after {
    display: none;
  }
  .projects-page .request__content::after {
    display: none;
  }
}
.request__text-wrap {
  margin-bottom: 5.6rem;
  display: flex;
  flex-direction: column;
}
@media (max-width: 48em) {
  .request__text-wrap {
    margin-bottom: 4.8rem;
  }
}
.request__title {
  margin-bottom: 2.4rem;
}
@media (max-width: 48em) {
  .request__title {
    margin-bottom: 3.2rem;
  }
}
.request__form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 49.9rem;
}
@media (max-width: 48em) {
  .request__form {
    display: grid;
    grid-template-columns: repeat(2, auto);
    column-gap: 2rem;
    width: 100%;
  }
}
.request__fields {
  margin-bottom: 5.6rem;
  display: flex;
  flex-direction: column;
  row-gap: 3rem;
  width: 100%;
}
@media (max-width: 48em) {
  .request__fields {
    margin-bottom: 4.8rem;
    grid-column: span 2;
    row-gap: 4.8rem;
  }
}
.request__btn {
  min-width: 15.3rem;
}
@media (max-width: 48em) {
  .request__btn {
    min-width: 24.6rem;
    order: 1;
  }
}

.our-team {
  margin-bottom: 18rem;
}
@media (max-width: 48em) {
  .our-team {
    display: none;
  }
}
.our-team__container {
  display: grid;
}
.our-team__container::before {
  z-index: 3;
  left: 0;
  top: -18rem;
  height: calc(100% + 18rem);
}
.scroll-trigger .our-team__container::before {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .our-team__container {
    position: relative;
    grid-template-columns: 6fr 6fr;
    grid-column: 2/3;
  }
}
@media (max-width: 48em) {
  .our-team__container::before {
    display: none;
  }
}
.our-team__text-wrap {
  position: relative;
  padding: 3rem;
  display: flex;
  flex-direction: column;
}
.our-team__text-wrap::before {
  content: "";
  position: absolute;
  z-index: 2;
  top: -1%;
  right: 0;
  width: calc(161.3rem - 2px);
  height: 101%;
  background-color: #242424;
}
.our-team__title {
  position: relative;
  z-index: 3;
  margin-bottom: 2.4rem;
}
.our-team__text {
  position: relative;
  z-index: 3;
  margin-bottom: 3.2rem;
}
.our-team__slider-control {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  column-gap: 3rem;
}
.our-team__slider-btn {
  flex: 0 0 5rem;
  width: 5rem;
}
.our-team__slider-btn svg {
  width: 5rem;
}
.our-team__slider {
  position: relative;
  padding: 4rem 0;
  min-width: 0;
}
.our-team__slider::before, .our-team__slider::after {
  z-index: 3;
  right: calc((31.4rem - 4px) / -2);
  width: calc(161.3rem - 4px);
  height: 2px;
}
.scroll-trigger .our-team__slider::before, .scroll-trigger .our-team__slider::after {
  transform: scaleX(var(--scaleX));
}
.our-team__slider::before {
  top: 0;
}
.our-team__slider::after {
  bottom: 0;
}
@media (min-width: 48em) {
  .our-team__slider.swiper {
    overflow: visible;
  }
}
.slide-our-team {
  display: flex;
  flex-direction: column;
}
.slide-our-team__image-wrap {
  margin-bottom: 2.4rem;
  height: 37.8rem;
}
.slide-our-team__image {
  height: 100%;
  object-fit: cover;
}
.slide-our-team__heading {
  margin-bottom: 0.4rem;
}
.slide-our-team__text {
  color: #9a9a9a;
}

.projects {
  margin-bottom: 18rem;
}
.projects__container {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.projects__container::before {
  top: -18rem;
  height: calc(100% + 36rem);
}
.scroll-trigger .projects__container::before {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .projects__container {
    grid-column: 2/3;
  }
}
@media (max-width: 48em) {
  .projects__container {
    margin-bottom: 2.4rem;
  }
  .projects__container::before {
    display: none;
  }
}
.projects__title {
  margin-bottom: 1.6rem;
}
@media (min-width: 48em) {
  .projects__title {
    margin-bottom: 3rem;
    transform: translateX(3rem);
  }
}
.projects__tabs.swiper {
  overflow: visible;
}
@media (max-width: 48em) {
  .projects__tabs {
    margin-bottom: 5rem;
  }
}
.projects__tabs-wrapper {
  position: relative;
}
.projects__tabs-wrapper::before, .projects__tabs-wrapper::after {
  left: 2px;
  width: calc(161.3rem - 4px);
  height: 2px;
}
.scroll-trigger .projects__tabs-wrapper::before, .scroll-trigger .projects__tabs-wrapper::after {
  transform: scaleX(var(--scaleX));
}
.projects__tabs-wrapper::before {
  top: -2px;
}
.projects__tabs-wrapper::after {
  bottom: -2px;
}
@media (min-width: 48em) {
  .projects__tabs-wrapper.swiper-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 50%);
  }
}
@media (max-width: 48em) {
  .projects__tabs-wrapper::before, .projects__tabs-wrapper::after {
    display: none;
  }
}
.projects__tabs-col {
  display: flex;
  justify-content: space-between;
}
.projects__tabs-col:first-child {
  margin-left: 2px;
}
@media (max-width: 48em) {
  .projects__tabs-col {
    display: none;
  }
}
.scroll-trigger .projects__tab .tab__text::after {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .projects__tab {
    flex: 1 1 auto;
  }
}
.projects__body {
  position: relative;
  margin-bottom: 9.6rem;
  display: grid;
  row-gap: 9.6rem;
}
.projects__body::before, .projects__body::after {
  top: 2px;
}
.scroll-trigger .projects__body::before, .scroll-trigger .projects__body::after {
  transform: scaleY(var(--scaleY));
}
.projects__body::before {
  left: calc(50% - 2px);
}
.projects__body::after {
  right: 0;
  height: calc(100% + 11.1rem + 18rem);
}
@media (max-width: 48em) {
  .projects__body::before, .projects__body::after {
    display: none;
  }
}
@media (min-width: 48em) {
  .projects__body {
    margin-bottom: 6.2rem;
    grid-template-columns: repeat(2, 50%);
    row-gap: 8.6rem;
  }
}
.projects__btn {
  min-width: 29.6rem;
  align-self: flex-start;
}
@media (min-width: 48em) {
  .projects__btn {
    align-self: center;
    min-width: 18.2rem;
  }
}

@media (any-hover: hover) {
  .card-projects:hover .card-projects__image-wrap {
    filter: grayscale(1);
  }
  .card-projects:hover .card-projects__link {
    opacity: 1;
    visibility: visible;
  }
}
@media (min-width: 48em) {
  .card-projects {
    padding: 3rem 3rem 0 3rem;
    -webkit-user-select: none;
            user-select: none;
  }
}
.card-projects__inner {
  display: flex;
  flex-direction: column;
}
.card-projects__image-wrap {
  margin-bottom: 3.2rem;
  height: 48rem;
  width: 100%;
}
@media (min-width: 48em) {
  .card-projects__image-wrap {
    margin-bottom: 2.4rem;
    height: 50rem;
    will-change: contents;
    transition: filter 0.3s ease;
  }
}
.card-projects__image {
  height: 100%;
  object-fit: cover;
}
.card-projects__heading-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 48em) {
  .card-projects__heading {
    font-weight: 400;
  }
}
.card-projects__link {
  opacity: 0;
  visibility: hidden;
  transform: translateX(-0.8rem);
  transition: all 0.3s ease;
}
.card-projects__info-wrap {
  padding: 1.6rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.image-text {
  margin-bottom: 18rem;
}
.image-text__container {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
}
.image-text__container::before {
  top: -18rem;
  height: calc(100% + 18rem);
}
.scroll-trigger .image-text__container::before {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .image-text__container {
    display: grid;
    grid-template-columns: 8fr 2fr;
    grid-column: 2/3;
  }
}
@media (max-width: 48em) {
  .image-text__container {
    margin-bottom: 2.4rem;
  }
  .image-text__container::before {
    display: none;
  }
}
.image-text__text-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
}
.image-text__text-wrap::after {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
}
.scroll-trigger .image-text__text-wrap::after {
  transform: scaleX(var(--scaleX));
}
.image-text__head {
  position: relative;
}
.image-text__head::before, .image-text__head::after {
  left: 0;
  width: 100%;
  height: 2px;
}
.scroll-trigger .image-text__head::before, .scroll-trigger .image-text__head::after {
  transform: scaleX(var(--scaleX));
}
.image-text__head::before {
  top: 0;
}
.image-text__head::after {
  bottom: 0;
}
@media (min-width: 48em) {
  .image-text__head {
    padding: 3.2rem 3rem;
  }
}
@media (max-width: 48em) {
  .image-text__head {
    margin-bottom: 3.2rem;
  }
  .image-text__head::before, .image-text__head::after {
    display: none;
  }
}
.image-text__title {
  display: flex;
  flex-direction: column;
}
.image-text__body {
  padding: 3.2rem 0;
  position: relative;
  display: flex;
  column-gap: 9.8rem;
}
.image-text__body::before {
  left: 0;
  top: 0;
  width: 100%;
  height: 2px;
}
.scroll-trigger .image-text__body::before {
  transform: scaleX(var(--scaleX));
}
@media (max-width: 48em) {
  .image-text__body {
    flex-direction: column;
    row-gap: 2rem;
  }
}
@media (min-width: 48em) {
  .image-text__body {
    padding: 3.2rem 3rem;
  }
  .image-text__body::before {
    display: none;
  }
}
.image-text__col {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
}
@media (max-width: 48em) {
  .image-text__col {
    row-gap: 2rem;
  }
}
@media (min-width: 48em) {
  .image-text__text {
    max-width: 42.5rem;
  }
}
.image-text__image-wrap {
  height: 37rem;
}
@media (min-width: 48em) {
  .image-text__image-wrap {
    width: calc(100% + 23.2rem);
    height: 100%;
    min-height: 77.1rem;
  }
}
@media (max-width: 48em) {
  .image-text__image-wrap {
    margin-bottom: 3.2rem;
  }
}
.image-text__image {
  height: 100%;
  object-fit: cover;
}

.hero-project {
  margin-bottom: 23.6rem;
}
@media (max-width: 48em) {
  .hero-project {
    margin-bottom: 18rem;
  }
}
.hero-project__body {
  position: relative;
}
@media (min-width: 48em) {
  .hero-project__body {
    grid-column: 2/3;
  }
}
.hero-project__container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.hero-project__container::before {
  top: 0;
  left: 0;
}
.scroll-trigger .hero-project__container::before {
  transform: scaleY(var(--scaleY));
}
@media (max-width: 48em) {
  .hero-project__container {
    padding: 0;
  }
  .hero-project__container::before {
    display: none;
  }
}
.hero-project__grid {
  display: grid;
}
@media (min-width: 48em) {
  .hero-project__grid {
    margin-bottom: 1.7rem;
    grid-template-columns: 4fr 7fr;
  }
}
.hero-project__text-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
@media (min-width: 48em) {
  .hero-project__text-wrap {
    padding: 36.2rem 6.4rem 24.9rem 3rem;
    height: 100%;
  }
}
.hero-project__title {
  margin-bottom: 3.2rem;
  display: flex;
  flex-direction: column;
}
@media (max-width: 48em) {
  .hero-project__title {
    margin-bottom: 2rem;
    max-width: 40rem;
  }
}
.hero-project__slider-nav {
  display: flex;
  align-items: center;
  gap: 1.6rem;
}
@media (max-width: 48em) {
  .hero-project__slider-nav {
    flex-direction: column;
    align-items: flex-end;
  }
}
.hero-project__carousel {
  width: 100%;
  overflow: hidden;
}
@media (min-width: 48em) {
  .hero-project__carousel {
    padding-top: 10rem;
    width: calc(100% + 129.2rem);
  }
  .two-slides .hero-project__carousel {
    margin-left: 9rem;
    width: 112rem;
  }
  .three-slides .hero-project__carousel {
    margin-left: 9rem;
    width: 163rem;
  }
}
@media (max-width: 48em) {
  .hero-project__carousel {
    margin-bottom: 3.2rem;
    order: -1;
  }
}
@media (min-width: 48em) {
  .hero-project__slide {
    width: 52rem;
  }
  .one-slide .hero-project__slide {
    width: 100%;
  }
}
.hero-project__bg-image {
  height: 72.1rem;
}
@media (max-width: 48em) {
  .hero-project__bg-image {
    height: 91rem;
  }
}
.hero-project__image {
  height: 100%;
  object-fit: cover;
}
.hero-project__group {
  display: grid;
}
@media (min-width: 48em) {
  .hero-project__group {
    padding-left: 3rem;
    grid-template-columns: 4fr 7fr;
  }
}
@media (max-width: 48em) {
  .hero-project__group {
    padding: 0 4rem;
    grid-template-columns: repeat(2, auto);
    column-gap: 10rem;
  }
}
.hero-project__group-text-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 3.2rem;
}
@media (max-width: 48em) {
  .hero-project__group-text-wrap {
    column-gap: 5rem;
  }
}
@media (max-width: 48em) {
  .hero-project__text {
    max-width: 45rem;
  }
}
.hero-project__btn {
  min-width: 20rem;
}
@media (max-width: 48em) {
  .hero-project__btn {
    min-width: 32.8rem;
  }
}
@media (min-width: 48em) {
  .hero-project__slider-fraction.sl-fraction {
    column-gap: 9.8rem;
  }
  .hero-project__slider-fraction.sl-fraction .sl-fraction__progress {
    flex: 1 1 auto;
    width: 100%;
  }
}
@media (max-width: 48em) {
  .hero-project__slider-fraction {
    order: -1;
  }
}
.one-slide .hero-project__slider-control .sl-fraction__progress {
  display: none;
}
@media (max-width: 48em) {
  .hero-project__slider-control {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    row-gap: 8rem;
  }
}
@media (min-width: 48em) {
  .hero-project__slider-control {
    align-self: flex-end;
  }
}

.project-info {
  margin-bottom: 18rem;
}
.project-info__container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.project-info__container::before {
  top: -23.6rem;
  left: 0;
  height: calc(100% + 23.6rem);
}
.scroll-trigger .project-info__container::before {
  transform: scaleY(var(--scaleY));
}
@media (max-width: 48em) {
  .project-info__container::before {
    display: none;
  }
}
@media (min-width: 48em) {
  .project-info__container {
    grid-column: 2/3;
  }
}
.project-info__head {
  padding-bottom: 3.2rem;
}
@media (min-width: 48em) {
  .project-info__head {
    padding-left: 3rem;
  }
}
.project-info__body {
  position: relative;
  padding: 3.2rem 0 0 0;
  display: grid;
}
.project-info__body::before, .project-info__body::after {
  left: 0;
  height: 2px;
  width: 100%;
}
.scroll-trigger .project-info__body::before, .scroll-trigger .project-info__body::after {
  transform: scaleX(var(--scaleX));
}
.project-info__body::before {
  top: 0;
}
.project-info__body::after {
  bottom: 0;
}
@media (min-width: 48em) {
  .project-info__body {
    padding: 3rem 3.2rem;
    grid-template-columns: 7fr 4fr;
    column-gap: 3rem;
  }
  .project-info__body::before, .project-info__body::after {
    width: calc(100% + 23.2rem);
  }
}
@media (max-width: 48em) {
  .project-info__slider {
    margin-bottom: 3.2rem;
  }
}
.project-info__slide {
  display: flex;
  min-height: 67.8rem;
}
@media (max-width: 48em) {
  .project-info__slide {
    height: 52.8rem;
    min-height: auto;
  }
}
.project-info__slider-nav {
  display: flex;
  align-items: center;
  column-gap: 1.6rem;
}
@media (max-width: 48em) {
  .project-info__slider-nav {
    justify-content: space-between;
  }
}
.project-info__image-wrap {
  height: 100%;
}
.project-info__image {
  height: 100%;
  object-fit: cover;
}
.project-info__content {
  display: flex;
  flex-direction: column;
}
@media (max-width: 48em) {
  .project-info__content {
    order: -1;
  }
}
.project-info__text-wrap {
  margin-bottom: 3.2rem;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
}
@media (max-width: 48em) {
  .project-info__text-wrap {
    row-gap: 2rem;
  }
}
@media (min-width: 48em) {
  .project-info__text {
    max-width: 52rem;
  }
}
.project-layout {
  margin-bottom: 18rem;
}
.project-layout__container {
  position: relative;
  display: grid;
}
.project-layout__container::before, .project-layout__container::after {
  left: 0;
  width: calc(100% + 129.2rem);
  height: 2px;
}
.scroll-trigger .project-layout__container::before, .scroll-trigger .project-layout__container::after {
  transform: scaleX(var(--scaleX));
}
.project-layout__container::before {
  top: 0;
}
.project-layout__container::after {
  bottom: 0;
}
@media (min-width: 48em) {
  .project-layout__container {
    grid-template-columns: 4fr 7fr;
    grid-column: 2/3;
    column-gap: 3rem;
  }
}
@media (max-width: 48em) {
  .project-layout__container::before, .project-layout__container::after {
    display: none;
  }
}
.project-layout__content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.scroll-trigger .project-layout__content::before, .scroll-trigger .project-layout__content::after {
  transform: scaleY(var(--scaleY));
}
.project-layout__content::before {
  top: -18rem;
  left: 0;
  height: calc(100% + 18rem);
}
.project-layout__content::after {
  top: 0;
  right: 0;
  height: 100%;
}
@media (max-width: 48em) {
  .project-layout__content::before, .project-layout__content::after {
    display: none;
  }
}
.project-layout__head {
  position: relative;
  padding: 3.2rem;
  width: 100%;
}
.project-layout__head::after {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
}
.scroll-trigger .project-layout__head::after {
  transform: scaleX(var(--scaleX));
}
@media (max-width: 48em) {
  .project-layout__head {
    margin-bottom: 3.2rem;
    padding: 0 0 3.2rem 0;
  }
}
.project-layout__body {
  padding: 0 0 3.2rem 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}
@media (min-width: 48em) {
  .project-layout__body {
    padding: 3rem;
    flex: 1 1 auto;
  }
}
@media (min-width: 48em) {
  .project-layout__text-wrap {
    margin-bottom: auto;
    max-width: 38.3rem;
  }
}
.project-layout__slider-nav {
  display: flex;
  align-items: center;
  column-gap: 1.6rem;
}
@media (max-width: 48em) {
  .project-layout__slider-nav {
    justify-content: space-between;
  }
}
.project-layout__slider {
  position: relative;
}
.project-layout__slider::after {
  top: 0;
  right: 0;
}
.scroll-trigger .project-layout__slider::after {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .project-layout__slider {
    padding: 3rem 3rem 3rem 0;
  }
}
@media (max-width: 48em) {
  .project-layout__slider {
    margin-bottom: 3.2rem;
  }
  .project-layout__slider::after {
    display: none;
  }
}
.project-layout__slide {
  display: flex;
  min-height: 67.8rem;
}
@media (max-width: 48em) {
  .project-layout__slide {
    height: 52.8rem;
    min-height: auto;
  }
}
.project-layout__image-wrap {
  display: flex;
  align-items: center;
  background-color: #ffffff;
}
.project-layout__image {
  object-fit: contain;
}
.project-interiors {
  margin-bottom: 18rem;
}
.project-interiors__container {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.project-interiors__container::before {
  top: -18rem;
  left: 0;
  height: calc(100% + 18rem);
}
.scroll-trigger .project-interiors__container::before {
  transform: scaleY(var(--scaleY));
}
@media (max-width: 48em) {
  .project-interiors__container::before {
    display: none;
  }
}
@media (min-width: 48em) {
  .project-interiors__container {
    grid-column: 2/3;
  }
}
.project-interiors__head {
  margin-bottom: 3.2rem;
  display: flex;
  justify-content: space-between;
}
@media (min-width: 48em) {
  .project-interiors__head {
    padding-left: 3rem;
  }
}
.project-interiors__slider-nav {
  display: flex;
  align-items: center;
  column-gap: 1.6rem;
}
@media (min-width: 48em) {
  .project-interiors__slider-nav {
    align-self: flex-end;
  }
}
@media (max-width: 48em) {
  .project-interiors__slider-nav {
    justify-content: space-between;
  }
}
.project-interiors__body {
  position: relative;
  padding: 3rem 0 3rem 3rem;
}
.project-interiors__body::before, .project-interiors__body::after {
  left: 0;
  width: calc(100% + 129.2rem);
  height: 2px;
}
.scroll-trigger .project-interiors__body::before, .scroll-trigger .project-interiors__body::after {
  transform: scaleX(var(--scaleX));
}
.project-interiors__body::before {
  top: 0;
}
.project-interiors__body::after {
  bottom: 0;
}
@media (max-width: 48em) {
  .project-interiors__body {
    padding: 3.2rem 0;
  }
  .project-interiors__body::before {
    width: 100%;
  }
  .project-interiors__body::after {
    display: none;
  }
}
.project-interiors__image-wrap {
  height: 84rem;
}
@media (max-width: 48em) {
  .project-interiors__image-wrap {
    height: 100rem;
  }
}
.project-interiors__image {
  height: 100%;
  object-fit: cover;
}

.portfolio {
  margin-bottom: 18rem;
}
.portfolio__container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.portfolio__container::before {
  top: -18rem;
  left: 0;
  height: calc(100% + 18rem);
}
.scroll-trigger .portfolio__container::before {
  transform: scaleY(var(--scaleY));
}
@media (max-width: 48em) {
  .portfolio__container::before {
    display: none;
  }
}
@media (min-width: 48em) {
  .portfolio__container {
    grid-column: 2/3;
  }
}
.portfolio__head {
  position: relative;
  margin-bottom: 3.2rem;
}
.portfolio__head::after {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
}
@media (min-width: 48em) {
  .portfolio__head {
    padding-left: 3rem;
  }
  .portfolio__head::after {
    display: none;
  }
  .scroll-trigger .portfolio__head::after {
    transform: scaleX(var(--scaleX));
  }
}
@media (max-width: 48em) {
  .portfolio__head {
    margin-bottom: 5rem;
    padding-bottom: 3.2rem;
  }
}
.portfolio__body {
  position: relative;
  display: grid;
}
.portfolio__body::after {
  right: 0;
  top: 0;
}
@media (max-width: 48em) {
  .portfolio__body {
    row-gap: 10rem;
  }
  .portfolio__body::after {
    display: none;
  }
}
@media (min-width: 48em) {
  .scroll-trigger .portfolio__body::after {
    transform: scaleY(var(--scaleY));
  }
}
.portfolio__row {
  position: relative;
  display: grid;
}
.portfolio__row:last-child::after, .portfolio__row::before {
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
}
.portfolio__row:last-child::after {
  top: auto;
  bottom: 0;
  width: calc(100% + 23.2rem);
}
@media (min-width: 48em) {
  .portfolio__row {
    grid-template-columns: repeat(4, 1fr);
  }
  .scroll-trigger .portfolio__row::before, .scroll-trigger .portfolio__row:last-child::after {
    transform: scaleX(var(--scaleX));
  }
}
@media (max-width: 48em) {
  .portfolio__row {
    padding-bottom: 3.2rem;
    row-gap: 3.2rem;
  }
  .portfolio__row::before {
    top: auto;
    bottom: 0;
  }
  .portfolio__row:last-child::after {
    width: 100%;
  }
}
.portfolio__cell {
  position: relative;
}
.portfolio__cell:not(:last-child)::after {
  top: 0;
  right: 0;
}
@media (min-width: 48em) {
  .portfolio__cell {
    padding: 3rem;
  }
  .scroll-trigger .portfolio__cell::after {
    transform: scaleY(var(--scaleY));
  }
}
@media (max-width: 48em) {
  .portfolio__cell:not(:last-child)::after {
    display: none;
  }
  .portfolio__cell_info {
    order: -1;
  }
}
@media (min-width: 48em) {
  .portfolio__cell_large {
    grid-column: span 2;
  }
}
.portfolio__image-wrap {
  display: flex;
  height: 44rem;
}
@media (max-width: 48em) {
  .portfolio__image-wrap {
    height: 59.2rem;
  }
}
.portfolio__image {
  height: 100%;
  object-fit: cover;
}
.portfolio__info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (min-width: 48em) {
  .portfolio__info {
    height: 100%;
  }
}
.portfolio__heading {
  margin-bottom: 2.4rem;
}
.portfolio__text {
  margin-bottom: auto;
  color: #9a9a9a;
}
@media (max-width: 48em) {
  .portfolio__text {
    margin-bottom: 2.4rem;
  }
}
@media (max-width: 48em) {
  .portfolio__square {
    font-weight: 400;
  }
}
.portfolio__footer {
  position: relative;
  padding: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.portfolio__footer::after {
  bottom: 0;
  left: 0;
  width: calc(100% + 23.2rem);
  height: 2px;
}
@media (max-width: 48em) {
  .portfolio__footer {
    padding: 3.2rem 0;
  }
  .portfolio__footer::after {
    width: 100%;
  }
}
@media (min-width: 48em) {
  .scroll-trigger .portfolio__footer::after {
    transform: scaleX(var(--scaleX));
  }
}
.portfolio__page-control {
  display: flex;
  align-items: center;
  column-gap: 1.6rem;
}
.contacts {
  margin-bottom: 18rem;
}
.contacts__container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.contacts__container::before {
  top: 0;
  left: 0;
}
.scroll-trigger .contacts__container::before {
  transform: scaleY(var(--scaleY));
}
.contacts__container::after {
  top: 0;
  right: 0;
  height: calc(100% + 18rem);
}
.scroll-trigger .contacts__container::after {
  transform: scaleY(var(--scaleY));
}
@media (max-width: 48em) {
  .contacts__container {
    padding: 0;
  }
  .contacts__container::before, .contacts__container::after {
    display: none;
  }
}
@media (min-width: 48em) {
  .contacts__container {
    grid-column: 2/3;
  }
}
.contacts__content {
  padding-top: 13.6rem;
  display: grid;
}
.contacts__content::after {
  top: 0;
  left: 72.8rem;
}
.scroll-trigger .contacts__content::after {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .contacts__content {
    grid-template-columns: repeat(2, 72.8rem);
  }
}
@media (max-width: 48em) {
  .contacts__content {
    margin-bottom: 10rem;
  }
  .contacts__content::after {
    display: none;
  }
}
.contacts__column {
  display: flex;
  flex-direction: column;
}
.contacts__column_info {
  justify-content: flex-end;
}
@media (min-width: 48em) {
  .contacts__column:not(.contacts__column_info) {
    padding-bottom: 20.9rem;
    padding-left: 18rem;
    padding-right: 3rem;
  }
  .contacts__column_info {
    padding-bottom: 10rem;
    padding-left: 3rem;
  }
}
@media (max-width: 48em) {
  .contacts__column_info {
    padding: 3.2rem 3.2rem 0 3.2rem;
  }
}
.contacts__title {
  margin-bottom: 5.6rem;
}
.contacts__image-wrap {
  position: relative;
  z-index: 2;
  margin-bottom: 5.6rem;
  height: 30.8rem;
  width: 51rem;
}
.contacts__image-wrap_abs {
  position: absolute;
  top: 12rem;
  right: -23.2rem;
  width: 41.5rem;
  height: 58.5rem;
}
.contacts__image-wrap::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(70, 74, 80, 0.2);
}
@media (max-width: 48em) {
  .contacts__image-wrap {
    margin: 0;
    width: 100%;
    height: 75.4rem;
  }
  .contacts__image-wrap_abs {
    display: none;
  }
}
.contacts__image {
  height: 100%;
  object-fit: cover;
}
@media (min-width: 48em) {
  .contacts__image:not(.contacts__image-wrap_abs .contacts__image) {
    position: absolute;
    top: 0;
    left: 0;
    width: 63.3rem;
  }
}
.contacts__tel {
  margin-bottom: 3.4rem;
  font-weight: 400;
}
@media (max-width: 48em) {
  .contacts__tel {
    margin-bottom: 2.4rem;
    order: -1;
  }
}
.contacts__btn {
  min-width: 20.5rem;
  align-self: flex-start;
}
@media (max-width: 48em) {
  .contacts__btn {
    margin-bottom: 5rem;
    min-width: 32rem;
  }
}
.contacts__info {
  display: flex;
  flex-direction: column;
  row-gap: 2.4rem;
}
.contacts__group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 0.8rem;
}
.contacts__group-subtitle {
  color: #9a9a9a;
}
.contacts__group-text {
  max-width: 29.2rem;
}
@media (max-width: 48em) {
  .contacts__group-text {
    max-width: 53.2rem;
  }
}
.contacts__map {
  position: relative;
  z-index: 5;
  padding-left: 16.2rem;
  padding-right: 3rem;
  width: 100%;
  height: 69.5rem;
}
@media (max-width: 48em) {
  .contacts__map {
    padding: 0 3.2rem;
    height: 84.4rem;
    width: 100vw;
  }
}

.company-info {
  margin-bottom: 18rem;
}
.company-info__container {
  position: relative;
  display: grid;
}
@media (min-width: 48em) {
  .company-info__container {
    grid-column: 2/3;
  }
}
.info-company-info {
  position: relative;
  display: grid;
}
.info-company-info::before {
  top: -18rem;
  left: 0;
  height: calc(100% + 18rem);
}
.scroll-trigger .info-company-info::before {
  transform: scaleY(var(--scaleY));
}
.info-company-info::after {
  bottom: 0;
  left: 0;
  width: calc(100% + 23.2rem);
  height: 2px;
}
.scroll-trigger .info-company-info::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .info-company-info {
    grid-template-columns: 62.2rem 1fr;
  }
}
@media (max-width: 48em) {
  .info-company-info {
    margin-bottom: 17.6rem;
  }
  .info-company-info::before {
    display: none;
  }
  .info-company-info::after {
    width: 100%;
  }
}
.info-company-info__text-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
}
.info-company-info__text-wrap::before {
  top: -18rem;
  right: 0;
  height: calc(100% + 18rem);
}
.scroll-trigger .info-company-info__text-wrap::before {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .info-company-info__text-wrap {
    padding: 0 3rem 3rem 3rem;
  }
}
@media (max-width: 48em) {
  .info-company-info__text-wrap .info-company-info__text {
    padding: 3.2rem 0;
    margin-bottom: 3.2rem;
    padding-bottom: 3.2rem;
    border-bottom: 2px solid #505050;
  }
  .info-company-info__text-wrap::before {
    display: none;
  }
}
@media (min-width: 48em) {
  .info-company-info__heading {
    margin-bottom: auto;
  }
}
@media (max-width: 48em) {
  .info-company-info__heading {
    padding-bottom: 3.2rem;
    border-bottom: 2px solid #505050;
    font-weight: 500;
  }
}
.info-company-info__text {
  color: #9a9a9a;
}
@media (min-width: 48em) {
  .info-company-info__text {
    max-width: 54.5rem;
  }
}
.info-company-info__image-wrap {
  padding-left: 3rem;
  padding-bottom: 3rem;
  display: flex;
  justify-content: space-between;
  column-gap: 3rem;
}
.info-company-info__image-wrap .info-company-info__text {
  max-width: 23.5rem;
  text-transform: uppercase;
}
@media (max-width: 48em) {
  .info-company-info__image-wrap {
    padding: 0 0 3.2rem 0;
    flex-direction: column;
    border-bottom: 2px solid #505050;
  }
  .info-company-info__image-wrap .info-company-info__text {
    margin-bottom: 3.2rem;
    padding-right: 15rem;
    padding-bottom: 3.2rem;
    max-width: none;
    border-bottom: 2px solid #505050;
  }
}
.info-company-info__image {
  width: 54rem;
  min-height: 60rem;
}
.info-company-info__image img {
  height: 100%;
  object-fit: cover;
}
@media (max-width: 48em) {
  .info-company-info__image {
    width: 100%;
    height: 59.2rem;
  }
}

.numbers-company-info {
  position: relative;
  display: grid;
}
.numbers-company-info::before {
  top: -18rem;
  left: 0;
  height: calc(100% + 18rem);
}
.scroll-trigger .numbers-company-info::before {
  transform: scaleY(var(--scaleY));
}
.numbers-company-info::after {
  bottom: 0;
  left: 0;
  width: calc(100% + 23.2rem);
  height: 2px;
}
.scroll-trigger .numbers-company-info::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .numbers-company-info {
    padding: 18rem 0;
    grid-template-columns: 1fr 66.3rem 1fr;
  }
}
@media (max-width: 48em) {
  .numbers-company-info {
    margin-bottom: 18rem;
  }
  .numbers-company-info::before, .numbers-company-info::after {
    display: none;
  }
}
.numbers-company-info__row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.numbers-company-info__row_left {
  position: relative;
  padding-left: 3rem;
}
.numbers-company-info__row_left::after {
  top: -18rem;
  left: calc(62.2rem - 2px);
  height: calc(100% + 36rem);
}
.scroll-trigger .numbers-company-info__row_left::after {
  transform: scaleY(var(--scaleY));
}
.numbers-company-info__row_right {
  align-items: flex-end;
}
.numbers-company-info__row_right .numbers-company-info__group {
  align-items: flex-end;
  text-align: right;
}
@media (max-width: 48em) {
  .numbers-company-info__row {
    margin-bottom: 3.2rem;
    padding-bottom: 3.2rem;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 2px solid #505050;
  }
  .numbers-company-info__row::after {
    display: none;
  }
  .numbers-company-info__row_right {
    display: none;
  }
}
.numbers-company-info__group {
  display: flex;
  flex-direction: column;
}
.numbers-company-info__group_bottom {
  margin-top: auto;
}
.numbers-company-info__heading {
  font-family: Assistant;
  font-size: 5.4rem;
  font-weight: 600;
  text-transform: uppercase;
}
@media (max-width: 48em) {
  .numbers-company-info__heading {
    margin-bottom: 0.8rem;
    font-size: 4rem;
  }
}
.numbers-company-info__text {
  color: #9a9a9a;
}
.numbers-company-info__image-wrap {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 44rem;
}
@media (max-width: 48em) {
  .numbers-company-info__image-wrap {
    height: 45.6rem;
  }
}
.numbers-company-info__image {
  height: 100%;
  object-fit: cover;
}

.privileges-company-info {
  position: relative;
  display: grid;
}
.privileges-company-info::before {
  top: 0;
  left: 0;
}
.scroll-trigger .privileges-company-info::before {
  transform: scaleY(var(--scaleY));
}
.privileges-company-info::after {
  bottom: 0;
  left: 0;
  width: calc(100% + 23.2rem);
  height: 2px;
}
.scroll-trigger .privileges-company-info::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .privileges-company-info {
    grid-template-columns: 7fr 4fr;
  }
}
@media (max-width: 48em) {
  .privileges-company-info::before, .privileges-company-info::after {
    display: none;
  }
}
.privileges-company-info__column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}
.privileges-company-info__column:last-child {
  position: relative;
  padding-right: 0;
}
.privileges-company-info__column:last-child::before {
  top: 0;
  left: 0;
}
.scroll-trigger .privileges-company-info__column:last-child::before {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .privileges-company-info__column {
    padding: 3rem;
  }
}
@media (max-width: 48em) and (max-width: 48em) {
  .privileges-company-info__column:first-child .privileges-company-info__text {
    margin-bottom: 3.2rem;
    padding-bottom: 3.2rem;
    max-width: none;
    border-bottom: 2px solid #505050;
  }
}
@media (max-width: 48em) {
  .privileges-company-info__column:last-child::before {
    display: none;
  }
}
.privileges-company-info__heading {
  margin-bottom: 2.4rem;
  font-weight: 500;
  line-height: 130%;
  color: #9a9a9a;
}
@media (max-width: 48em) {
  .privileges-company-info__heading {
    margin-bottom: 1.6rem;
    font-size: 3.6rem;
  }
}
.privileges-company-info__text {
  margin-bottom: auto;
  max-width: 63.2rem;
  font-weight: 500;
  line-height: 130%;
}
.privileges-company-info__btn {
  min-width: 20.5rem;
}
.privileges-company-info__slider {
  margin-bottom: 3rem;
  width: 100%;
}
.privileges-company-info__slide {
  display: flex;
  flex-direction: column;
}
.privileges-company-info__ellipse {
  flex: 0 0 7.8rem;
  width: 7.8rem;
  height: 5.7rem;
}
@media (max-width: 48em) {
  .privileges-company-info__ellipse {
    flex: 0 0 10rem;
    width: 10rem;
    height: 8rem;
  }
}
.privileges-company-info__text-wrap {
  display: flex;
  flex-direction: column;
}
.privileges-company-info__text-wrap .privileges-company-info__heading {
  margin-bottom: 1.6rem;
  color: #ffffff;
}
.privileges-company-info__text-wrap .privileges-company-info__text {
  position: relative;
  padding-bottom: 3rem;
  color: #9a9a9a;
}
.privileges-company-info__text-wrap .privileges-company-info__text::after {
  bottom: 0;
  right: 0;
  width: 100%;
  height: 2px;
}
.scroll-trigger .privileges-company-info__text-wrap .privileges-company-info__text::after {
  transform: scaleX(var(--scaleX));
}
@media (min-width: 48em) {
  .privileges-company-info__text-wrap .privileges-company-info__text {
    max-width: 39.8rem;
  }
  .privileges-company-info__text-wrap .privileges-company-info__heading {
    margin-bottom: 0.8rem;
  }
}
@media (max-width: 48em) {
  .privileges-company-info__text-wrap .privileges-company-info__text::after {
    width: 100vw;
  }
}
.privileges-company-info__slide-content {
  display: flex;
  column-gap: 2.4rem;
}
@media (max-width: 48em) {
  .privileges-company-info__slide-content {
    padding-top: 3.2rem;
    column-gap: 4rem;
    border-top: 2px solid #505050;
  }
}
@media (max-width: 48em) {
  .privileges-company-info__slider-control {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
}
@media (min-width: 48em) {
  .privileges-company-info__slider-control {
    margin-left: auto;
  }
}
.privileges-company-info__slider-nav {
  display: flex;
  align-items: center;
  align-self: flex-end;
  column-gap: 1.6rem;
}
@media (max-width: 48em) {
  .privileges-company-info__image-wrap {
    margin-bottom: 3.2rem;
    height: 45.6rem;
    width: 100%;
  }
}
@media (max-width: 48em) {
  .privileges-company-info__image {
    height: 100%;
    object-fit: cover;
  }
}
.company-methods {
  margin-bottom: 18rem;
}
.company-methods__container {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
}
.company-methods__container::before {
  top: -18rem;
  height: calc(100% + 18rem);
}
.scroll-trigger .company-methods__container::before {
  transform: scaleY(var(--scaleY));
}
@media (min-width: 48em) {
  .company-methods__container {
    grid-column: 2/3;
  }
}
@media (max-width: 48em) {
  .company-methods__container::before {
    display: none;
  }
}
.company-methods__body {
  position: relative;
  padding: 3.2rem 0;
}
.company-methods__body::before, .company-methods__body::after {
  left: 0;
  width: calc(100% + 23.2rem);
  height: 2px;
}
.scroll-trigger .company-methods__body::before, .scroll-trigger .company-methods__body::after {
  transform: scaleX(var(--scaleX));
}
.company-methods__body::before {
  top: 0;
}
.company-methods__body::after {
  bottom: 0;
}
@media (min-width: 48em) {
  .company-methods__body {
    padding: 3.2rem 3rem 0 3rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 48em) {
  .company-methods__body::before, .company-methods__body::after {
    width: 100%;
  }
}
.company-methods__text-wrap {
  display: flex;
  flex-direction: column;
}
@media (min-width: 48em) {
  .company-methods__text-wrap {
    padding-bottom: 25.2rem;
  }
  .company-methods__text-wrap_lc {
    justify-self: end;
    text-align: right;
  }
}
@media (max-width: 48em) {
  .company-methods__text-wrap_fc {
    margin-bottom: 10rem;
    flex-direction: row;
    justify-content: space-between;
  }
  .company-methods__text-wrap_fc .company-methods__group {
    margin: 0;
  }
  .company-methods__text-wrap_fc .company-methods__group:last-child {
    text-align: right;
  }
}
.company-methods__group {
  margin-bottom: 33.5rem;
  display: flex;
  flex-direction: column;
}
.company-methods__subtitle {
  text-transform: uppercase;
}
.company-methods__subtext {
  color: #9a9a9a;
}
@media (max-width: 48em) {
  .company-methods__text {
    margin-bottom: 3.2rem;
    padding-top: 3.2rem;
    border-top: 2px solid #505050;
  }
}
.company-methods__image-wrap {
  width: 64.3rem;
}
@media (max-width: 48em) {
  .company-methods__image-wrap {
    margin-bottom: 8rem;
  }
}
@media (min-width: 48em) {
  .company-methods__image-wrap {
    padding-bottom: 3rem;
  }
}
.company-methods__bg-text {
  position: absolute;
  z-index: -1;
  top: 20rem;
  left: 3rem;
  font-size: 14.6rem;
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 170%;
  opacity: 0.1;
}
@media (max-width: 48em) {
  .company-methods__bg-text {
    top: 22rem;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 8rem;
    transform: translateX(-50%);
  }
  .company-methods__bg-text span {
    font-size: 21.8rem;
  }
}
@media (max-width: 48em) {
  .company-methods__link {
    transform: none;
  }
}

.hero-portfolio {
  position: relative;
  margin-bottom: 18rem;
}
.hero-portfolio__container {
  position: relative;
  min-width: 0;
}
.hero-portfolio__container::before {
  z-index: 2;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.2);
}
.scroll-trigger .hero-portfolio__container::before {
  transform: scaleY(var(--scaleY));
}
@media (max-width: 48em) {
  .hero-portfolio__container {
    padding: 0;
  }
  .hero-portfolio__container::before {
    display: none;
  }
}
@media (min-width: 48em) {
  .hero-portfolio__container {
    grid-column: 2/3;
  }
}
.hero-portfolio__carousel {
  position: relative;
}
@media (min-width: 48em) {
  .hero-portfolio__slider.swiper {
    overflow: visible;
  }
}
@media (max-width: 48em) {
  .hero-portfolio__slider {
    margin-bottom: 10rem;
  }
}
.hero-portfolio__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (min-width: 48em) {
  .hero-portfolio__content {
    position: absolute;
    top: 12rem;
    left: 3rem;
    width: calc(72.7% - 3rem);
    max-height: calc(100% - 12rem);
  }
}
@media (max-width: 48em) {
  .hero-portfolio__content {
    padding: 0 3.2rem;
  }
}
.hero-portfolio__group {
  margin-bottom: 12rem;
  display: flex;
  align-items: center;
  column-gap: 3rem;
}
.hero-portfolio__group::after {
  content: "";
  width: 90.4rem;
  height: 2px;
  background-color: rgba(255, 255, 255, 0.5);
}
@media (max-width: 48em) {
  .hero-portfolio__group {
    position: absolute;
    top: 77.2rem;
    left: 3.2rem;
    column-gap: 2rem;
  }
  .hero-portfolio__group::after {
    width: 19.4rem;
  }
}
.hero-portfolio__group-txt {
  white-space: nowrap;
}
.hero-portfolio__group-txt:first-child {
  order: -1;
}
.hero-portfolio__group-txt:last-child {
  order: 1;
}
@media (max-width: 48em) {
  .hero-portfolio__group-txt {
    font-size: 2.8rem;
  }
}
.hero-portfolio__text-wrap {
  display: flex;
  flex-direction: column;
}
@media (min-width: 48em) {
  .hero-portfolio__text-wrap {
    margin-bottom: 10.2rem;
  }
}
.hero-portfolio__title {
  margin-bottom: 3.2rem;
  display: flex;
  flex-direction: column;
}
@media (max-width: 48em) {
  .hero-portfolio__title {
    margin-bottom: 5rem;
    flex-direction: row;
    column-gap: 2rem;
  }
}
@media (min-width: 48em) {
  .hero-portfolio__text {
    max-width: 36.4rem;
    color: #b3b3b3;
  }
}
.hero-portfolio__slider-control {
  display: flex;
  flex-direction: column;
}
@media (max-width: 48em) {
  .hero-portfolio__slider-control {
    position: absolute;
    bottom: 0;
    right: 3.2rem;
    flex-direction: column-reverse;
  }
}
.hero-portfolio__slider-nav {
  display: flex;
  flex-direction: column;
  row-gap: 1.6rem;
}
@media (min-width: 48em) {
  .hero-portfolio__slider-nav {
    margin-bottom: 10.2rem;
  }
}
@media (max-width: 48em) {
  .hero-portfolio__slider-nav {
    flex-direction: column-reverse;
    align-items: flex-end;
  }
}
@media (max-width: 48em) {
  .hero-portfolio__slider-fraction {
    margin-bottom: 8rem;
    font-size: 3.6rem;
  }
}
.hero-portfolio__thumbs-carousel {
  position: absolute;
  z-index: 5;
  bottom: 10rem;
  right: 0;
  overflow: hidden;
}
.hero-portfolio__thumbs {
  width: 68.2rem;
  height: 23.3rem;
}
.hero-portfolio__thumbs.swiper {
  overflow: visible;
}
.hero-portfolio__thumb {
  width: 23.5rem;
  cursor: pointer;
}
.hero-portfolio__thumb-image-wrap {
  height: 100%;
}
.hero-portfolio__thumb-image {
  height: 100%;
  object-fit: cover;
}

.slide-hero-portfolio {
  display: grid;
  width: 100%;
}
@media (min-width: 48em) {
  .slide-hero-portfolio {
    grid-template-columns: 8fr 3fr;
    min-height: 100rem;
  }
}
.slide-hero-portfolio__image-wrap {
  position: relative;
}
.slide-hero-portfolio__image-wrap::after {
  content: "";
  position: absolute;
  top: 0;
  left: -46.4rem;
  height: 100%;
  width: calc(46.4rem + 100%);
  background: linear-gradient(70deg, rgba(46, 46, 46, 0.3) 20.45%, rgba(0, 0, 0, 0) 63.6%), linear-gradient(0deg, rgba(70, 74, 80, 0.2) 0%, rgba(70, 74, 80, 0.4) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.2) 100%);
}
@media (max-width: 48em) {
  .slide-hero-portfolio__image-wrap {
    margin-bottom: 3.2rem;
    height: 84rem;
  }
}
.slide-hero-portfolio__image {
  height: 100%;
  object-fit: cover;
}
@media (min-width: 48em) {
  .slide-hero-portfolio__image {
    position: absolute;
    top: 0;
    left: -46.4rem;
    width: calc(46.4rem + 100%);
  }
}
.slide-hero-portfolio__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (min-width: 48em) {
  .slide-hero-portfolio__content {
    padding-top: 26.3rem;
    padding-bottom: 43.3rem;
    padding-left: 14.9rem;
    width: calc(100% + 192rem - 145.6rem);
  }
}
@media (max-width: 48em) {
  .slide-hero-portfolio__content {
    padding-left: 3.2rem;
    max-width: 58rem;
  }
}
.slide-hero-portfolio__title-wrap {
  margin-bottom: 3.2rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.8rem;
}
@media (max-width: 48em) {
  .slide-hero-portfolio__title-wrap {
    margin-bottom: 2.4rem;
    flex-direction: column-reverse;
  }
}
.slide-hero-portfolio__subtitle {
  color: #b2b2b2;
}
.slide-hero-portfolio__text {
  margin-bottom: 3.2rem;
}
@media (max-width: 48em) {
  .slide-hero-portfolio__text {
    margin-bottom: 2.4rem;
  }
}
.slide-hero-portfolio__square {
  margin-bottom: 4.8rem;
  display: flex;
  flex-direction: column;
  row-gap: 4.8rem;
}
.slide-hero-portfolio__square::after {
  content: "";
  width: 4rem;
  height: 2px;
  background-color: #ffffff;
}
@media (max-width: 48em) {
  .slide-hero-portfolio__square {
    margin-bottom: 4rem;
    row-gap: 4rem;
  }
  .slide-hero-portfolio__square::after {
    width: 8rem;
  }
}
.slide-hero-portfolio__link {
  transform: none;
}

.lock body {
  overflow: hidden;
  touch-action: none;
}
.wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 192rem;
  margin: 0 auto;
  overflow: hidden;
}
.wrapper::before {
  z-index: 5;
  left: 0;
  top: 0;
}
.wrapper::after {
  z-index: 5;
  right: 0;
  top: 0;
}
@media (max-width: 120em) {
  .wrapper::before, .wrapper::after {
    display: none;
  }
}
@media (max-width: 48em) {
  .wrapper {
    width: 100%;
  }
}
.wrapper > main {
  flex: 1 1 auto;
}
.wrapper > * {
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/scss/fonts.scss","webpack://./src/index.scss","webpack://./src/scss/style.scss","webpack://./src/scss/base/set.scss","webpack://./src/scss/base/forms/forms.scss","webpack://./src/scss/base/forms/button.scss","webpack://./src/scss/base/forms/input.scss","webpack://./src/scss/base/forms/checkbox.scss","webpack://./src/scss/base/popup.scss","webpack://./src/scss/base/maps.scss","webpack://./src/scss/base.scss","webpack://./src/scss/common.scss","webpack://./src/scss/components/_footer.scss","webpack://./src/scss/sections/hero.scss","webpack://./src/scss/sections/about-company.scss","webpack://./src/scss/sections/services.scss","webpack://./src/scss/sections/privileges.scss","webpack://./src/scss/sections/team.scss","webpack://./src/scss/sections/request.scss","webpack://./src/scss/sections/our-team.scss","webpack://./src/scss/sections/projects.scss","webpack://./src/scss/sections/image-text.scss","webpack://./src/scss/sections/hero-project.scss","webpack://./src/scss/sections/project-info.scss","webpack://./src/scss/sections/project-layout.scss","webpack://./src/scss/sections/project-interiors.scss","webpack://./src/scss/sections/portfolio.scss","webpack://./src/scss/sections/contacts.scss","webpack://./src/scss/sections/company-info.scss","webpack://./src/scss/sections/company-methods.scss","webpack://./src/scss/sections/hero-portfolio.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACGF;ADDA;EACE,mBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACGF;ADDA;EACE,mBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACGF;ACJA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;ADMF;;AE9BA;;;EAGE,sBAAA;AFiCF;;AE/BA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AFkCF;;AE/BA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,cDTM;ECUN,yBDZG;AD8CL;;AE/BA;;EAEE,qCAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;AFkCF;;AEhCA;EACE,YAAA;AFmCF;;AEjCA;;EAEE,6BAAA;EAAA,qBAAA;AFoCF;;AEjCA;;;;EAIE,aAAA;EACA,eAAA;EACA,aAAA;AFoCF;AEnCE;;;;EACE,aAAA;AFwCJ;AEtCE;;;;EACE,aAAA;AF2CJ;;AEvCA;;;;;;EAME,aAAA;EACA,SAAA;EACA,UAAA;AF0CF;;AExCA;EACE,aAAA;EACA,gBAAA;AF2CF;;AExCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AF2CF;;AExCA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;AF2CF;;AEzCA;EACE,UAAA;EACA,SAAA;AF4CF;;AEzCA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AF4CF;;AEzCA;EACE,eAAA;EACA,cAAA;AF4CF;;AEzCA;;EAEE,wBAAA;EACA,SAAA;AF4CF;;AEzCA;EACE,0BAAA;AF4CF;;AEzCA;EACE;IACE,eAAA;EF4CF;AACF;AEzCA;EACE;IACE,cAAA;IACA,mBAAA;IACA,yBAAA;IACA,8BAAA;EF2CF;EExCA;IACE,8BAAA;EF0CF;EEvCA;IACE,eAAA;IACA,WAAA;EFyCF;AACF;AGvKE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;AHyKJ;AGxKI;EARF;IASI,iBAAA;EH2KJ;AACF;;AIhMA;EACE,oBAAA;EACA,mBAAA;AJmMF;AI/LE;EACE,kBAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBHFI;EGGJ,gBAAA;AJiMJ;AIhMI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,yBHRE;EGSF,yBAAA;AJkMN;AIhMI;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;AJkMN;AIhMI;EACE,4BAAA;AJkMN;AIhMI;EAEI;IACE,UAAA;IACA,oBAAA;EJiMR;EI/LM;IACE,eH3BF;ED4NN;EI/LM;IACE,cH9BF;ED+NN;AACF;AI9LI;EA3CF;IA4CI,kCAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,oBAAA;EJiMJ;EIhMI;IACE,aAAA;IACA,cAAA;EJkMN;AACF;AI5LE;EACE,6BAAA;AJ8LJ;AI7LI;EACE,cHpDE;ADmPR;AI7LI;EACE,aAAA;EACA,cAAA;EACA,6BAAA;EACA,+BAAA;AJ+LN;AI5LM;EACE,6BAAA;AJ8LR;AI3LI;EACE;IACE,WAAA;IACA,YAAA;EJ6LN;AACF;AIvLE;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,cHlFI;EGmFJ,mBAAA;EACA,2BAAA;AJyLJ;AIxLI;EAPF;IAQI,mBAAA;EJ2LJ;EI1LI;IACE,iBAAA;EJ4LN;AACF;;AKjSA;;;;EAIE,wBAAA;EAEA,gBAAA;ALoSF;;AKlSA;;EAEE,aAAA;ALqSF;;AKlSA;EACE,kBAAA;ALqSF;AKpSE;EAEE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,iDAAA;EACA,iBAAA;EACA,yBAAA;ALqSJ;AKpSI;EACE,+BAAA;ALsSN;AKpSI;EACE,gCAAA;ALsSN;AKpSI;EACE,cAAA;EACA,gCAAA;ALsSN;AKrSM;EACE,cAAA;ALuSR;AKpSI;EACE,cJvBE;EIwBF,gCAAA;ALsSN;AKpSI;EA1BF;IA2BI,iBAAA;ELuSJ;AACF;;AKpSA;EACE,UAAA;EACA,YAAA;ALuSF;;AMvVA;EACE,kBAAA;AN0VF;AMxVI;EACE,cAAA;AN0VN;AMrVE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ANuVJ;AMtVI;EACE,yBAAA;ANwVN;AMpVI;EACE,yDAAA;EACA,2BAAA;EACA,uBAAA;EACA,4BAAA;ANsVN;AMrVM;EALF;IAMI,qBAAA;ENwVN;AACF;AMpVE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;ANsVJ;AMrVI;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;ANuVN;AMrVI;EAdF;IAeI,kBAAA;ENwVJ;EMvVI;IACE,gBAAA;IACA,aAAA;IACA,cAAA;ENyVN;AACF;AMrVE;EACE,2BAAA;ANuVJ;AMtVI;EACE,iBAAA;ANwVN;AMvVM;EAFF;IAGI,iBAAA;EN0VN;AACF;;AOtZA;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBNGM;EMFN,oBAAA;EACA,gCAAA;APyZF;AOxZE;EAZF;IAaI,oCAAA;IACA,qCAAA;YAAA,6BAAA;EP2ZF;AACF;;AOzZA;EACE,UAAA;AP4ZF;;AO1ZA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;AP6ZF;AO5ZE;EACE,cAAA;AP8ZJ;AO3ZI;EADF;IAEI,UAAA;EP8ZJ;AACF;;AO3ZA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AP8ZF;;AO5ZA;EACE,mBAAA;EACA,mBAAA;AP+ZF;;AO7ZA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;APgaF;;AO9ZA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;APiaF;AOhaE;EACE,mBAAA;APkaJ;AOhaE;EACE,UAAA;EACA,aAAA;APkaJ;AOjaI;EAHF;IAII,kCAAA;EPoaJ;AACF;;AO7ZE;EACE;IACE,wBAAA;EPgaJ;EO9ZE;IACE,cAAA;EPgaJ;AACF;AO1ZI;EADF;IAEI,qBAAA;IACA,WAAA;IACA,aAAA;EP6ZJ;AACF;AOxZE;EACE,YAAA;EACA,iBAAA;AP0ZJ;AOrZE;EACE,kCAAA;EACA,aAAA;EACA,sBAAA;APuZJ;AOtZI;EAJF;IAKI,yBAAA;EPyZJ;EOxZI;IACE,mBAAA;IACA,kBAAA;EP0ZN;AACF;AOxZI;EACE;IACE,mCAAA;EP0ZN;AACF;AOpZE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;APsZJ;AOrZI;EALF;IAMI,oBAAA;IACA,WAAA;IACA,YAAA;IACA,8BAAA;EPwZJ;AACF;AOvZI;EACE;IACE,sBAAA;EPyZN;AACF;AOnZE;EACE,qBAAA;APqZJ;AOpZI;EAFF;IAGI,iBAAA;EPuZJ;AACF;AOtZI;EACE;IACE,kBAAA;EPwZN;AACF;AOlZE;EACE,mBAAA;APoZJ;AOnZI;EACE,qBAAA;APqZN;AOnZI;EALF;IAMI,mBAAA;IACA,iBAAA;IACA,kBAAA;EPsZJ;AACF;AOjZE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;APmZJ;AOlZI;EAJF;IAKI,iBAAA;EPqZJ;AACF;AOhZE;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;APkZJ;AOjZI;EANF;IAOI,mBAAA;IACA,aAAA;IACA,WAAA;EPoZJ;AACF;AOzYI;EADF;IAEI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,gBAAA;EP4YJ;AACF;AOtYI;EADF;IAEI,qBAAA;EPyYJ;AACF;AOpYE;EACE,kBAAA;APsYJ;AOrYI;EAFF;IAGI,kBAAA;EPwYJ;AACF;AOvYI;EALF;IAMI,sBAAA;EP0YJ;AACF;;AQrnBA;EACE,oBAAA;EACA,wBAAA;EACA,4BAAA;EACA,yBAAA;EACA,uBAAA;ARwnBF;;AQrnBA;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,6CAAA;EACA,eAAA;ARwnBF;AQvnBE;EANF;IAOI,YAAA;ER0nBF;AACF;;ASlnBA;EACE,kBAAA;ATqnBF;ASpnBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,iBAAA;ATsnBJ;;ASlnBE;EACE,mBAAA;ATqnBJ;;ASthBA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;ATyhBF;;ASrhBE;EACE,qBAAA;EACA,6BAAA;ATwhBJ;ASthBE;EACE,qBAAA;EACA,8BAAA;ATwhBJ;;AU5qBA;EACE,kBAAA;AV+qBF;AU9qBE;EACE,WAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AVgrBJ;AU9qBE;EAEI;IACE,UAAA;IACA,mBAAA;EV+qBN;AACF;;AUxqBA;EACE,kBAAA;AV2qBF;AU1qBE;EACE;IACE,WAAA;IACA,eAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,2CAAA;IACA,qCAAA;YAAA,6BAAA;IACA,+BAAA;EV4qBJ;EU3qBI;IACE,4BAAA;EV6qBN;EU3qBI;IACE,wBAAA;EV6qBN;EU3qBI;IACE,4BAAA;EV6qBN;AACF;;AUvqBA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;EACA,YAAA;EACA,0CAAA;EACA,qCAAA;UAAA,6BAAA;AV0qBF;AUzqBE;EATF;IAUI,eAAA;IACA,OAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,6BAAA;IACA,gCAAA;YAAA,wBAAA;IACA,yBAAA;EV4qBF;EU3qBE;IACE,4BAAA;EV6qBJ;EU3qBE;IACE,wBAAA;EV6qBJ;AACF;AUzqBE;EA3BF;IA4BI,eAAA;IACA,YAAA;IACA,2BAAA;EV4qBF;EU3qBE;IACE,cAAA;EV6qBJ;AACF;AUxqBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AV0qBJ;AUzqBI;EALF;IAMI,sBAAA;EV4qBJ;AACF;AU3qBI;EARF;IASI,iBAAA;EV8qBJ;AACF;AUzqBE;EACE,cAAA;AV2qBJ;AU1qBI;EAFF;IAGI,kBAAA;IACA,YAAA;IACA,cAAA;EV6qBJ;AACF;AU5qBI;EAPF;IAQI,qBAAA;EV+qBJ;AACF;AU1qBE;EACE,mBAAA;AV4qBJ;AUnqBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AVqqBJ;AUpqBI;EALF;IAMI,mBAAA;IACA,mBAAA;IACA,gBAAA;EVuqBJ;AACF;AUjqBI;EACE;IACE,aAAA;EVmqBN;AACF;AU7pBE;EACE,qBAAA;EACA,aAAA;AV+pBJ;AU9pBI;EAHF;IAII,WAAA;EViqBJ;AACF;AU5pBE;EACE,mBAAA;AV8pBJ;AUzpBE;EACE,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AV2pBJ;AU1pBI;EACE,UAAA;EACA,mBAAA;AV4pBN;AU1pBI;EAVF;IAWI,mBAAA;EV6pBJ;EU5pBI;IACE,eAAA;IACA,gBAAA;EV8pBN;AACF;;AUxpBA;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AV2pBF;AU1pBE;EAEE,WAAA;AV2pBJ;AUzpBE;;EAGE,WAAA;EACA,cAAA;EACA,yBTlMI;AD41BR;AUxpBE;EACE,sBAAA;EACA,+BAAA;AV0pBJ;AUxpBE;EArBF;IAsBI,eAAA;IACA,aAAA;EV2pBF;EU1pBE;;IAGE,cAAA;IACA,yBAAA;EV2pBJ;EUzpBE;IACE,kBAAA;EV2pBJ;EU1pBI;;IAGE,UAAA;IACA,kBAAA;EV2pBN;AACF;AUxpBE;EAxCF;IAyCI,yBAAA;EV2pBF;EU1pBE;IACE,UAAA;IACA,kBAAA;EV4pBJ;AACF;;AUvpBA;EACE,kBAAA;AV0pBF;AUzpBE;EAFF;IAGI,aAAA;IACA,mBAAA;IACA,cAAA;EV4pBF;AACF;AUvpBI;EAGM;IACE,uBAAA;EVupBV;AACF;AUnpBI;EAVF;IAWI,kBAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;EVspBJ;EUrpBI;IACE,WAAA;IACA,kBAAA;IACA,aAAA;IACA,cAAA;IACA,yDAAA;IACA,wBAAA;IACA,2BAAA;IACA,4BAAA;IACA,UAAA;IACA,kBAAA;IACA,yBAAA;EVupBN;EUppBM;IACE,gBAAA;IACA,UAAA;IACA,mBAAA;EVspBR;AACF;AUnpBI;EApCF;IAqCI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;IACA,gCAAA;EVspBJ;EUrpBI;IACE,UAAA;IACA,kBAAA;EVupBN;AACF;AU5oBE;EACE,yBAAA;EACA,cT5SI;AD07BR;AUzoBE;EACE,UAAA;EACA,kBAAA;AV2oBJ;AUzoBI;EAJF;IAKI,eAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,kBAAA;IACA,qBAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,aAAA;IACA,cAAA;EV4oBJ;AACF;AU3oBI;EACE,UAAA;EACA,mBAAA;AV6oBN;AUvoBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AVyoBJ;AUxoBI;EANF;IAOI,sBAAA;IACA,eAAA;EV2oBJ;AACF;AUjoBE;EACE,kBAAA;EACA,yBAAA;AVmoBJ;AUloBI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBTvWE;ESwWF,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,yBAAA;AVooBN;AUloBI;EAEI;IACE,UAAA;IACA,oBAAA;EVmoBR;AACF;AUhoBI;EAxBF;IAyBI,eAAA;EVmoBJ;AACF;;AU9nBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AVioBF;AUhoBE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;AVkoBJ;AUjoBI;EACE,4BAAA;AVmoBN;AUhoBE;EAEI;IACE,aT5YA;ED6gCN;EUhoBM;IACE,eTjZF;EDmhCN;AACF;AU9nBE;EAvBF;IAwBI,cAAA;IACA,WAAA;IACA,YAAA;EVioBF;EUhoBE;IACE,WAAA;IACA,YAAA;EVkoBJ;AACF;;AU7nBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AVgoBF;AU5nBE;EACE,aAAA;AV8nBJ;AU7nBI;EAFF;IAGI,kBAAA;IACA,cAAA;IACA,iBAAA;IACA,cAAA;IACA,WAAA;IACA,0CAAA;EVgoBJ;EU/nBI;IACE,WAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,MAAA;IACA,OAAA;IACA,yBTtbA;ISubA,sBAAA;IACA,kCAAA;EVioBN;AACF;AU3nBE;EACE,mBAAA;AV6nBJ;;AUxnBA;EACE,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;AV2nBF;AUznBI;EACE,0CAAA;AV2nBN;AU1nBM;EACE,UAAA;AV4nBR;AUxnBE;EAdF;IAeI,8CAAA;IACA,iDAAA;IACA,gDAAA;EV2nBF;EU1nBE;IACE,+CAAA;EV4nBJ;AACF;AUvnBE;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AVynBJ;AUxnBI;EAEE,MAAA;EACA,QAAA;EACA,YAAA;EACA,6BAAA;AVynBN;AUvnBI;EAdF;IAeI,oBAAA;EV0nBJ;EUznBI;IACE,aAAA;EV2nBN;EUznBI;IACE,iBAAA;EV2nBN;AACF;;AUrnBA;EACE,kBAAA;AVwnBF;AUvnBE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mFAAA;EAKA,uBAAA;EACA,mBAAA;AVqnBJ;;AU/mBE;EAGE,OAAA;EACA,WAAA;EACA,WAAA;AVgnBJ;AU9mBE;EACE,MAAA;AVgnBJ;AU9mBE;EACE,SAAA;AVgnBJ;AU9mBE;EAdF;IAeI,kBAAA;IACA,iBAAA;EVinBF;AACF;;AU7mBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AVgnBF;AU3mBI;EACE,oBAAA;AV6mBN;AU5mBM;EACE,mBAAA;AV8mBR;AU3mBI;EACE,cAAA;AV6mBN;AU3mBI;EACE;IACE,kBAAA;EV6mBN;EU5mBM;IACE,kBAAA;EV8mBR;AACF;;AUrmBA;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AVwmBF;AUvmBE;EANF;IAOI,eAAA;EV0mBF;AACF;;AUtmBA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;AVymBF;AUxmBE;EANF;IAOI,iBAAA;EV2mBF;AACF;;AUvmBA;EACE,iBAAA;EACA,gBAAA;AV0mBF;AUzmBE;EAHF;IAII,eAAA;EV4mBF;AACF;;AUxmBA;EACE,gBAAA;AV2mBF;;AUvmBA;EACE,mBAAA;EACA,iBAAA;AV0mBF;AUzmBE;EAHF;IAII,iBAAA;EV4mBF;AACF;AUxmBE;EACE,iBAAA;AV0mBJ;AUzmBI;EAFF;IAGI,iBAAA;EV4mBJ;AACF;AUvmBE;EACE,iBAAA;AVymBJ;AUxmBI;EAFF;IAGI,iBAAA;EV2mBJ;AACF;;AUrmBA;EACE,aAAA;AVwmBF;AUvmBE;EAFF;IAGI,gCAAA;EV0mBF;AACF;;AUtmBE;EADF;IAEI,aAAA;EV0mBF;AACF;;AUtmBE;EADF;IAEI,aAAA;EV0mBF;AACF;;AW7wCA;EACE,kBAAA;EACA,qBAAA;AXgxCF;AW/wCE;EAEE,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AXgxCJ;AW/wCI;EACE,gCAAA;AXixCN;AW9wCE;EAbF;IAcI,SAAA;IACA,iBAAA;EXixCF;EWhxCE;IACE,aAAA;EXkxCJ;AACF;AW7wCE;EACE,2BAAA;EACA,aAAA;EACA,sBAAA;AX+wCJ;AW9wCI;EAEE,OAAA;EACA,WAAA;EACA,mCAAA;AX+wCN;AW9wCM;EACE,gCAAA;AXgxCR;AW7wCI;EAbF;IAcI,kBAAA;IACA,gBAAA;IACA,eAAA;EXgxCJ;AACF;AW/wCI;EAlBF;IAmBI,wBAAA;IACA,8CAAA;EXkxCJ;EWjxCI;IACE,aAAA;EXmxCN;AACF;AW7wCE;EACE,aAAA;EACA,8BAAA;AX+wCJ;AW1wCM;EADF;IAEI,qBAAA;EX6wCN;AACF;AWvwCM;EADF;IAEI,mBAAA;IACA,sBAAA;EX0wCN;AACF;AWpwCE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AXswCJ;AWrwCI;EAJF;IAKI,uBAAA;IACA,eAAA;EXwwCJ;AACF;AWnwCE;EACE,sBAAA;AXqwCJ;AWpwCI;EAFF;IAGI,cAAA;EXuwCJ;AACF;AWlwCE;EACE,iBAAA;EACA,cAAA;AXowCJ;AWnwCI;EAHF;IAII,iBAAA;EXswCJ;AACF;AWjwCE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AXmwCJ;AWlwCI;EALF;IAMI,gBAAA;EXqwCJ;AACF;AW3vCE;EACE,qBAAA;EACA,WAAA;AX6vCJ;AW5vCI;EAHF;IAII,WAAA;EX+vCJ;AACF;AW1vCE;EACE,mBAAA;AX4vCJ;AWvvCE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AXyvCJ;AWxvCI;EAJF;IAKI,mBAAA;IACA,eAAA;EX2vCJ;AACF;AWjvCE;EACE,cAAA;AXmvCJ;AW7uCI;EADF;IAEI,oBAAA;EXgvCJ;AACF;AW3uCE;EACE,aAAA;EACA,kBAAA;AX6uCJ;AW5uCI;EAHF;IAII,aAAA;IACA,qCAAA;IACA,gBAAA;IACA,aAAA;EX+uCJ;AACF;AWruCE;EAEE,iBAAA;AXsuCJ;AWruCI;EAHF;IAII,iBAAA;EXwuCJ;AACF;;AY16CA;EACE,kBAAA;EACA,oBAAA;AZ66CF;AY56CE;EACE;IACE,oBAAA;EZ86CJ;AACF;AYz6CE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;AZ26CJ;AY16CI;EAEE,MAAA;EACA,OAAA;EACA,0CAAA;AZ26CN;AY16CM;EACE,gCAAA;AZ46CR;AYx6CM;EACE,aAAA;AZ06CR;AYv6CI;EAnBF;IAoBI,qCAAA;IACA,gBAAA;EZ06CJ;EYz6CI;IACE,gCAAA;IACA,eAAA;EZ26CN;EYz6CI;IACE,UAAA;IACA,eAAA;IACA,YAAA;EZ26CN;EY16CM;IACE,aAAA;EZ46CR;AACF;AYz6CI;EAnCF;IAoCI,8BAAA;EZ46CJ;EY36CI;IACE,kCAAA;EZ66CN;AACF;AYj6CI;EADF;IAEI,gBAAA;IACA,kBAAA;EZo6CJ;AACF;AY/5CE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;AZi6CJ;AYh6CI;EACE,oBAAA;EACA,2BAAA;AZk6CN;AYh6CI;EAGE,MAAA;EACA,0CAAA;AZg6CN;AY/5CM;EACE,gCAAA;AZi6CR;AY95CI;EACE,OAAA;AZg6CN;AY95CI;EACE,cAAA;AZg6CN;AY/5CM;EACE,QAAA;AZi6CR;AY95CI;EA7BF;IA8BI,2BAAA;EZi6CJ;AACF;AYh6CI;EACE;IACE,oBAAA;IACA,2BAAA;IACA,YAAA;EZk6CN;EYh6CI;IACE,iBAAA;EZk6CN;EYh6CI;IAEE,aAAA;EZi6CN;AACF;AY35CE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;AZ65CJ;AY55CI;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AZ85CN;AY75CM;EAEE,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,0CAAA;AZ85CR;AY75CQ;EACE,gCAAA;AZ+5CV;AY35CI;EArBF;IAsBI,qBAAA;EZ85CJ;EY75CI;IACE,mBAAA;IACA,gBAAA;EZ+5CN;EY95CM;IACE,aAAA;EZg6CR;AACF;AYp5CE;EACE,qBAAA;AZs5CJ;AYr5CI;EACE,kBAAA;AZu5CN;AYr5CI;EALF;IAMI,qBAAA;IACA,kBAAA;EZw5CJ;EYv5CI;IACE,oBAAA;IACA,kBAAA;EZy5CN;AACF;AYn5CE;EACE,sBAAA;AZq5CJ;AY/4CI;EADF;IAEI,SAAA;EZk5CJ;AACF;AYj5CI;EAJF;IAKI,iBAAA;EZo5CJ;AACF;AY/4CE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AZi5CJ;AYh5CI;EACE,iBAAA;AZk5CN;AY54CE;EACE,kBAAA;AZ84CJ;AY74CI;EACE,aAAA;AZ+4CN;AY74CI;EACE,qBAAA;EACA,6BAAA;AZ+4CN;AY74CI;EACE,qBAAA;EACA,8BAAA;AZ+4CN;AY74CI;EAbF;IAcI,yBAAA;EZg5CJ;EY/4CI;IACE,kBAAA;IACA,UAAA;IACA,oBAAA;IACA,2BAAA;IACA,YAAA;EZi5CN;AACF;AY34CE;EAEE,WAAA;EACA,MAAA;EACA,aAAA;EACA,YAAA;AZ44CJ;AY34CI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qKAAA;AZ64CN;AYl4CI;EAxBF;IAyBI,OAAA;EZq4CJ;AACF;AYl4CE;EACE,kBAAA;EACA,OAAA;AZo4CJ;AYn4CI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AZq4CN;AY/3CE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;AZi4CJ;AYh4CI;EACE,OAAA;AZk4CN;AYj4CM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,4OAAA;AZm4CR;AYt3CI;EACE,aAAA;EACA,WAAA;AZw3CN;AYt3CI;EA9BF;IA+BI,aAAA;IACA,aAAA;IACA,0BAAA;IACA,4BAAA;EZy3CJ;EYx3CI;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;IACA,WAAA;IACA,MAAA;IACA,OAAA;IACA,eAAA;EZ03CN;AACF;AYp3CE;EACE,iBAAA;AZs3CJ;AYj3CE;EACE,UAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;AZm3CJ;AYl3CI;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;AZo3CN;AYl3CI;EAbF;IAcI,oBAAA;EZq3CJ;AACF;AYp3CI;EAhBF;IAiBI,gBAAA;IACA,UAAA;IACA,cAAA;IACA,QAAA;IACA,SAAA;EZu3CJ;EYt3CI;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,SAAA;IACA,kBAAA;EZw3CN;AACF;AYl3CE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AZo3CJ;AY92CI;EACE,cAAA;AZg3CN;AY12CE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AZ42CJ;AY32CI;EAJF;IAKI,oBAAA;EZ82CJ;AACF;AY72CI;EAPF;IAQI,kBAAA;IACA,YAAA;IACA,aAAA;IACA,cAAA;IACA,2BAAA;IACA,8BAAA;IACA,kBAAA;EZg3CJ;AACF;AY12CI;EADF;IAEI,kBAAA;IACA,aAAA;IACA,aAAA;EZ62CJ;AACF;AYx2CE;EACE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AZ02CJ;AYz2CI;EATF;IAUI,sBAAA;EZ42CJ;AACF;AYv2CE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;AZy2CJ;AYx2CI;EARF;IASI,aAAA;IACA,cAAA;IACA,eAAA;EZ22CJ;AACF;AYt2CE;EACE,qBAAA;EACA,kBAAA;AZw2CJ;AYv2CI;EAEE,eAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AZw2CN;AYt2CI;EAXF;IAYI,kBAAA;IACA,qBAAA;IACA,kBAAA;EZy2CJ;EYx2CI;IACE,qBAAA;EZ02CN;AACF;;AYn2CA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AZs2CF;AYr2CE;EAPF;IAQI,eAAA;EZw2CF;AACF;AYp2CE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AZs2CJ;AYj2CE;EACE,sBAAA;AZm2CJ;AYl2CI;EAFF;IAGI,eAAA;EZq2CJ;AACF;AYh2CE;EACE,uBAAA;EACA,cAAA;AZk2CJ;AYj2CI;EAHF;IAII,+BAAA;EZo2CJ;AACF;;Aah2DA;EACE,oBAAA;Abm2DF;Aa/1DE;EACE,kBAAA;EACA,aAAA;Abi2DJ;Aah2DI;EAEE,SAAA;EACA,aAAA;EACA,WAAA;Abi2DN;Aah2DM;EACE,gCAAA;Abk2DR;Aa/1DI;EAZF;IAaI,iBAAA;Ebk2DJ;Eaj2DI;IACE,aAAA;Ebm2DN;AACF;Aaj2DI;EAlBF;IAmBI,8BAAA;IACA,gBAAA;Ebo2DJ;AACF;Aa/1DE;EACE,kBAAA;EACA,aAAA;Abi2DJ;Aah2DI;EAGE,WAAA;EACA,gCAAA;Abg2DN;Aa/1DM;EACE,gCAAA;Abi2DR;Aa91DI;EACE,OAAA;Abg2DN;Aa91DI;EACE,cAAA;Abg2DN;Aa91DI;EACE;IAEE,aAAA;Eb+1DN;AACF;Aaz1DE;EACE,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,qBAAA;Ab21DJ;Aa11DI;EAEE,SAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;Ab21DN;Aa11DM;EACE,gCAAA;Ab41DR;Aaz1DI;EAfF;IAgBI,qBAAA;IACA,iDAAA;Eb41DJ;Ea31DI;IACE,aAAA;Eb61DN;AACF;Aa70DE;EACE,aAAA;Ab+0DJ;Aa90DI;EAFF;IAGI,8BAAA;IACA,mBAAA;Ebi1DJ;AACF;Aah1DI;EANF;IAOI,qBAAA;Ebm1DJ;AACF;Aa90DE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;Abg1DJ;Aa90DM;EAEE,QAAA;EACA,MAAA;Ab+0DR;Aa90DQ;EACE,gCAAA;Abg1DV;Aa50DI;EAdF;IAeI,kBAAA;IACA,kBAAA;Eb+0DJ;AACF;Aa90DI;EAlBF;IAmBI,iBAAA;IACA,aAAA;IACA,iDAAA;Ebi1DJ;Ea/0DM;IACE,aAAA;Ebi1DR;AACF;Aa10DE;EACE,aAAA;Ab40DJ;Aal0DE;EACE,sBAAA;Abo0DJ;Aan0DI;EAFF;IAGI,gBAAA;IACA,kBAAA;Ebs0DJ;AACF;Aaj0DE;EACE,WAAA;EACA,eAAA;Abm0DJ;Aal0DI;EAHF;IAII,2BAAA;IACA,eAAA;IACA,eAAA;IACA,mCAAA;IACA,mCAAA;Ebq0DJ;AACF;Aah0DE;EACE,YAAA;EACA,iBAAA;Abk0DJ;;Acn/DA;EACE,oBAAA;Ads/DF;Acr/DE;EACE,OAAA;EACA,OAAA;EACA,OAAA;Adu/DJ;Acl/DE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;Ado/DJ;Acn/DI;EAEE,SAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;Ado/DN;Acn/DM;EACE,gCAAA;Adq/DR;Acl/DI;EAdF;IAeI,gBAAA;Edq/DJ;AACF;Acp/DI;EAjBF;IAkBI,iBAAA;Edu/DJ;Ect/DI;IACE,aAAA;Edw/DN;AACF;Acl/DE;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;Ado/DJ;Acn/DI;EARF;IASI,qBAAA;IACA,UAAA;Eds/DJ;AACF;Ac5+DE;EACE,kBAAA;Ad8+DJ;Ac7+DI;EAFF;IAGI,aAAA;Edg/DJ;AACF;Ac3+DE;EACE,aAAA;EACA,sBAAA;Ad6+DJ;Ac5+DI;EAHF;IAII,eAAA;Ed++DJ;AACF;Acp+DA;EACE,kBAAA;EACA,aAAA;Ads+DF;Acr+DE;EAEE,MAAA;EACA,OAAA;Ads+DJ;Acr+DI;EACE,gCAAA;Adu+DN;Acp+DE;EAEE,MAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;Adq+DJ;Acp+DI;EACE,gCAAA;Ads+DN;Acl+DI;EACE,aAAA;EACA,4BAAA;Ado+DN;Acn+DM;EACE,gCAAA;Adq+DR;Ach+DI;EACE,0BAAA;Adk+DN;Ac99DE;EApCF;IAqCI,kCAAA;Edi+DF;Ech+DE;IACE,kCAAA;Edk+DJ;Ecj+DI;IACE,iBAAA;IACA,gBAAA;Edm+DN;Ecj+DI;IACE,qBAAA;IACA,gBAAA;IACA,aAAA;Edm+DN;Ecj+DI;IACE,UAAA;Edm+DN;AACF;Ach+DE;EAtDF;IAuDI,sBAAA;IACA,aAAA;Edm+DF;Ecl+DE;IACE,SAAA;IACA,SAAA;IACA,WAAA;Edo+DJ;Ecj+DI;IACE,aAAA;Edm+DN;AACF;Ac79DE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;Ad+9DJ;Ac99DI;EAJF;IAKI,gBAAA;IACA,aAAA;Edi+DJ;AACF;Ac59DE;EACE,YAAA;EACA,iBAAA;Ad89DJ;Acz9DE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;Ad29DJ;Ac19DI;EALF;IAMI,qBAAA;IACA,uBAAA;IACA,kBAAA;IACA,YAAA;Ed69DJ;AACF;Acx9DE;EACE,qBAAA;Ad09DJ;Acz9DI;EAFF;IAGI,qBAAA;Ed49DJ;AACF;Acv9DE;EACE,kBAAA;Ady9DJ;Acx9DI;EAFF;IAGI,gBAAA;Ed29DJ;AACF;Act9DE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,+BAAA;Adw9DJ;Acv9DI;EAXF;IAYI,WAAA;IACA,aAAA;IACA,gBAAA;Ed09DJ;AACF;;AevrEA;EACE,oBAAA;Af0rEF;AetrEE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AfwrEJ;AevrEI;EAEE,WAAA;EACA,gCAAA;AfwrEN;AevrEM;EACE,gCAAA;AfyrER;AetrEI;EAEE,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;AfurEN;AetrEM;EACE,gCAAA;AfwrER;AerrEI;EAtBF;IAuBI,gBAAA;EfwrEJ;AACF;AevrEI;EACE;IACE,aAAA;EfyrEN;AACF;AenrEE;EACE,kBAAA;EACA,kBAAA;EACA,sBAAA;AfqrEJ;AeprEI;EAEE,SAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AfqrEN;AeprEM;EACE,gCAAA;AfsrER;AenrEI;EAdF;IAeI,qBAAA;IACA,eAAA;IACA,sBAAA;IACA,iDAAA;EfsrEJ;EerrEI;IACE,aAAA;EfurEN;AACF;AehrEI;EADF;IAEI,cAAA;IACA,gBAAA;EfmrEJ;AACF;Ae9qEE;EACE,aAAA;AfgrEJ;Ae/qEI;EAFF;IAGI,8BAAA;EfkrEJ;AACF;Ae5qEI;EAEE,MAAA;EACA,QAAA;Af6qEN;Ae5qEM;EACE,gCAAA;Af8qER;Ae3qEI;EATF;IAUI,kBAAA;IACA,oBAAA;Ef8qEJ;AACF;Ae7qEI;EAbF;IAcI,sBAAA;IACA,aAAA;IACA,iDAAA;EfgrEJ;Ee/qEI;IACE,aAAA;EfirEN;AACF;Ae3qEE;EAEE,YAAA;EACA,iBAAA;Af4qEJ;AevqEE;EACE,kBAAA;EACA,aAAA;AfyqEJ;AexqEI;EAEE,MAAA;EACA,UAAA;EACA,UAAA;AfyqEN;AexqEM;EACE,gCAAA;Af0qER;AenqEE;EACE,kBAAA;EACA,aAAA;AfqqEJ;AenqEM;EAEE,SAAA;EACA,OAAA;EACA,sBAAA;EACA,WAAA;AfoqER;AenqEQ;EACE,gCAAA;AfqqEV;AejqEI;EAfF;IAgBI,qCAAA;EfoqEJ;AACF;Ae/pEE;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;AfiqEJ;AehqEI;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AfkqEN;AejqEM;EAJF;IAKI,qBAAA;EfoqEN;AACF;AelqEI;EAZF;IAaI,iBAAA;IACA,iDAAA;EfqqEJ;EepqEI;IAEE,aAAA;EfqqEN;AACF;AehqEI;EACE,2BAAA;EACA,eAAA;EACA,2BAAA;AfkqEN;AejqEM;EAJF;IAKI,aAAA;EfoqEN;AACF;Ae9pEE;EACE,qBAAA;AfgqEJ;Ae/pEI;EAFF;IAGI,qBAAA;EfkqEJ;AACF;Ae5pEI;EADF;IAEI,kBAAA;Ef+pEJ;AACF;;AgBz2EA;EACE,oBAAA;AhB42EF;AgBx2EE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AhB02EJ;AgBz2EI;EAGE,WAAA;EACA,0BAAA;AhBy2EN;AgBx2EM;EACE,gCAAA;AhB02ER;AgBv2EI;EACE,cAAA;AhBy2EN;AgBv2EI;EACE,OAAA;AhBy2EN;AgBx2EM;EACE,gCAAA;AhB02ER;AgBv2EI;EAtBF;IAuBI,gBAAA;EhB02EJ;AACF;AgBz2EI;EAzBF;IA0BI,iBAAA;EhB42EJ;EgB32EI;IAEE,aAAA;EhB42EN;AACF;AgBt2EE;EACE,kBAAA;AhBw2EJ;AgBv2EI;EAEE,SAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AhBw2EN;AgBv2EM;EACE,gCAAA;AhBy2ER;AgBt2EI;EAZF;IAaI,kBAAA;IACA,sBAAA;EhBy2EJ;AACF;AgBx2EI;EAhBF;IAiBI,qBAAA;EhB22EJ;EgB12EI;IACE,aAAA;EhB42EN;AACF;AgBt2EE;EACE,sBAAA;AhBw2EJ;AgBn2EE;EACE,kBAAA;EACA,aAAA;AhBq2EJ;AgBp2EI;EAEE,SAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;AhBq2EN;AgBp2EM;EACE,gCAAA;AhBs2ER;AgBn2EI;EAbF;IAcI,kCAAA;EhBs2EJ;AACF;AgBr2EI;EACE;IACE,aAAA;EhBu2EN;AACF;AgBj2EE;EACE,aAAA;EACA,sBAAA;AhBm2EJ;AgBl2EI;EAHF;IAII,aAAA;EhBq2EJ;AACF;AgBh2EE;EACE,aAAA;EACA,8BAAA;AhBk2EJ;AgBj2EI;EAHF;IAII,oBAAA;IACA,kBAAA;EhBo2EJ;AACF;AgBn2EI;EAPF;IAQI,oBAAA;IACA,2BAAA;IACA,iBAAA;IACA,iDAAA;EhBs2EJ;AACF;AgBj2EE;EACE,aAAA;EACA,sBAAA;AhBm2EJ;AgB91EE;EACE,yBAAA;AhBg2EJ;AgB31EE;EACE,cf7HG;AD09EP;AgBv1EI;EADF;IAEI,eAAA;IACA,iDAAA;EhB01EJ;AACF;AgBp1EI;EADF;IAEI,yBAAA;IACA,iBAAA;IACA,2BAAA;EhBu1EJ;AACF;AgBt1EI;EANF;IAOI,qBAAA;IACA,aAAA;IACA,aAAA;EhBy1EJ;AACF;AgBp1EE;EACE,YAAA;EACA,iBAAA;AhBs1EJ;;AiBhgFA;EACE,oBAAA;AjBmgFF;AiB//EE;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;AjBigFJ;AiBhgFI;EAEE,OAAA;EACA,WAAA;EACA,0BAAA;AjBigFN;AiBhgFM;EACE,gCAAA;AjBkgFR;AiB//EI;EAEE,SAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AjBggFN;AiB//EM;EACE,gCAAA;AjBigFR;AiB9/EI;EAvBF;IAwBI,aAAA;IACA,gBAAA;IACA,8BAAA;EjBigFJ;AACF;AiBhgFI;EACE;IAEE,aAAA;EjBigFN;AACF;AiB1/EI;EAEE,UAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;AjB2/EN;AiB1/EM;EACE,gCAAA;AjB4/ER;AiBz/EI;EAXF;IAYI,kBAAA;IACA,mBAAA;EjB4/EJ;AACF;AiB3/EI;EAfF;IAgBI,qBAAA;IACA,aAAA;EjB8/EJ;EiB7/EI;IACE,aAAA;EjB+/EN;AACF;AiBz/EE;EACE,YAAA;EACA,iBAAA;AjB2/EJ;AiBt/EE;EACE,aAAA;EACA,sBAAA;AjBw/EJ;AiBv/EI;EACE,kBAAA;AjBy/EN;AiBx/EM;EAEE,WAAA;EACA,0BAAA;EACA,iCAAA;AjBy/ER;AiBv/EM;EAEE,WAAA;EACA,YAAA;EACA,iCAAA;AjBw/ER;AiBr/EI;EACE,kBAAA;AjBu/EN;AiBt/EM;EAEE,WAAA;EACA,QAAA;EACA,gCAAA;AjBu/ER;AiBt/EQ;EACE,gCAAA;AjBw/EV;AiBp/EI;EA9BF;IA+BI,qBAAA;EjBu/EJ;AACF;AiBt/EI;EAEI;IAEE,aAAA;EjBs/ER;EiBl/EM;IACE,aAAA;EjBo/ER;AACF;AiB7+EE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;AjB++EJ;AiB9+EI;EAJF;IAKI,qBAAA;EjBi/EJ;AACF;AiB5+EE;EACE,qBAAA;AjB8+EJ;AiB7+EI;EAFF;IAGI,qBAAA;EjBg/EJ;AACF;AiBt+EE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AjBw+EJ;AiBv+EI;EALF;IAMI,aAAA;IACA,sCAAA;IACA,gBAAA;IACA,WAAA;EjB0+EJ;AACF;AiBr+EE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;AjBu+EJ;AiBt+EI;EANF;IAOI,qBAAA;IACA,mBAAA;IACA,eAAA;EjBy+EJ;AACF;AiB19EE;EACE,kBAAA;AjB49EJ;AiB39EI;EAFF;IAGI,kBAAA;IACA,QAAA;EjB89EJ;AACF;;AkBlqFA;EACE,oBAAA;AlBqqFF;AkBpqFE;EAFF;IAGI,aAAA;ElBuqFF;AACF;AkBnqFE;EACE,aAAA;AlBqqFJ;AkBpqFI;EAEE,UAAA;EACA,OAAA;EACA,WAAA;EACA,0BAAA;AlBqqFN;AkBpqFM;EACE,gCAAA;AlBsqFR;AkBnqFI;EAZF;IAaI,kBAAA;IACA,8BAAA;IACA,gBAAA;ElBsqFJ;AACF;AkBrqFI;EACE;IACE,aAAA;ElBuqFN;AACF;AkBjqFE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AlBmqFJ;AkBlqFI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,yBjBlCD;ADssFL;AkB9pFE;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;AlBgqFJ;AkB3pFE;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;AlB6pFJ;AkBxpFE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AlB0pFJ;AkBrpFE;EACE,cAAA;EACA,WAAA;AlBupFJ;AkBtpFI;EACE,WAAA;AlBwpFN;AkBlpFE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;AlBopFJ;AkBnpFI;EAGE,UAAA;EACA,iCAAA;EACA,2BAAA;EACA,WAAA;AlBmpFN;AkBlpFM;EACE,gCAAA;AlBopFR;AkBjpFI;EACE,MAAA;AlBmpFN;AkBjpFI;EACE,SAAA;AlBmpFN;AkBhpFI;EACE;IACE,iBAAA;ElBkpFN;AACF;AkBjoFA;EACE,aAAA;EACA,sBAAA;AlBmoFF;AkB/nFE;EACE,qBAAA;EACA,eAAA;AlBioFJ;AkB5nFE;EACE,YAAA;EACA,iBAAA;AlB8nFJ;AkBznFE;EACE,qBAAA;AlB2nFJ;AkBtnFE;EACE,cAAA;AlBwnFJ;;AmBtxFA;EACE,oBAAA;AnByxFF;AmBrxFE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AnBuxFJ;AmBtxFI;EAEE,WAAA;EACA,0BAAA;AnBuxFN;AmBtxFM;EACE,gCAAA;AnBwxFR;AmBrxFI;EAbF;IAcI,gBAAA;EnBwxFJ;AACF;AmBvxFI;EAhBF;IAiBI,qBAAA;EnB0xFJ;EmBzxFI;IACE,aAAA;EnB2xFN;AACF;AmBrxFE;EACE,qBAAA;AnBuxFJ;AmBtxFI;EAFF;IAGI,mBAAA;IACA,2BAAA;EnByxFJ;AACF;AmBnxFI;EACE,iBAAA;AnBqxFN;AmBnxFI;EAJF;IAKI,mBAAA;EnBsxFJ;AACF;AmBjxFE;EACE,kBAAA;AnBmxFJ;AmBlxFI;EAGE,SAAA;EACA,2BAAA;EACA,WAAA;AnBkxFN;AmBjxFM;EACE,gCAAA;AnBmxFR;AmBhxFI;EACE,SAAA;AnBkxFN;AmBhxFI;EACE,YAAA;AnBkxFN;AmBhxFI;EACE;IACE,aAAA;IACA,qCAAA;EnBkxFN;AACF;AmBhxFI;EACE;IAEE,aAAA;EnBixFN;AACF;AmB3wFE;EACE,aAAA;EACA,8BAAA;AnB6wFJ;AmB5wFI;EACE,gBAAA;AnB8wFN;AmB5wFI;EANF;IAOI,aAAA;EnB+wFJ;AACF;AmBxwFM;EACE,gCAAA;AnB0wFR;AmBvwFI;EANF;IAOI,cAAA;EnB0wFJ;AACF;AmBrwFE;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;AnBuwFJ;AmBtwFI;EAGE,QAAA;AnBswFN;AmBrwFM;EACE,gCAAA;AnBuwFR;AmBpwFI;EACE,qBAAA;AnBswFN;AmBpwFI;EACE,QAAA;EACA,oCAAA;AnBswFN;AmBpwFI;EACE;IAEE,aAAA;EnBqwFN;AACF;AmBnwFI;EA1BF;IA2BI,qBAAA;IACA,qCAAA;IACA,eAAA;EnBswFJ;AACF;AmB5vFE;EACE,kBAAA;EACA,sBAAA;AnB8vFJ;AmB7vFI;EAHF;IAII,kBAAA;IACA,kBAAA;EnBgwFJ;AACF;;AmBzvFE;EAEI;IACE,oBAAA;EnB2vFN;EmBzvFI;IACE,UAAA;IACA,mBAAA;EnB2vFN;AACF;AmBxvFE;EAZF;IAaI,yBAAA;IACA,yBAAA;YAAA,iBAAA;EnB2vFF;AACF;AmBvvFE;EACE,aAAA;EACA,sBAAA;AnByvFJ;AmBpvFE;EACE,qBAAA;EACA,aAAA;EACA,WAAA;AnBsvFJ;AmBrvFI;EAJF;IAKI,qBAAA;IACA,aAAA;IACA,qBAAA;IACA,4BAAA;EnBwvFJ;AACF;AmBnvFE;EACE,YAAA;EACA,iBAAA;AnBqvFJ;AmBhvFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AnBkvFJ;AmB5uFI;EADF;IAEI,gBAAA;EnB+uFJ;AACF;AmB1uFE;EACE,UAAA;EACA,kBAAA;EACA,8BAAA;EACA,yBAAA;AnB4uFJ;AmBvuFE;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,8CAAA;EACA,iDAAA;AnByuFJ;AoB39FA;EACE,oBAAA;ApB69FF;AoBz9FE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;ApB29FJ;AoB19FI;EAEE,WAAA;EACA,0BAAA;ApB29FN;AoB19FM;EACE,gCAAA;ApB49FR;AoBz9FI;EAZF;IAaI,aAAA;IACA,8BAAA;IACA,gBAAA;EpB49FJ;AACF;AoB39FI;EAjBF;IAkBI,qBAAA;EpB89FJ;EoB79FI;IACE,aAAA;EpB+9FN;AACF;AoBz9FE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;ApB29FJ;AoB19FI;EAEE,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;ApB29FN;AoB19FM;EACE,gCAAA;ApB49FR;AoBr9FE;EACE,kBAAA;ApBu9FJ;AoBt9FI;EAGE,OAAA;EACA,WAAA;EACA,WAAA;ApBs9FN;AoBr9FM;EACE,gCAAA;ApBu9FR;AoBp9FI;EACE,MAAA;ApBs9FN;AoBp9FI;EACE,SAAA;ApBs9FN;AoBp9FI;EAlBF;IAmBI,oBAAA;EpBu9FJ;AACF;AoBt9FI;EArBF;IAsBI,qBAAA;EpBy9FJ;EoBx9FI;IAEE,aAAA;EpBy9FN;AACF;AoBn9FE;EACE,aAAA;EACA,sBAAA;ApBq9FJ;AoB38FE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;ApB68FJ;AoB58FI;EAEE,OAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;ApB68FN;AoB58FM;EACE,gCAAA;ApB88FR;AoB38FI;EAfF;IAgBI,sBAAA;IACA,aAAA;EpB88FJ;AACF;AoB78FI;EAnBF;IAoBI,oBAAA;EpBg9FJ;EoB/8FI;IACE,aAAA;EpBi9FN;AACF;AoB38FE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;ApB68FJ;AoB58FI;EAJF;IAKI,aAAA;EpB+8FJ;AACF;AoBz8FI;EADF;IAEI,kBAAA;EpB48FJ;AACF;AoBv8FE;EACE,aAAA;ApBy8FJ;AoBx8FI;EAFF;IAGI,2BAAA;IACA,YAAA;IACA,mBAAA;EpB28FJ;AACF;AoB18FI;EAPF;IAQI,qBAAA;EpB68FJ;AACF;AoBx8FE;EACE,YAAA;EACA,iBAAA;ApB08FJ;;AqBxmGA;EACE,sBAAA;ArB2mGF;AqB1mGE;EAFF;IAGI,oBAAA;ErB6mGF;AACF;AqBpmGE;EACE,kBAAA;ArBsmGJ;AqBrmGI;EAFF;IAGI,gBAAA;ErBwmGJ;AACF;AqBnmGE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;ArBqmGJ;AqBpmGI;EAEE,MAAA;EACA,OAAA;ArBqmGN;AqBpmGM;EACE,gCAAA;ArBsmGR;AqBnmGI;EAZF;IAaI,UAAA;ErBsmGJ;EqBrmGI;IACE,aAAA;ErBumGN;AACF;AqBjmGE;EACE,aAAA;ArBmmGJ;AqBlmGI;EAFF;IAGI,qBAAA;IACA,8BAAA;ErBqmGJ;AACF;AqBhmGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ArBkmGJ;AqBjmGI;EALF;IAMI,oCAAA;IACA,YAAA;ErBomGJ;AACF;AqB/lGE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;ArBimGJ;AqBhmGI;EAJF;IAKI,mBAAA;IACA,gBAAA;ErBmmGJ;AACF;AqB9lGE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;ArBgmGJ;AqB/lGI;EAJF;IAKI,sBAAA;IACA,qBAAA;ErBkmGJ;AACF;AqBxlGE;EACE,WAAA;EACA,gBAAA;ArB0lGJ;AqBzlGI;EAHF;IAII,kBAAA;IACA,4BAAA;ErB4lGJ;EqB3lGI;IACE,iBAAA;IACA,aAAA;ErB6lGN;EqB3lGI;IACE,iBAAA;IACA,aAAA;ErB6lGN;AACF;AqB3lGI;EAfF;IAgBI,qBAAA;IACA,SAAA;ErB8lGJ;AACF;AqB9kGI;EADF;IAEI,YAAA;ErBilGJ;EqBhlGI;IACE,WAAA;ErBklGN;AACF;AqBvkGE;EACE,eAAA;ArBykGJ;AqBxkGI;EAFF;IAGI,aAAA;ErB2kGJ;AACF;AqBtkGE;EACE,YAAA;EACA,iBAAA;ArBwkGJ;AqBnkGE;EACE,aAAA;ArBqkGJ;AqBpkGI;EAFF;IAGI,kBAAA;IACA,8BAAA;ErBukGJ;AACF;AqBtkGI;EANF;IAOI,eAAA;IACA,sCAAA;IACA,iBAAA;ErBykGJ;AACF;AqBpkGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;ArBskGJ;AqBrkGI;EALF;IAMI,gBAAA;ErBwkGJ;AACF;AqBlkGI;EADF;IAEI,gBAAA;ErBqkGJ;AACF;AqBhkGE;EACE,gBAAA;ArBkkGJ;AqBjkGI;EAFF;IAGI,kBAAA;ErBokGJ;AACF;AqB9jGI;EACE;IACE,kBAAA;ErBgkGN;EqB/jGM;IACE,cAAA;IACA,WAAA;ErBikGR;AACF;AqB9jGI;EAVF;IAWI,SAAA;ErBikGJ;AACF;AqB1jGM;EACE,aAAA;ArB4jGR;AqBzjGI;EANF;IAOI,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,aAAA;ErB4jGJ;AACF;AqB3jGI;EAZF;IAaI,oBAAA;ErB8jGJ;AACF;;AsB1yGA;EACE,oBAAA;AtB6yGF;AsBzyGE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AtB2yGJ;AsB1yGI;EAEE,aAAA;EACA,OAAA;EACA,4BAAA;AtB2yGN;AsB1yGM;EACE,gCAAA;AtB4yGR;AsBzyGI;EACE;IACE,aAAA;EtB2yGN;AACF;AsBzyGI;EAlBF;IAmBI,gBAAA;EtB4yGJ;AACF;AsBvyGE;EACE,sBAAA;AtByyGJ;AsBxyGI;EAFF;IAGI,kBAAA;EtB2yGJ;AACF;AsBjyGE;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;AtBmyGJ;AsBlyGI;EAGE,OAAA;EACA,WAAA;EACA,WAAA;AtBkyGN;AsBjyGM;EACE,gCAAA;AtBmyGR;AsBhyGI;EACE,MAAA;AtBkyGN;AsBhyGI;EACE,SAAA;AtBkyGN;AsBhyGI;EApBF;IAqBI,oBAAA;IACA,8BAAA;IACA,gBAAA;EtBmyGJ;EsBlyGI;IAEE,2BAAA;EtBmyGN;AACF;AsB5xGI;EADF;IAEI,qBAAA;EtB+xGJ;AACF;AsBrxGE;EACE,aAAA;EACA,mBAAA;AtBuxGJ;AsBtxGI;EAHF;IAII,eAAA;IACA,gBAAA;EtByxGJ;AACF;AsBpxGE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AtBsxGJ;AsBrxGI;EAJF;IAKI,8BAAA;EtBwxGJ;AACF;AsBnxGE;EACE,YAAA;AtBqxGJ;AsBhxGE;EACE,YAAA;EACA,iBAAA;AtBkxGJ;AsB7wGE;EACE,aAAA;EACA,sBAAA;AtB+wGJ;AsB9wGI;EAHF;IAII,SAAA;EtBixGJ;AACF;AsB5wGE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AtB8wGJ;AsB7wGI;EALF;IAMI,aAAA;EtBgxGJ;AACF;AsB1wGI;EADF;IAEI,gBAAA;EtB6wGJ;AACF;AuBn6GA;EACE,oBAAA;AvBq6GF;AuBj6GE;EACE,kBAAA;EACA,aAAA;AvBm6GJ;AuBl6GI;EAGE,OAAA;EACA,4BAAA;EACA,WAAA;AvBk6GN;AuBj6GM;EACE,gCAAA;AvBm6GR;AuBh6GI;EACE,MAAA;AvBk6GN;AuBh6GI;EACE,SAAA;AvBk6GN;AuBh6GI;EAnBF;IAoBI,8BAAA;IACA,gBAAA;IACA,gBAAA;EvBm6GJ;AACF;AuBl6GI;EACE;IAEE,aAAA;EvBm6GN;AACF;AuB75GE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AvB+5GJ;AuB35GM;EACE,gCAAA;AvB65GR;AuB15GI;EACE,WAAA;EACA,OAAA;EACA,0BAAA;AvB45GN;AuB15GI;EACE,MAAA;EACA,QAAA;EACA,YAAA;AvB45GN;AuB15GI;EACE;IAEE,aAAA;EvB25GN;AACF;AuBr5GE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AvBu5GJ;AuBt5GI;EAEE,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AvBu5GN;AuBt5GM;EACE,gCAAA;AvBw5GR;AuBr5GI;EAdF;IAeI,qBAAA;IACA,qBAAA;EvBw5GJ;AACF;AuB94GE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AvBg5GJ;AuB/4GI;EALF;IAMI,aAAA;IACA,cAAA;EvBk5GJ;AACF;AuB54GI;EADF;IAEI,mBAAA;IACA,kBAAA;EvB+4GJ;AACF;AuBr4GE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AvBu4GJ;AuBt4GI;EAJF;IAKI,8BAAA;EvBy4GJ;AACF;AuBt3GE;EACE,kBAAA;AvBw3GJ;AuBv3GI;EAEE,MAAA;EACA,QAAA;AvBw3GN;AuBv3GM;EACE,gCAAA;AvBy3GR;AuBt3GI;EAVF;IAWI,yBAAA;EvBy3GJ;AACF;AuBx3GI;EAbF;IAcI,qBAAA;EvB23GJ;EuB13GI;IACE,aAAA;EvB43GN;AACF;AuBj3GE;EACE,aAAA;EACA,mBAAA;AvBm3GJ;AuBl3GI;EAHF;IAII,eAAA;IACA,gBAAA;EvBq3GJ;AACF;AuBh3GE;EACE,aAAA;EACA,mBAAA;EACA,yBtBjLI;ADmiHR;AuB72GE;EACE,mBAAA;AvB+2GJ;AwBrjHA;EACE,oBAAA;AxBujHF;AwBnjHE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AxBqjHJ;AwBpjHI;EAEE,WAAA;EACA,OAAA;EACA,0BAAA;AxBqjHN;AwBpjHM;EACE,gCAAA;AxBsjHR;AwBnjHI;EACE;IACE,aAAA;ExBqjHN;AACF;AwBnjHI;EAnBF;IAoBI,gBAAA;ExBsjHJ;AACF;AwBjjHE;EACE,qBAAA;EACA,aAAA;EACA,8BAAA;AxBmjHJ;AwBljHI;EAJF;IAKI,kBAAA;ExBqjHJ;AACF;AwB3iHE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AxB6iHJ;AwB5iHI;EAJF;IAKI,oBAAA;ExB+iHJ;AACF;AwB9iHI;EAPF;IAQI,8BAAA;ExBijHJ;AACF;AwB9hHE;EACE,kBAAA;EACA,yBAAA;AxBgiHJ;AwB/hHI;EAGE,OAAA;EACA,4BAAA;EACA,WAAA;AxB+hHN;AwB9hHM;EACE,gCAAA;AxBgiHR;AwB7hHI;EACE,MAAA;AxB+hHN;AwB7hHI;EACE,SAAA;AxB+hHN;AwB7hHI;EAnBF;IAoBI,iBAAA;ExBgiHJ;EwB/hHI;IACE,WAAA;ExBiiHN;EwB/hHI;IACE,aAAA;ExBiiHN;AACF;AwB5gHE;EACE,aAAA;AxB8gHJ;AwB7gHI;EAFF;IAGI,cAAA;ExBghHJ;AACF;AwB3gHE;EACE,YAAA;EACA,iBAAA;AxB6gHJ;;AyBlpHA;EACE,oBAAA;AzBqpHF;AyBjpHE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AzBmpHJ;AyBlpHI;EAEE,WAAA;EACA,OAAA;EACA,0BAAA;AzBmpHN;AyBlpHM;EACE,gCAAA;AzBopHR;AyBjpHI;EACE;IACE,aAAA;EzBmpHN;AACF;AyBjpHI;EAlBF;IAmBI,gBAAA;EzBopHJ;AACF;AyB/oHE;EACE,kBAAA;EACA,qBAAA;AzBipHJ;AyBhpHI;EAEE,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AzBipHN;AyB/oHI;EAVF;IAWI,kBAAA;EzBkpHJ;EyBjpHI;IACE,aAAA;EzBmpHN;EyBlpHM;IACE,gCAAA;EzBopHR;AACF;AyBjpHI;EAnBF;IAoBI,mBAAA;IACA,sBAAA;EzBopHJ;AACF;AyB1oHE;EACE,kBAAA;EACA,aAAA;AzB4oHJ;AyB3oHI;EAEE,QAAA;EACA,MAAA;AzB4oHN;AyB1oHI;EARF;IASI,cAAA;EzB6oHJ;EyB5oHI;IACE,aAAA;EzB8oHN;AACF;AyB5oHI;EAEI;IACE,gCAAA;EzB6oHR;AACF;AyBtoHE;EACE,kBAAA;EACA,aAAA;AzBwoHJ;AyBvoHI;EAGE,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AzBuoHN;AyBroHI;EACE,SAAA;EACA,SAAA;EACA,2BAAA;AzBuoHN;AyBroHI;EAhBF;IAiBI,qCAAA;EzBwoHJ;EyBroHM;IACE,gCAAA;EzBuoHR;AACF;AyBpoHI;EAzBF;IA0BI,sBAAA;IACA,eAAA;EzBuoHJ;EyBtoHI;IACE,SAAA;IACA,SAAA;EzBwoHN;EyBtoHI;IACE,WAAA;EzBwoHN;AACF;AyBloHE;EACE,kBAAA;AzBooHJ;AyBloHM;EAEE,MAAA;EACA,QAAA;AzBmoHR;AyBhoHI;EATF;IAUI,aAAA;EzBmoHJ;EyBjoHM;IACE,gCAAA;EzBmoHR;AACF;AyBhoHI;EAEI;IACE,aAAA;EzBioHR;EyB9nHI;IACE,SAAA;EzBgoHN;AACF;AyB1nHM;EADF;IAEI,mBAAA;EzB6nHN;AACF;AyBvnHE;EACE,aAAA;EACA,aAAA;AzBynHJ;AyBxnHI;EAHF;IAII,eAAA;EzB2nHJ;AACF;AyBtnHE;EACE,YAAA;EACA,iBAAA;AzBwnHJ;AyBnnHE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AzBqnHJ;AyBpnHI;EAJF;IAKI,YAAA;EzBunHJ;AACF;AyBlnHE;EACE,qBAAA;AzBonHJ;AyB/mHE;EACE,mBAAA;EACA,cAAA;AzBinHJ;AyBhnHI;EAHF;IAII,qBAAA;EzBmnHJ;AACF;AyB7mHI;EADF;IAEI,gBAAA;EzBgnHJ;AACF;AyB3mHE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AzB6mHJ;AyB5mHI;EAEE,SAAA;EACA,OAAA;EACA,2BAAA;EACA,WAAA;AzB6mHN;AyB3mHI;EAbF;IAcI,iBAAA;EzB8mHJ;EyB7mHI;IACE,WAAA;EzB+mHN;AACF;AyB7mHI;EAEI;IACE,gCAAA;EzB8mHR;AACF;AyBlmHE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AzBomHJ;A0Bp2HA;EACE,oBAAA;A1Bs2HF;A0Bl2HE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;A1Bo2HJ;A0Bn2HI;EAEE,MAAA;EACA,OAAA;A1Bo2HN;A0Bn2HM;EACE,gCAAA;A1Bq2HR;A0Bl2HI;EAEE,MAAA;EACA,QAAA;EACA,0BAAA;A1Bm2HN;A0Bl2HM;EACE,gCAAA;A1Bo2HR;A0Bj2HI;EArBF;IAsBI,UAAA;E1Bo2HJ;E0Bn2HI;IAEE,aAAA;E1Bo2HN;AACF;A0Bl2HI;EA5BF;IA6BI,gBAAA;E1Bq2HJ;AACF;A0Bh2HE;EACE,oBAAA;EACA,aAAA;A1Bk2HJ;A0Bj2HI;EAEE,MAAA;EACA,aAAA;A1Bk2HN;A0Bj2HM;EACE,gCAAA;A1Bm2HR;A0Bh2HI;EAXF;IAYI,yCAAA;E1Bm2HJ;AACF;A0Bl2HI;EAdF;IAeI,oBAAA;E1Bq2HJ;E0Bp2HI;IACE,aAAA;E1Bs2HN;AACF;A0Bh2HE;EACE,aAAA;EACA,sBAAA;A1Bk2HJ;A0B91HI;EACE,yBAAA;A1Bg2HN;A0B71HI;EACE;IACE,uBAAA;IACA,mBAAA;IACA,mBAAA;E1B+1HN;E0B71HI;IACE,qBAAA;IACA,kBAAA;E1B+1HN;AACF;A0B71HI;EACE;IACE,+BAAA;E1B+1HN;AACF;A0Bz1HE;EACE,qBAAA;A1B21HJ;A0Bt1HE;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;A1Bw1HJ;A0Bv1HI;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;A1By1HN;A0Bv1HI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;A1By1HN;A0Bv1HI;EAtBF;IAuBI,SAAA;IACA,WAAA;IACA,eAAA;E1B01HJ;E0Bz1HI;IACE,aAAA;E1B21HN;AACF;A0Br1HE;EACE,YAAA;EACA,iBAAA;A1Bu1HJ;A0Bt1HI;EACE;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,cAAA;E1Bw1HN;AACF;A0Bl1HE;EACE,qBAAA;EACA,gBAAA;A1Bo1HJ;A0Bn1HI;EAHF;IAII,qBAAA;IACA,SAAA;E1Bs1HJ;AACF;A0Bj1HE;EACE,kBAAA;EACA,sBAAA;A1Bm1HJ;A0Bl1HI;EAHF;IAII,mBAAA;IACA,gBAAA;E1Bq1HJ;AACF;A0Bh1HE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;A1Bk1HJ;A0B70HE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;A1B+0HJ;A0B10HE;EACE,cAAA;A1B40HJ;A0Bv0HE;EACE,kBAAA;A1By0HJ;A0Bx0HI;EAFF;IAGI,kBAAA;E1B20HJ;AACF;A0Bt0HE;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;A1Bw0HJ;A0Bv0HI;EAPF;IAQI,iBAAA;IACA,eAAA;IACA,YAAA;E1B00HJ;AACF;;A2BhiIA;EACE,oBAAA;A3BmiIF;A2B/hIE;EACE,kBAAA;EACA,aAAA;A3BiiIJ;A2BhiII;EAHF;IAII,gBAAA;E3BmiIJ;AACF;A2B9gIA;EACE,kBAAA;EACA,aAAA;A3BghIF;A2B/gIE;EAEE,WAAA;EACA,OAAA;EACA,0BAAA;A3BghIJ;A2B/gII;EACE,gCAAA;A3BihIN;A2B9gIE;EAEE,SAAA;EACA,OAAA;EACA,2BAAA;EACA,WAAA;A3B+gIJ;A2B9gII;EACE,gCAAA;A3BghIN;A2B7gIE;EAtBF;IAuBI,kCAAA;E3BghIF;AACF;A2B/gIE;EAzBF;IA0BI,sBAAA;E3BkhIF;E2BjhIE;IACE,aAAA;E3BmhIJ;E2BjhIE;IACE,WAAA;E3BmhIJ;AACF;A2B9gIE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;A3BghIJ;A2B/gII;EAEE,WAAA;EACA,QAAA;EACA,0BAAA;A3BghIN;A2B/gIM;EACE,gCAAA;A3BihIR;A2B9gII;EAbF;IAcI,yBAAA;E3BihIJ;AACF;A2BhhII;EACE;IACE,iBAAA;IACA,qBAAA;IACA,sBAAA;IACA,gCAAA;E3BkhIN;E2BhhII;IACE,aAAA;E3BkhIN;AACF;A2B3gII;EADF;IAEI,mBAAA;E3B8gIJ;AACF;A2B7gII;EAJF;IAKI,sBAAA;IACA,gCAAA;IACA,gBAAA;E3BghIJ;AACF;A2B3gIE;EACE,cAAA;A3B6gIJ;A2B5gII;EAFF;IAGI,kBAAA;E3B+gIJ;AACF;A2B1gIE;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;A3B4gIJ;A2B3gII;EACE,kBAAA;EACA,yBAAA;A3B6gIN;A2B3gII;EAVF;IAWI,qBAAA;IACA,sBAAA;IACA,gCAAA;E3B8gIJ;E2B7gII;IACE,qBAAA;IACA,oBAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;E3B+gIN;AACF;A2BzgIE;EACE,YAAA;EACA,iBAAA;A3B2gIJ;A2B1gII;EACE,YAAA;EACA,iBAAA;A3B4gIN;A2B1gII;EAPF;IAQI,WAAA;IACA,eAAA;E3B6gIJ;AACF;;A2BvgIA;EACE,kBAAA;EACA,aAAA;A3B0gIF;A2BzgIE;EAEE,WAAA;EACA,OAAA;EACA,0BAAA;A3B0gIJ;A2BzgII;EACE,gCAAA;A3B2gIN;A2BxgIE;EAEE,SAAA;EACA,OAAA;EACA,2BAAA;EACA,WAAA;A3BygIJ;A2BxgII;EACE,gCAAA;A3B0gIN;A2BvgIE;EAtBF;IAuBI,gBAAA;IACA,sCAAA;E3B0gIF;AACF;A2BzgIE;EA1BF;IA2BI,oBAAA;E3B4gIF;E2B3gIE;IAEE,aAAA;E3B4gIJ;AACF;A2BvgIE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;A3BygIJ;A2BxgII;EACE,kBAAA;EACA,kBAAA;A3B0gIN;A2BzgIM;EAEE,WAAA;EACA,yBAAA;EACA,0BAAA;A3B0gIR;A2BzgIQ;EACE,gCAAA;A3B2gIV;A2BvgII;EACE,qBAAA;A3BygIN;A2BxgIM;EACE,qBAAA;EACA,iBAAA;A3B0gIR;A2BvgII;EAxBF;IAyBI,qBAAA;IACA,sBAAA;IACA,mBAAA;IACA,8BAAA;IACA,gCAAA;E3B0gIJ;E2BzgII;IACE,aAAA;E3B2gIN;E2BzgII;IACE,aAAA;E3B2gIN;AACF;A2BrgIE;EACE,aAAA;EACA,sBAAA;A3BugIJ;A2BtgII;EACE,gBAAA;A3BwgIN;A2BlgIE;EACE,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;A3BogIJ;A2BngII;EALF;IAMI,qBAAA;IACA,eAAA;E3BsgIJ;AACF;A2BjgIE;EACE,cAAA;A3BmgIJ;A2B9/HE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;A3BggIJ;A2B//HI;EALF;IAMI,eAAA;E3BkgIJ;AACF;A2B7/HE;EACE,YAAA;EACA,iBAAA;A3B+/HJ;;A2Bz/HA;EACE,kBAAA;EACA,aAAA;A3B4/HF;A2B3/HE;EAEE,MAAA;EACA,OAAA;A3B4/HJ;A2B3/HI;EACE,gCAAA;A3B6/HN;A2B1/HE;EAEE,SAAA;EACA,OAAA;EACA,2BAAA;EACA,WAAA;A3B2/HJ;A2B1/HI;EACE,gCAAA;A3B4/HN;A2Bz/HE;EArBF;IAsBI,8BAAA;E3B4/HF;AACF;A2B3/HE;EACE;IAEE,aAAA;E3B4/HJ;AACF;A2Bv/HE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;A3By/HJ;A2Bx/HI;EACE,kBAAA;EACA,gBAAA;A3B0/HN;A2Bz/HM;EAEE,MAAA;EACA,OAAA;A3B0/HR;A2Bz/HQ;EACE,gCAAA;A3B2/HV;A2Bv/HI;EAjBF;IAkBI,aAAA;E3B0/HJ;AACF;A2Bt/HU;EADF;IAEI,qBAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;E3By/HV;AACF;A2BjgII;EAYI;IACE,aAAA;E3Bw/HR;AACF;A2Bj/HE;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;A3Bm/HJ;A2Bl/HI;EALF;IAMI,qBAAA;IACA,iBAAA;E3Bq/HJ;AACF;A2Bh/HE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A3Bk/HJ;A2B7+HE;EACE,kBAAA;A3B++HJ;A2B1+HE;EACE,mBAAA;EACA,WAAA;A3B4+HJ;A2Bl+HE;EACE,aAAA;EACA,sBAAA;A3Bo+HJ;A2B/9HE;EACE,gBAAA;EACA,aAAA;EACA,cAAA;A3Bi+HJ;A2Bh+HI;EAJF;IAKI,eAAA;IACA,YAAA;IACA,YAAA;E3Bm+HJ;AACF;A2B99HE;EACE,aAAA;EACA,sBAAA;A3Bg+HJ;A2B/9HI;EACE,qBAAA;EACA,c1B7ZE;AD83IR;A2B/9HI;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;A3Bi+HN;A2Bh+HM;EAEE,SAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;A3Bi+HR;A2Bh+HQ;EACE,gCAAA;A3Bk+HV;A2B99HI;EACE;IACE,kBAAA;E3Bg+HN;E2B99HI;IACE,qBAAA;E3Bg+HN;AACF;A2B99HI;EAEI;IACE,YAAA;E3B+9HR;AACF;A2Bx9HE;EACE,aAAA;EACA,kBAAA;A3B09HJ;A2Bz9HI;EAHF;IAII,mBAAA;IACA,gBAAA;IACA,6BAAA;E3B49HJ;AACF;A2Bt9HI;EADF;IAEI,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,WAAA;E3By9HJ;AACF;A2Bx9HI;EAPF;IAQI,iBAAA;E3B29HJ;AACF;A2Bt9HE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;A3Bw9HJ;A2Bl9HI;EADF;IAEI,qBAAA;IACA,eAAA;IACA,WAAA;E3Bq9HJ;AACF;A2B/8HI;EADF;IAEI,YAAA;IACA,iBAAA;E3Bk9HJ;AACF;A4Bn9IA;EACE,oBAAA;A5Bq9IF;A4Bj9IE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;A5Bm9IJ;A4Bl9II;EAEE,WAAA;EACA,0BAAA;A5Bm9IN;A4Bl9IM;EACE,gCAAA;A5Bo9IR;A4Bj9II;EAZF;IAaI,gBAAA;E5Bo9IJ;AACF;A4Bn9II;EACE;IACE,aAAA;E5Bq9IN;AACF;A4B/8IE;EACE,kBAAA;EACA,iBAAA;A5Bi9IJ;A4Bh9II;EAGE,OAAA;EACA,2BAAA;EACA,WAAA;A5Bg9IN;A4B/8IM;EACE,gCAAA;A5Bi9IR;A4B98II;EACE,MAAA;A5Bg9IN;A4B98II;EACE,SAAA;A5Bg9IN;A4B98II;EAnBF;IAoBI,2BAAA;IACA,aAAA;IACA,qCAAA;E5Bi9IJ;AACF;A4Bh9II;EACE;IAEE,WAAA;E5Bi9IN;AACF;A4B38IE;EACE,aAAA;EACA,sBAAA;A5B68IJ;A4B58II;EAHF;IAII,uBAAA;E5B+8IJ;E4B98II;IACE,iBAAA;IACA,iBAAA;E5Bg9IN;AACF;A4B98II;EACE;IACE,oBAAA;IACA,mBAAA;IACA,8BAAA;E5Bg9IN;E4B/8IM;IACE,SAAA;E5Bi9IR;E4Bh9IQ;IACE,iBAAA;E5Bk9IV;AACF;A4B18IE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;A5B48IJ;A4Bv8IE;EACE,yBAAA;A5By8IJ;A4Bp8IE;EACE,cAAA;A5Bs8IJ;A4Bh8II;EADF;IAEI,qBAAA;IACA,mBAAA;IACA,6BAAA;E5Bm8IJ;AACF;A4B97IE;EACE,cAAA;A5Bg8IJ;A4B/7II;EAFF;IAGI,mBAAA;E5Bk8IJ;AACF;A4Bj8II;EALF;IAMI,oBAAA;E5Bo8IJ;AACF;A4B/7IE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;A5Bi8IJ;A4Bh8II;EAXF;IAYI,UAAA;IACA,SAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;IACA,2BAAA;E5Bm8IJ;E4Bl8II;IACE,kBAAA;E5Bo8IN;AACF;A4B77II;EADF;IAEI,eAAA;E5Bg8IJ;AACF;;A6BlmJA;EACE,kBAAA;EACA,oBAAA;A7BqmJF;A6BjmJE;EACE,kBAAA;EACA,YAAA;A7BmmJJ;A6BlmJI;EAEE,UAAA;EACA,MAAA;EACA,OAAA;EACA,0CAAA;A7BmmJN;A6BlmJM;EACE,gCAAA;A7BomJR;A6BjmJI;EAbF;IAcI,UAAA;E7BomJJ;E6BnmJI;IACE,aAAA;E7BqmJN;AACF;A6BnmJI;EAnBF;IAoBI,gBAAA;E7BsmJJ;AACF;A6BjmJE;EACE,kBAAA;A7BmmJJ;A6B7lJI;EACE;IACE,iBAAA;E7B+lJN;AACF;A6B7lJI;EANF;IAOI,oBAAA;E7BgmJJ;AACF;A6BhlJE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;A7BklJJ;A6BjlJI;EAJF;IAKI,kBAAA;IACA,UAAA;IACA,UAAA;IACA,yBAAA;IACA,8BAAA;E7BolJJ;AACF;A6BnlJI;EAXF;IAYI,iBAAA;E7BslJJ;AACF;A6BjlJE;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;A7BmlJJ;A6BllJI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,0CAAA;A7BolJN;A6BllJI;EAXF;IAYI,kBAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;E7BqlJJ;E6BplJI;IACE,cAAA;E7BslJN;AACF;A6BhlJE;EACE,mBAAA;A7BklJJ;A6BjlJI;EACE,SAAA;A7BmlJN;A6BjlJI;EACE,QAAA;A7BmlJN;A6BjlJI;EARF;IASI,iBAAA;E7BolJJ;AACF;A6B/kJE;EACE,aAAA;EACA,sBAAA;A7BilJJ;A6BhlJI;EAHF;IAII,sBAAA;E7BmlJJ;AACF;A6B9kJE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;A7BglJJ;A6B/kJI;EAJF;IAKI,mBAAA;IACA,mBAAA;IACA,gBAAA;E7BklJJ;AACF;A6B5kJI;EADF;IAEI,kBAAA;IACA,cAAA;E7B+kJJ;AACF;A6B1kJE;EACE,aAAA;EACA,sBAAA;A7B4kJJ;A6B3kJI;EAHF;IAII,kBAAA;IACA,SAAA;IACA,aAAA;IACA,8BAAA;E7B8kJJ;AACF;A6BzkJE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;A7B2kJJ;A6B1kJI;EAJF;IAKI,sBAAA;E7B6kJJ;AACF;A6B5kJI;EAPF;IAQI,8BAAA;IACA,qBAAA;E7B+kJJ;AACF;A6BzkJI;EADF;IAEI,mBAAA;IACA,iBAAA;E7B4kJJ;AACF;A6BvkJE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;A7BykJJ;A6BpkJE;EACE,cAAA;EACA,eAAA;A7BskJJ;A6BrkJI;EACE,iBAAA;A7BukJN;A6BjkJE;EACE,cAAA;EACA,eAAA;A7BmkJJ;A6B9jJE;EACE,YAAA;A7BgkJJ;A6B3jJE;EACE,YAAA;EACA,iBAAA;A7B6jJJ;;A6BvjJA;EACE,aAAA;EACA,WAAA;A7B0jJF;A6BzjJE;EAHF;IAII,8BAAA;IACA,kBAAA;E7B4jJF;AACF;A6BxjJE;EACE,kBAAA;A7B0jJJ;A6BzjJI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,cAAA;EACA,YAAA;EACA,2BAAA;EACA,4OAAA;A7B2jJN;A6B/iJI;EArBF;IAsBI,qBAAA;IACA,aAAA;E7BkjJJ;AACF;A6B7iJE;EACE,YAAA;EACA,iBAAA;A7B+iJJ;A6B9iJI;EAHF;IAII,kBAAA;IACA,MAAA;IACA,cAAA;IACA,2BAAA;E7BijJJ;AACF;A6B5iJE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;A7B8iJJ;A6B7iJI;EAJF;IAKI,oBAAA;IACA,uBAAA;IACA,qBAAA;IACA,qCAAA;E7BgjJJ;AACF;A6B/iJI;EAVF;IAWI,oBAAA;IACA,gBAAA;E7BkjJJ;AACF;A6B7iJE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;A7B+iJJ;A6B9iJI;EALF;IAMI,qBAAA;IACA,8BAAA;E7BijJJ;AACF;A6B5iJE;EACE,cAAA;A7B8iJJ;A6BpiJE;EACE,qBAAA;A7BsiJJ;A6BriJI;EAFF;IAGI,qBAAA;E7BwiJJ;AACF;A6BniJE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;A7BqiJJ;A6BpiJI;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yB5BtUE;AD42JR;A6BpiJI;EAXF;IAYI,mBAAA;IACA,aAAA;E7BuiJJ;E6BtiJI;IACE,WAAA;E7BwiJN;AACF;A6BliJE;EACE,eAAA;A7BoiJJ;;ACr0JE;EACE,gBAAA;EACA,kBAAA;ADw0JJ;ACj0JA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;ADm0JF;ACl0JE;EAEE,UAAA;EACA,OAAA;EACA,MAAA;ADm0JJ;ACj0JE;EAEE,UAAA;EACA,QAAA;EACA,MAAA;ADk0JJ;ACh0JE;EACE;IAEE,aAAA;EDi0JJ;AACF;AC/zJE;EA1BF;IA2BI,WAAA;EDk0JF;AACF;ACh0JE;EACE,cAAA;ADk0JJ;AC/zJE;EACE,YAAA;ADi0JJ","sourcesContent":["@font-face {\n  font-family: Gilroy;\n  font-display: swap;\n  src: url('./assets/fonts/Gilroy-Bold.woff2') format('woff2');\n  font-weight: 700;\n  font-style: normal;\n}\n@font-face {\n  font-family: Gilroy;\n  font-display: swap;\n  src: url('./assets/fonts/Gilroy-Medium.woff2') format('woff2');\n  font-weight: 500;\n  font-style: normal;\n}\n@font-face {\n  font-family: Gilroy;\n  font-display: swap;\n  src: url('./assets/fonts/Gilroy-Regular.woff2') format('woff2');\n  font-weight: 400;\n  font-style: normal;\n}\n","@import url(\"https://fonts.googleapis.com/css?family=Assistant:regular,600,700,800&display=swap\");\n@import url(\"https://fonts.googleapis.com/css?family=Poiret+One:regular&display=swap\");\n@font-face {\n  font-family: Gilroy;\n  font-display: swap;\n  src: url(\"./assets/fonts/Gilroy-Bold.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: normal;\n}\n@font-face {\n  font-family: Gilroy;\n  font-display: swap;\n  src: url(\"./assets/fonts/Gilroy-Medium.woff2\") format(\"woff2\");\n  font-weight: 500;\n  font-style: normal;\n}\n@font-face {\n  font-family: Gilroy;\n  font-display: swap;\n  src: url(\"./assets/fonts/Gilroy-Regular.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n}\nbody {\n  --scaleY: 0;\n  --scaleX: 0;\n  --opacity: 0;\n  --progress: 0;\n  --transition: \"none\";\n  --x: translateX(-100%);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: \"Gilroy\";\n  font-size: 0.5208335vw;\n  font-style: normal;\n  font-weight: normal;\n  -webkit-animation: bugfix infinite 1s;\n  line-height: 1.2;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 2.5rem;\n  -webkit-animation: bugfix infinite 1s;\n  line-height: 1.2;\n  margin: 0;\n  padding: 0;\n  color: #ffffff;\n  background-color: #242424;\n}\n\ninput,\ntextarea {\n  -webkit-animation: bugfix infinite 1s;\n  line-height: inherit;\n  margin: 0;\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  color: inherit;\n}\n\na {\n  color: unset;\n}\n\na,\na:hover {\n  text-decoration: none;\n}\n\nbutton,\ninput,\na,\ntextarea {\n  outline: none;\n  cursor: pointer;\n  font: inherit;\n}\nbutton:focus,\ninput:focus,\na:focus,\ntextarea:focus {\n  outline: none;\n}\nbutton:active,\ninput:active,\na:active,\ntextarea:active {\n  outline: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font: inherit;\n  margin: 0;\n  padding: 0;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\nimg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\nbutton {\n  border: none;\n  color: inherit;\n  font: inherit;\n  text-align: inherit;\n  padding: 0;\n  background-color: transparent;\n}\n\nul {\n  padding: 0;\n  margin: 0;\n}\n\nul li {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.container {\n  width: 145.6rem;\n  margin: 0 auto;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n@media (min-width: 1920px) {\n  html {\n    font-size: 10px;\n  }\n}\n@media (max-width: 48em) {\n  html {\n    font-size: 5px;\n    font-size: 1.5625vw;\n    font-size: 1.3333333333vw;\n    -webkit-text-size-adjust: none;\n  }\n  body {\n    -webkit-text-size-adjust: none;\n  }\n  .container {\n    padding: 0 4rem;\n    width: 100%;\n  }\n}\n.form__error {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #f05757;\n  transform: translateY(0.3rem);\n}\n@media (max-width: 48em) {\n  .form__error {\n    font-size: 2.4rem;\n  }\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n}\n.btn_primary {\n  position: relative;\n  padding: 1.6rem 2.4rem;\n  justify-content: space-between;\n  column-gap: 1rem;\n  min-width: 19.6rem;\n  height: 4.9rem;\n  border-radius: 10rem;\n  background-color: #1a1a1a;\n  overflow: hidden;\n}\n.btn_primary::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: #ffffff;\n  transition: all 0.3s ease;\n}\n.btn_primary svg {\n  position: relative;\n  z-index: 2;\n  width: 1.6rem;\n  height: 1.6rem;\n}\n.btn_primary path {\n  transition: stroke 0.3s ease;\n}\n@media (any-hover: hover) {\n  .btn_primary:hover::after {\n    opacity: 0;\n    transform: scaleY(0);\n  }\n  .btn_primary:hover path {\n    stroke: #ffffff;\n  }\n  .btn_primary:hover .btn__text {\n    color: #ffffff;\n  }\n}\n@media (max-width: 48em) {\n  .btn_primary {\n    padding: 2.2rem 3.2rem 2rem 3.2rem;\n    column-gap: 2rem;\n    height: 7.8rem;\n    min-width: 32rem;\n    border-radius: 20rem;\n  }\n  .btn_primary svg {\n    width: 2.2rem;\n    height: 2.2rem;\n  }\n}\n.btn_link {\n  transform: translateX(1.6rem);\n}\n.btn_link .btn__text {\n  color: #ffffff;\n}\n.btn_link svg {\n  width: 1.6rem;\n  height: 1.6rem;\n  transform: translateX(1.6rem);\n  transition: transform 0.3s ease;\n}\n.btn_link:hover svg {\n  transform: translateX(0.8rem);\n}\n@media (max-width: 48em) {\n  .btn_link svg {\n    width: 2rem;\n    height: 2rem;\n  }\n}\n.btn__text {\n  position: relative;\n  z-index: 2;\n  padding-top: 0.1rem;\n  color: #1a1a1a;\n  white-space: nowrap;\n  transition: color 0.3s ease;\n}\n@media (max-width: 48em) {\n  .btn__text {\n    padding-top: 0.4rem;\n  }\n  .btn__text.txt, .btn__text.input__field {\n    font-size: 2.8rem;\n  }\n}\n\ninput[type=text],\ninput[type=email],\ninput[type=tel],\ntextarea {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\ntextarea:focus,\ninput:focus {\n  outline: none;\n}\n\n.input {\n  position: relative;\n}\n.input__field {\n  display: block;\n  width: 100%;\n  padding: 1.6rem 0;\n  border-radius: 0 !important;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  font-size: 1.8rem;\n  transition: all 0.3s ease;\n}\n.input__field::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n.input__field._form-focus {\n  border-bottom: 2px solid #ffffff;\n}\n.input__field._form-error {\n  color: #f05757;\n  border-bottom: 2px solid #f05757;\n}\n.input__field._form-error::placeholder {\n  color: #f05757;\n}\n.input__field._filled {\n  color: #ffffff;\n  border-bottom: 2px solid #ffffff;\n}\n@media (max-width: 48em) {\n  .input__field {\n    padding: 1.6rem 0;\n  }\n}\n\ntextarea.input {\n  padding: 0;\n  resize: none;\n}\n\n.checkbox {\n  position: relative;\n}\n.checkbox._form-error .checkbox__text {\n  color: #f05757;\n}\n.checkbox__input {\n  position: absolute;\n  width: 0;\n  height: 0;\n  opacity: 0;\n}\n.checkbox__input._form-error + .checkbox__label::before {\n  border: 1px solid #f05757;\n}\n.checkbox__input:checked + .checkbox__label:before {\n  background-image: url(./assets/images/icons/check.svg);\n  background-position: center;\n  background-size: 1.4rem;\n  background-repeat: no-repeat;\n}\n@media (max-width: 48em) {\n  .checkbox__input:checked + .checkbox__label:before {\n    background-size: 3rem;\n  }\n}\n.checkbox__label {\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  column-gap: 2.4rem;\n  cursor: pointer;\n}\n.checkbox__label:before {\n  content: \"\";\n  flex: 0 0 2.4rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  border: 1px solid #ffffff;\n  transition: border 1px solid;\n}\n@media (max-width: 48em) {\n  .checkbox__label {\n    column-gap: 2.5rem;\n  }\n  .checkbox__label::before {\n    flex: 0 0 4.8rem;\n    width: 4.8rem;\n    height: 4.8rem;\n  }\n}\n.checkbox__text {\n  transition: color 0.3s ease;\n}\n.checkbox__text.txt, .checkbox__text.input__field {\n  line-height: 155%;\n}\n@media (max-width: 48em) {\n  .checkbox__text.txt, .checkbox__text.input__field {\n    font-size: 2.7rem;\n  }\n}\n\nbody::before {\n  content: \"\";\n  position: fixed;\n  z-index: 90;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  background-color: #1a1a1a;\n  pointer-events: none;\n  transition: opacity 0.8s ease 0s;\n}\n@media (min-width: 48em) {\n  body::before {\n    background: rgba(106, 106, 106, 0.2);\n    backdrop-filter: blur(1.9rem);\n  }\n}\n\n.popup-show body::before {\n  opacity: 1;\n}\n\n.popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 3rem 1rem;\n  visibility: hidden;\n  pointer-events: none;\n  transition: visibility 0.8s ease 0s;\n}\n@media (max-width: 48em) {\n  .popup.request-modal {\n    padding: 0;\n  }\n}\n\n.popup_show {\n  z-index: 150;\n  visibility: visible;\n  overflow: auto;\n  pointer-events: auto;\n}\n\n.popup_show .popup__content {\n  visibility: visible;\n  transform: scale(1);\n}\n\n.popup__wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex: 1 1 auto;\n  min-height: 100%;\n  width: 100%;\n}\n\n.popup__content {\n  padding: 2rem;\n  width: 100%;\n  max-width: 127.8rem;\n  background-color: #242424;\n  visibility: hidden;\n  transform: scale(0);\n  transition: transform 0.3s ease 0s;\n}\n.lock .popup__content {\n  visibility: visible;\n}\n.request-modal .popup__content {\n  padding: 0;\n  display: grid;\n}\n@media (min-width: 48em) {\n  .request-modal .popup__content {\n    grid-template-columns: 59.9rem 1fr;\n  }\n}\n\n@media (max-width: 48em) {\n  .request-modal .popup__wrapper {\n    justify-content: stretch;\n  }\n  .request-modal .popup__content {\n    flex: 1 1 auto;\n  }\n}\n@media (max-width: 48em) {\n  .request-modal__image-wrap {\n    margin-bottom: 6.3rem;\n    width: 100%;\n    height: 46rem;\n  }\n}\n.request-modal__image {\n  height: 100%;\n  object-fit: cover;\n}\n.request-modal__body {\n  padding: 2.5rem 2.5rem 9.7rem 8rem;\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 48em) {\n  .request-modal__body {\n    padding: 5rem 0 21.4rem 0;\n  }\n  .request-modal_sent .request-modal__body {\n    align-items: center;\n    text-align: center;\n  }\n}\n@media (min-width: 48em) {\n  .request-modal_sent .request-modal__body {\n    padding: 2.5rem 2.5rem 23.6rem 8rem;\n  }\n}\n.request-modal__close-btn {\n  margin-bottom: 4.9rem;\n  width: 3rem;\n  height: 3rem;\n  align-self: flex-end;\n}\n@media (max-width: 48em) {\n  .request-modal__close-btn {\n    margin-bottom: 11rem;\n    width: 5rem;\n    height: 5rem;\n    transform: translateX(-3.2rem);\n  }\n}\n@media (min-width: 48em) {\n  .request-modal_sent .request-modal__close-btn {\n    margin-bottom: 18.8rem;\n  }\n}\n.request-modal__title {\n  margin-bottom: 3.2rem;\n}\n@media (max-width: 48em) {\n  .request-modal__title {\n    padding: 0 3.2rem;\n  }\n}\n@media (min-width: 48em) {\n  .request-modal_sent .request-modal__title {\n    max-width: 53.3rem;\n  }\n}\n.request-modal__text {\n  margin-bottom: 6rem;\n}\n.request-modal_sent .request-modal__text {\n  margin-bottom: 3.2rem;\n}\n@media (max-width: 48em) {\n  .request-modal__text {\n    margin-bottom: 5rem;\n    padding: 0 3.2rem;\n    max-width: 58.2rem;\n  }\n}\n.request-modal__form {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n@media (max-width: 48em) {\n  .request-modal__form {\n    padding: 0 3.2rem;\n  }\n}\n.request-modal__fields {\n  margin-bottom: 3rem;\n  display: flex;\n  flex-direction: column;\n  row-gap: 2.4rem;\n  width: 50rem;\n}\n@media (max-width: 48em) {\n  .request-modal__fields {\n    margin-bottom: 5rem;\n    row-gap: 5rem;\n    width: 100%;\n  }\n}\n@media (max-width: 48em) {\n  .request-modal__actions {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    column-gap: 2rem;\n  }\n}\n@media (min-width: 48em) {\n  .request-modal__checkbox {\n    margin-bottom: 5.6rem;\n  }\n}\n.request-modal__btn {\n  min-width: 15.3rem;\n}\n@media (max-width: 48em) {\n  .request-modal__btn {\n    min-width: 24.6rem;\n  }\n}\n@media (min-width: 48em) {\n  .request-modal__btn {\n    align-self: flex-start;\n  }\n}\n\n.ymaps3x0--main-engine-container {\n  filter: grayscale(1);\n  -ms-filter: grayscale(1);\n  -webkit-filter: grayscale(1);\n  -moz-filter: grayscale(1);\n  -o-filter: grayscale(1);\n}\n\n.marker {\n  position: relative;\n  box-sizing: border-box;\n  width: 8.2rem;\n  transform: translate(-50%, calc(-50% - 24px));\n  cursor: pointer;\n}\n@media (max-width: 48em) {\n  .marker {\n    width: 10rem;\n  }\n}\n\n[class*=-ibg] {\n  position: relative;\n}\n[class*=-ibg] img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  object-fit: cover;\n}\n\n[class*=-ibg_contain] img {\n  object-fit: contain;\n}\n\n.wrapper::after, .wrapper::before, .hero-portfolio__container::before, .company-methods__body::before, .company-methods__body::after, .company-methods__container::before, .privileges-company-info__text-wrap .privileges-company-info__text::after, .privileges-company-info__column:last-child::before, .privileges-company-info::after, .privileges-company-info::before, .numbers-company-info__row_left::after, .numbers-company-info::after, .numbers-company-info::before, .info-company-info__text-wrap::before, .info-company-info::after, .info-company-info::before, .contacts__content::after, .contacts__container::after, .contacts__container::before, .portfolio__footer::after, .portfolio__cell:not(:last-child)::after, .portfolio__row:last-child::after, .portfolio__row::before, .portfolio__body::after, .portfolio__head::after, .portfolio__container::before, .project-interiors__body::before, .project-interiors__body::after, .project-interiors__container::before, .project-layout__slider::after, .project-layout__head::after, .project-layout__content::before, .project-layout__content::after, .project-layout__container::before, .project-layout__container::after, .project-info__body::before, .project-info__body::after, .project-info__container::before, .hero-project__container::before, .image-text__body::before, .image-text__head::before, .image-text__head::after, .image-text__text-wrap::after, .image-text__container::before, .projects__body::before, .projects__body::after, .projects__tabs-wrapper::before, .projects__tabs-wrapper::after, .projects__container::before, .our-team__slider::before, .our-team__slider::after, .our-team__container::before, .projects-page .request__content::after, .contacts-page .request__content::after, .contacts-page .request__content::before, .request__image-wrap::before, .request__container::after, .request__container::before, .team__body::after, .team__head::after, .team__container::before, .team__container::after, .privileges__row:not(:last-child)::after, .privileges__cards::after, .privileges__image-wrap::after, .privileges__head::after, .privileges__container::after, .privileges__container::before, .card-services::before, .card-services::after, .services__container::after, .about-company__column:first-child::after, .about-company__head::after, .about-company__text-wrap::before, .about-company__text-wrap::after, .about-company__container::after, .hero__info-txt::after, .about-company-page .hero__title::after, .hero__text-wrap::before, .hero__text-wrap::after, .hero__container::before, .footer__container::after, .footer::after, .section-footer::before, .section-footer::after, .tab__text::after {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  height: 100%;\n  background-color: #505050;\n  transform-origin: left top;\n}\n\n.swiper-slide.hero-portfolio__slide {\n  opacity: 0 !important;\n  visibility: hidden !important;\n}\n.swiper-slide-active.hero-portfolio__slide {\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\nbody {\n  position: relative;\n}\nbody::after {\n  content: \"\";\n  position: fixed;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(4rem);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n@media (max-width: 48em) {\n  .menu-open body::after {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.main {\n  position: relative;\n}\n@media (max-width: 48em) {\n  .main::before {\n    content: \"\";\n    position: fixed;\n    z-index: 100;\n    width: 100%;\n    height: 16.4rem;\n    top: 0;\n    left: 0;\n    background-color: rgba(255, 255, 255, 0.05);\n    backdrop-filter: blur(4.6rem);\n    transition: transform 0.3s ease;\n  }\n  ._header-scroll .main::before {\n    transform: translateY(-110%);\n  }\n  ._header-show .main::before {\n    transform: translateY(0);\n  }\n  .menu-open .main::before {\n    transform: translateY(-110%);\n  }\n}\n\n.sidebar {\n  position: absolute;\n  z-index: 100;\n  top: 0;\n  left: auto;\n  padding: 3.6rem 2.3rem 9rem 2.3rem;\n  height: 100%;\n  background-color: rgba(106, 106, 106, 0.2);\n  backdrop-filter: blur(1.9rem);\n}\n@media (max-width: 48em) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    padding: 4rem 0;\n    width: 100%;\n    height: 16.4rem;\n    background-color: transparent;\n    backdrop-filter: blur(0);\n    transition: all 0.3s ease;\n  }\n  ._header-scroll .sidebar {\n    transform: translateY(-110%);\n  }\n  ._header-show .sidebar {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 48em) {\n  .sidebar {\n    position: fixed;\n    width: 15rem;\n    transition: width 0.4s ease;\n  }\n  .menu-open .sidebar {\n    width: 30.7rem;\n  }\n}\n.sidebar__inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n}\n@media (min-width: 48em) {\n  .sidebar__inner {\n    flex-direction: column;\n  }\n}\n@media (max-width: 48em) {\n  .sidebar__inner {\n    padding: 0 3.2rem;\n  }\n}\n.sidebar__logo-wrap {\n  width: 10.4rem;\n}\n@media (max-width: 48em) {\n  .sidebar__logo-wrap {\n    position: relative;\n    z-index: 105;\n    width: 13.6rem;\n  }\n}\n@media (min-width: 48em) {\n  .sidebar__logo-wrap {\n    margin-bottom: 8.6rem;\n  }\n}\n.sidebar__logo {\n  object-fit: contain;\n}\n.sidebar__socials {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 1.9rem;\n}\n@media (max-width: 48em) {\n  .sidebar__socials {\n    margin-bottom: 2rem;\n    flex-direction: row;\n    column-gap: 5rem;\n  }\n}\n@media (min-width: 48em) {\n  .sidebar__socials-item._mobile-only {\n    display: none;\n  }\n}\n.sidebar__socials-link {\n  display: inline-block;\n  width: 3.2rem;\n}\n@media (max-width: 48em) {\n  .sidebar__socials-link {\n    width: 6rem;\n  }\n}\n.sidebar__socials-icon {\n  object-fit: contain;\n}\n.sidebar__tel {\n  font-family: Assistant;\n  opacity: 0;\n  visibility: hidden;\n  white-space: nowrap;\n  transition: all 0.4s ease;\n}\n.menu-open .sidebar__tel {\n  opacity: 1;\n  visibility: visible;\n}\n@media (max-width: 48em) {\n  .sidebar__tel {\n    margin-bottom: 5rem;\n  }\n  .sidebar__tel.txt, .sidebar__tel.input__field {\n    font-size: 6rem;\n    font-weight: 700;\n  }\n}\n\n.hamburger {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 0.6rem;\n  width: 3.4rem;\n}\n.hamburger::before, .hamburger::after {\n  content: \"\";\n}\n.hamburger::before, .hamburger::after,\n.hamburger span {\n  width: 100%;\n  height: 0.2rem;\n  background-color: #ffffff;\n}\n.hamburger span {\n  transform: scaleX(0.7);\n  transition: transform 0.4s ease;\n}\n@media (max-width: 48em) {\n  .hamburger {\n    row-gap: 1.2rem;\n    width: 6.5rem;\n  }\n  .hamburger::before, .hamburger::after,\n  .hamburger span {\n    height: 0.4rem;\n    transition: all 0.3s ease;\n  }\n  .menu-open .hamburger {\n    position: absolute;\n  }\n  .menu-open .hamburger::before, .menu-open .hamburger::after,\n  .menu-open .hamburger span {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n@media (min-width: 48em) {\n  .hamburger {\n    transition: all 0.3s ease;\n  }\n  .menu-open .hamburger {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n.menu {\n  position: relative;\n}\n@media (min-width: 48em) {\n  .menu {\n    display: flex;\n    align-items: center;\n    flex: 1 1 auto;\n  }\n}\n@media (any-hover: hover) {\n  .menu__hamburger-wrap:hover .hamburger span {\n    transform: scaleX(0.99);\n  }\n}\n@media (max-width: 48em) {\n  .menu__hamburger-wrap {\n    position: relative;\n    z-index: 105;\n    display: flex;\n    align-items: center;\n  }\n  .menu__hamburger-wrap::after {\n    content: \"\";\n    position: absolute;\n    width: 6.5rem;\n    height: 6.5rem;\n    background-image: url(./assets/images/icons/cross.svg);\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n  }\n  .menu-open .menu__hamburger-wrap::after {\n    position: static;\n    opacity: 1;\n    visibility: visible;\n  }\n}\n@media (min-width: 48em) {\n  .menu__hamburger-wrap {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 1.6rem;\n    transform: translate(-50%, -50%);\n  }\n  .menu-open .menu__hamburger-wrap {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n.menu__hamburger-txt {\n  text-transform: uppercase;\n  color: #ffffff;\n}\n.menu__body {\n  opacity: 0;\n  visibility: hidden;\n}\n@media (max-width: 48em) {\n  .menu__body {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding-top: 40rem;\n    padding-bottom: 12rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100vh;\n    overflow: auto;\n  }\n}\n.menu-open .menu__body {\n  opacity: 1;\n  visibility: visible;\n}\n.menu__list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 4.8rem;\n  text-align: center;\n}\n@media (max-width: 48em) {\n  .menu__list {\n    margin-bottom: 39.6rem;\n    row-gap: 6.4rem;\n  }\n}\n.menu__link, .footer__navigation-link {\n  position: relative;\n  text-transform: uppercase;\n}\n.menu__link::after, .footer__navigation-link::after {\n  content: \"\";\n  position: absolute;\n  bottom: -0.3rem;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background-color: #ffffff;\n  opacity: 0;\n  transform: scaleX(0);\n  transform-origin: center;\n  transition: all 0.5s ease;\n}\n@media (any-hover: hover) {\n  .menu__link:hover::after, .footer__navigation-link:hover::after {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n@media (max-width: 48em) {\n  .menu__link, .footer__navigation-link {\n    font-size: 4rem;\n  }\n}\n\n.nav-btn {\n  flex: 0 0 6rem;\n  width: 6rem;\n  height: 6rem;\n  border-radius: 50%;\n}\n.nav-btn svg {\n  width: 6rem;\n  height: 6rem;\n  transition: fill 0.4s ease;\n}\n.nav-btn svg path {\n  transition: stroke 0.4s ease;\n}\n@media (any-hover: hover) {\n  .nav-btn:hover svg {\n    fill: #ffffff;\n  }\n  .nav-btn:hover svg path {\n    stroke: #1a1a1a;\n  }\n}\n@media (max-width: 48em) {\n  .nav-btn {\n    flex: 0 0 8rem;\n    width: 8rem;\n    height: 8rem;\n  }\n  .nav-btn svg {\n    width: 8rem;\n    height: 8rem;\n  }\n}\n\n.sl-fraction {\n  display: flex;\n  align-items: center;\n  column-gap: 5rem;\n}\n.sl-fraction__progress {\n  display: none;\n}\n@media (min-width: 48em) {\n  .sl-fraction__progress {\n    position: relative;\n    display: block;\n    flex: 0 0 36.8rem;\n    width: 36.8rem;\n    height: 2px;\n    background-color: rgba(255, 255, 255, 0.6);\n  }\n  .sl-fraction__progress::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    top: 0;\n    left: 0;\n    background-color: #ffffff;\n    transform-origin: left;\n    transform: scaleX(var(--progress));\n  }\n}\n.sl-fraction__content {\n  white-space: nowrap;\n}\n\n.tab {\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.3s ease;\n}\n.tab._active .tab__text {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.tab._active .tab__text::after {\n  opacity: 0;\n}\n@media (max-width: 48em) {\n  .tab {\n    border-top: 2px solid rgba(255, 255, 255, 0.2);\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n    border-right: 2px solid rgba(255, 255, 255, 0.2);\n  }\n  .tab_fc {\n    border-left: 2px solid rgba(255, 255, 255, 0.2);\n  }\n}\n.tab__text {\n  position: relative;\n  padding: 3.2rem 3.8rem;\n  width: 100%;\n  text-align: center;\n  text-transform: uppercase;\n  transition: all 0.3s ease;\n}\n.tab__text::after {\n  top: 0;\n  right: 0;\n  height: 100%;\n  transition: opacity 0.3s ease;\n}\n@media (max-width: 48em) {\n  .tab__text {\n    padding: 2.8rem 4rem;\n  }\n  .tab__text::after {\n    display: none;\n  }\n  .tab__text.txt, .tab__text.input__field {\n    font-size: 2.8rem;\n  }\n}\n\n.image-gradient {\n  position: relative;\n}\n.image-gradient::after {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, rgba(36, 36, 36, 0) 0%, rgb(36, 36, 36) 100%);\n  opacity: var(--opacity);\n  transform: var(--x);\n}\n\n.section-footer::before, .section-footer::after {\n  left: 0;\n  width: 100%;\n  height: 2px;\n}\n.section-footer::before {\n  top: 0;\n}\n.section-footer::after {\n  bottom: 0;\n}\n@media (max-width: 48em) {\n  .section-footer {\n    position: relative;\n    padding: 3.2rem 0;\n  }\n}\n\n.page-nav {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n.page-nav__num:not(:last-child) {\n  margin-right: 2.4rem;\n}\n.page-nav__num:not(:last-child)._active {\n  margin-right: 12rem;\n}\n.page-nav__num:not(.page-nav__num._active) {\n  color: #9a9a9a;\n}\n@media (max-width: 48em) {\n  .page-nav__num:not(:last-child) {\n    margin-right: 1rem;\n  }\n  .page-nav__num:not(:last-child)._active {\n    margin-right: 5rem;\n  }\n}\n\n.tl1 {\n  font-size: 5.4rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.2rem;\n  line-height: 130%;\n}\n@media (max-width: 48em) {\n  .tl1 {\n    font-size: 6rem;\n  }\n}\n\n.tl2 {\n  font-size: 3rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  line-height: 120%;\n  letter-spacing: 0.1rem;\n}\n@media (max-width: 48em) {\n  .tl2 {\n    font-size: 4.2rem;\n  }\n}\n\n.tl3 {\n  font-size: 2.6rem;\n  font-weight: 600;\n}\n@media (max-width: 48em) {\n  .tl3 {\n    font-size: 4rem;\n  }\n}\n\n.reg {\n  font-weight: 400;\n}\n\n.txt, .input__field {\n  font-family: Gilroy;\n  line-height: 130%;\n}\n@media (max-width: 48em) {\n  .txt, .input__field {\n    font-size: 3.2rem;\n  }\n}\n.txt_16 {\n  font-size: 1.6rem;\n}\n@media (max-width: 48em) {\n  .txt_16 {\n    font-size: 3.2rem;\n  }\n}\n.txt_18 {\n  font-size: 1.8rem;\n}\n@media (max-width: 48em) {\n  .txt_18 {\n    font-size: 3.2rem;\n  }\n}\n\n.grid {\n  display: grid;\n}\n@media (min-width: 48em) {\n  .grid {\n    grid-template-columns: 15rem 1fr;\n  }\n}\n\n@media (max-width: 48em) {\n  .desktop-only {\n    display: none;\n  }\n}\n\n@media (min-width: 48em) {\n  .mobile-only {\n    display: none;\n  }\n}\n\n.footer {\n  position: relative;\n  margin-bottom: 2.8rem;\n}\n.footer::after {\n  bottom: 0;\n  left: 2px;\n  width: 100%;\n  height: 2px;\n}\n.scroll-trigger .footer::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (max-width: 48em) {\n  .footer {\n    margin: 0;\n    padding: 0 3.2rem;\n  }\n  .footer::after {\n    display: none;\n  }\n}\n.footer__container {\n  padding: 8.8rem 0 8rem 3rem;\n  display: flex;\n  flex-direction: column;\n}\n.footer__container::after {\n  left: 0;\n  top: -18rem;\n  height: calc(100% + 18rem + 2.8rem);\n}\n.scroll-trigger .footer__container::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .footer__container {\n    position: relative;\n    grid-column: 2/3;\n    row-gap: 6.4rem;\n  }\n}\n@media (max-width: 48em) {\n  .footer__container {\n    padding: 3.2rem 0 6rem 0;\n    border-top: 2px solid rgba(255, 255, 255, 0.2);\n  }\n  .footer__container::after {\n    display: none;\n  }\n}\n.footer__row {\n  display: flex;\n  justify-content: space-between;\n}\n@media (max-width: 48em) {\n  .footer__row_upper {\n    margin-bottom: 6.4rem;\n  }\n}\n@media (max-width: 48em) {\n  .footer__row_lower {\n    margin-bottom: 8rem;\n    flex-direction: column;\n  }\n}\n.footer__contacts {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.6rem;\n}\n@media (min-width: 48em) {\n  .footer__contacts {\n    align-items: flex-start;\n    row-gap: 0.8rem;\n  }\n}\n.footer__tel {\n  font-family: Assistant;\n}\n@media (max-width: 48em) {\n  .footer__tel {\n    font-size: 700;\n  }\n}\n.footer__mail {\n  font-size: 2.4rem;\n  color: #9a9a9a;\n}\n@media (max-width: 48em) {\n  .footer__mail {\n    font-size: 3.2rem;\n  }\n}\n.footer__socials {\n  display: flex;\n  align-items: center;\n  align-self: flex-start;\n  column-gap: 3rem;\n}\n@media (max-width: 48em) {\n  .footer__socials {\n    column-gap: 6rem;\n  }\n}\n.footer__socials-link {\n  display: inline-block;\n  width: 5rem;\n}\n@media (max-width: 48em) {\n  .footer__socials-link {\n    width: 7rem;\n  }\n}\n.footer__socials-icon {\n  object-fit: contain;\n}\n.footer__address {\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.8rem;\n}\n@media (max-width: 48em) {\n  .footer__address {\n    margin-bottom: 9rem;\n    row-gap: 1.6rem;\n  }\n}\n.footer__address-text {\n  color: #9a9a9a;\n}\n@media (min-width: 48em) {\n  .footer__navigation {\n    align-self: flex-end;\n  }\n}\n.footer__navigation-list {\n  display: flex;\n  column-gap: 4.8rem;\n}\n@media (max-width: 48em) {\n  .footer__navigation-list {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 5rem;\n    row-gap: 5rem;\n  }\n}\n.footer__navigation-link {\n  font-size: 1.6rem;\n}\n@media (max-width: 48em) {\n  .footer__navigation-link {\n    font-size: 3.2rem;\n  }\n}\n\n.hero {\n  position: relative;\n  margin-bottom: 18rem;\n}\n@media (max-width: 48em) {\n  .about-company-page .hero {\n    margin-bottom: 28rem;\n  }\n}\n.hero__container {\n  position: relative;\n  z-index: 2;\n  display: grid;\n  height: 100%;\n}\n.hero__container::before {\n  top: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.scroll-trigger .hero__container::before {\n  transform: scaleY(var(--scaleY));\n}\n.mainpage .hero__container::before {\n  display: none;\n}\n@media (max-width: 48em) {\n  .hero__container {\n    padding: 22.7rem 3.2rem 6.4rem 3.2rem;\n    row-gap: 26.2rem;\n  }\n  .projects-page .hero__container {\n    padding: 63.4rem 3.2rem 0 3.2rem;\n    row-gap: normal;\n  }\n  .about-company-page .hero__container {\n    padding: 0;\n    row-gap: normal;\n    height: auto;\n  }\n  .about-company-page .hero__container::before {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .hero__container {\n    grid-template-columns: 6fr 5fr;\n  }\n  .about-company-page .hero__container {\n    grid-template-columns: 62.2rem 1fr;\n  }\n}\n@media (min-width: 48em) {\n  .hero__body {\n    grid-column: 2/3;\n    min-height: 100rem;\n  }\n}\n.hero__text-wrap {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  height: 100%;\n}\n.about-company-page .hero__text-wrap {\n  padding-top: 39.8rem;\n  justify-content: flex-start;\n}\n.hero__text-wrap::before, .hero__text-wrap::after {\n  top: 0;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.scroll-trigger .hero__text-wrap::before, .scroll-trigger .hero__text-wrap::after {\n  transform: scaleY(var(--scaleY));\n}\n.hero__text-wrap::before {\n  left: 0;\n}\n.hero__text-wrap::after {\n  right: -2.5rem;\n}\n.about-company-page .hero__text-wrap::after {\n  right: 0;\n}\n@media (min-width: 48em) {\n  .hero__text-wrap {\n    padding: 5rem 0 8.8rem 3rem;\n  }\n}\n@media (max-width: 48em) {\n  .projects-page .hero__text-wrap {\n    margin-bottom: 26rem;\n    justify-content: flex-start;\n    height: auto;\n  }\n  .about-company-page .hero__text-wrap {\n    padding: 0 3.2rem;\n  }\n  .hero__text-wrap::before, .hero__text-wrap::after {\n    display: none;\n  }\n}\n.hero__title {\n  margin-bottom: 3.2rem;\n  display: flex;\n  flex-direction: column;\n}\n.about-company-page .hero__title {\n  position: relative;\n  margin-bottom: 4rem;\n  flex-direction: row;\n  column-gap: 1rem;\n}\n.about-company-page .hero__title::after {\n  left: -49.7rem;\n  bottom: -1.4rem;\n  width: 192rem;\n  height: 2px;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.scroll-trigger .about-company-page .hero__title::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (max-width: 48em) {\n  .hero__title {\n    margin-bottom: 4.8rem;\n  }\n  .about-company-page .hero__title {\n    margin-bottom: 5rem;\n    column-gap: 2rem;\n  }\n  .about-company-page .hero__title::after {\n    display: none;\n  }\n}\n.hero__text {\n  margin-bottom: 3.2rem;\n}\n.about-company-page .hero__text {\n  max-width: 37.5rem;\n}\n@media (max-width: 48em) {\n  .hero__text {\n    margin-bottom: 4.8rem;\n    max-width: 57.8rem;\n  }\n  .about-company-page .hero__text {\n    margin-bottom: 10rem;\n    max-width: 61.5rem;\n  }\n}\n.hero__btn {\n  align-self: flex-start;\n}\n@media (max-width: 48em) {\n  .hero__facts {\n    order: -1;\n  }\n}\n@media (min-width: 48em) {\n  .hero__facts {\n    padding-top: 5rem;\n  }\n}\n.hero__slider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n}\n.hero__slider.swiper {\n  overflow: visible;\n}\n.hero__slide {\n  position: relative;\n}\n.hero__slide .hero__slide-text {\n  display: none;\n}\n.hero__slide.swiper-slide {\n  opacity: 0 !important;\n  visibility: hidden !important;\n}\n.hero__slide.swiper-slide-active {\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n@media (max-width: 48em) {\n  .hero__slide {\n    padding: 65rem 0 6.4rem 0;\n  }\n  .hero__slide .hero__text-wrap {\n    position: relative;\n    z-index: 2;\n    margin-bottom: 26rem;\n    justify-content: flex-start;\n    height: auto;\n  }\n}\n.hero__video-wrap, .hero__bg-image {\n  z-index: -1;\n  top: 0;\n  width: 192rem;\n  height: 100%;\n}\n.hero__video-wrap::after, .hero__bg-image::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(70deg, rgba(46, 46, 46, 0.2) 20.45%, rgba(0, 0, 0, 0) 63.6%), linear-gradient(0deg, rgba(70, 74, 80, 0.2) 0%, rgba(70, 74, 80, 0.2) 100%);\n}\n@media (max-width: 48em) {\n  .hero__video-wrap, .hero__bg-image {\n    left: 0;\n  }\n}\n.hero__video-wrap {\n  position: absolute;\n  left: 0;\n}\n.hero__video-wrap video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.hero__bg-image {\n  position: absolute;\n  left: -30.7rem;\n  display: flex;\n}\n.about-company-page .hero__bg-image {\n  left: 0;\n}\n.about-company-page .hero__bg-image::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(70deg, rgba(46, 46, 46, 0.2) 20.45%, rgba(0, 0, 0, 0) 63.6%), linear-gradient(0deg, rgba(70, 74, 80, 0.2) 0%, rgba(70, 74, 80, 0.2) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%);\n}\n.hero__bg-image picture {\n  display: flex;\n  width: 100%;\n}\n@media (max-width: 48em) {\n  .hero__bg-image {\n    top: -16.4rem;\n    left: -3.2rem;\n    width: calc(100% + 6.4rem);\n    height: calc(16.4rem + 100%);\n  }\n  .about-company-page .hero__bg-image {\n    position: relative;\n    margin-bottom: 3.2rem;\n    height: 92.4rem;\n    width: 100%;\n    top: 0;\n    left: 0;\n    transform: none;\n  }\n}\n.hero__image {\n  object-fit: cover;\n}\n.hero__slider-control {\n  z-index: 2;\n  padding-top: 5rem;\n  padding-bottom: 18.1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n.hero__slider-control .hero__text {\n  margin-bottom: 37.8rem;\n  max-width: 23.5rem;\n  text-align: right;\n}\n@media (min-width: 48em) {\n  .hero__slider-control {\n    padding-left: 2.5rem;\n  }\n}\n@media (max-width: 48em) {\n  .hero__slider-control {\n    position: static;\n    padding: 0;\n    display: block;\n    width: 0;\n    height: 0;\n  }\n  .hero__slider-control .hero__text {\n    position: absolute;\n    top: 22.8rem;\n    right: 3.2rem;\n    margin: 0;\n    max-width: 35.4rem;\n  }\n}\n.hero__slider-nav {\n  display: flex;\n  align-items: center;\n  column-gap: 1.6rem;\n}\n.hero__slide-text span {\n  display: block;\n}\n.hero__slider-nav-wrap {\n  display: flex;\n  align-items: center;\n  column-gap: 3rem;\n}\n@media (min-width: 48em) {\n  .hero__slider-nav-wrap {\n    margin-bottom: 27rem;\n  }\n}\n@media (max-width: 48em) {\n  .hero__slider-nav-wrap {\n    position: absolute;\n    left: 3.2rem;\n    right: 3.2rem;\n    bottom: 6.4rem;\n    flex-direction: row-reverse;\n    justify-content: space-between;\n    column-gap: 0.8rem;\n  }\n}\n@media (max-width: 48em) {\n  .hero__slider-fraction {\n    position: absolute;\n    right: 3.2rem;\n    bottom: 18rem;\n  }\n}\n.hero__info {\n  position: relative;\n  padding-top: 41.6rem;\n  padding-right: 10rem;\n  display: inline-flex;\n  flex-direction: column;\n  justify-self: flex-end;\n  align-items: flex-end;\n  text-align: right;\n}\n@media (max-width: 48em) {\n  .hero__info {\n    padding: 0 10.2rem 0 0;\n  }\n}\n.hero__info-ellipse {\n  position: absolute;\n  z-index: -1;\n  top: 50%;\n  right: 0;\n  width: 26.9rem;\n  height: 26.9rem;\n  transform: translateY(-50%);\n}\n@media (max-width: 48em) {\n  .hero__info-ellipse {\n    right: 3.2rem;\n    width: 37.4rem;\n    height: 37.4rem;\n  }\n}\n.hero__info-txt {\n  margin-bottom: 5.5rem;\n  max-width: 23.2rem;\n}\n.hero__info-txt::after {\n  right: -10.2rem;\n  bottom: -3.2rem;\n  display: none;\n  width: 100vw;\n  height: 1px;\n}\n@media (max-width: 48em) {\n  .hero__info-txt {\n    position: relative;\n    margin-bottom: 6.4rem;\n    max-width: 46.2rem;\n  }\n  .hero__info-txt::after {\n    display: inline-block;\n  }\n}\n\n.facts-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  align-self: start;\n  justify-self: end;\n  row-gap: 4.8rem;\n}\n@media (max-width: 48em) {\n  .facts-hero {\n    row-gap: 6.4rem;\n  }\n}\n.facts-hero__item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  row-gap: 0.8rem;\n  text-align: right;\n}\n.facts-hero__heading {\n  font-family: Assistant;\n}\n@media (max-width: 48em) {\n  .facts-hero__heading {\n    font-size: 4rem;\n  }\n}\n.facts-hero__text {\n  letter-spacing: 0.05rem;\n  color: #9a9a9a;\n}\n@media (max-width: 48em) {\n  .facts-hero__text {\n    color: rgba(255, 255, 255, 0.6);\n  }\n}\n\n.about-company {\n  margin-bottom: 18rem;\n}\n.about-company__container {\n  position: relative;\n  display: grid;\n}\n.about-company__container::after {\n  bottom: 0;\n  width: 161rem;\n  height: 2px;\n}\n.scroll-trigger .about-company__container::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (max-width: 48em) {\n  .about-company__container {\n    padding: 0 3.2rem;\n  }\n  .about-company__container::after {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .about-company__container {\n    grid-template-columns: 6fr 5fr;\n    grid-column: 2/3;\n  }\n}\n.about-company__text-wrap {\n  position: relative;\n  display: grid;\n}\n.about-company__text-wrap::before, .about-company__text-wrap::after {\n  top: -18rem;\n  height: calc(100% + 18rem - 2px);\n}\n.scroll-trigger .about-company__text-wrap::before, .scroll-trigger .about-company__text-wrap::after {\n  transform: scaleY(var(--scaleY));\n}\n.about-company__text-wrap::before {\n  left: 0;\n}\n.about-company__text-wrap::after {\n  right: -2.5rem;\n}\n@media (max-width: 48em) {\n  .about-company__text-wrap::before, .about-company__text-wrap::after {\n    display: none;\n  }\n}\n.about-company__head {\n  position: relative;\n  padding: 0 2.6rem 2rem 3rem;\n  display: flex;\n  align-items: flex-end;\n}\n.about-company__head::after {\n  left: 2px;\n  bottom: 0;\n  width: calc(100% + 2.5rem - 4px);\n  height: 2px;\n}\n.scroll-trigger .about-company__head::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (max-width: 48em) {\n  .about-company__head {\n    padding: 0 0 3.2rem 0;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  }\n  .about-company__head::after {\n    display: none;\n  }\n}\n.about-company__body {\n  display: grid;\n}\n@media (min-width: 48em) {\n  .about-company__body {\n    grid-template-columns: 4fr 2fr;\n    min-height: 54.8rem;\n  }\n}\n@media (max-width: 48em) {\n  .about-company__body {\n    margin-bottom: 3.2rem;\n  }\n}\n.about-company__column {\n  padding: 3.2rem;\n  display: flex;\n  flex-direction: column;\n}\n.about-company__column:first-child::after {\n  right: 0;\n  top: 0;\n}\n.scroll-trigger .about-company__column:first-child::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .about-company__column {\n    position: relative;\n    margin-bottom: 2px;\n  }\n}\n@media (max-width: 48em) {\n  .about-company__column {\n    padding: 3.2rem 0;\n    row-gap: 2rem;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  }\n  .about-company__column:first-child::after {\n    display: none;\n  }\n}\n.about-company__txt-wrap {\n  row-gap: 1rem;\n}\n.about-company__link {\n  align-self: flex-start;\n}\n@media (min-width: 48em) {\n  .about-company__link {\n    margin-top: auto;\n    align-self: center;\n  }\n}\n.about-company__image-wrap {\n  width: 100%;\n  height: 52.8rem;\n}\n@media (min-width: 48em) {\n  .about-company__image-wrap {\n    width: calc(100% + 23.2rem);\n    height: 63.8rem;\n    align-self: end;\n    transform: translate(6rem, -3.4rem);\n    transform: translate(6rem, -3.4rem);\n  }\n}\n.about-company__image {\n  height: 100%;\n  object-fit: cover;\n}\n\n.services {\n  margin-bottom: 18rem;\n}\n.scroll-trigger .services {\n  --l1: 0;\n  --l2: 0;\n  --l3: 0;\n}\n.services__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.services__container::after {\n  bottom: 0;\n  left: 2px;\n  height: 2px;\n  width: calc(161rem - 2px);\n}\n.scroll-trigger .services__container::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .services__container {\n    grid-column: 2/3;\n  }\n}\n@media (max-width: 48em) {\n  .services__container {\n    padding: 0 3.2rem;\n  }\n  .services__container::after {\n    display: none;\n  }\n}\n.services__head {\n  position: relative;\n  margin-bottom: 2.4rem;\n  padding-left: 3rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  height: 6.5rem;\n}\n@media (max-width: 48em) {\n  .services__head {\n    margin-bottom: 3.2rem;\n    padding: 0;\n  }\n}\n.services__btn {\n  min-width: 20.5rem;\n}\n@media (max-width: 48em) {\n  .services__btn {\n    display: none;\n  }\n}\n.services__body {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 48em) {\n  .services__body {\n    row-gap: 9.8rem;\n  }\n}\n.card-services {\n  position: relative;\n  display: grid;\n}\n.card-services::after {\n  top: 0;\n  left: 0;\n}\n.scroll-trigger .card-services::after {\n  transform: scaleY(var(--scaleY));\n}\n.card-services::before {\n  top: 0;\n  left: 2px;\n  width: 161rem;\n  height: 2px;\n}\n.scroll-trigger .card-services::before {\n  transform: scaleX(var(--scaleX));\n}\n.card-services:first-child::after {\n  top: -26.9rem;\n  height: calc(100% + 26.9rem);\n}\n.scroll-trigger .card-services:first-child::after {\n  transform: scaleY(var(--scaleY));\n}\n.card-services:not(.card-services_reversed) .card-services__image {\n  transform: translateX(2px);\n}\n@media (min-width: 48em) {\n  .card-services {\n    grid-template-columns: 62.2rem 1fr;\n  }\n  .card-services_reversed {\n    grid-template-columns: 1fr 62.2rem;\n  }\n  .card-services_reversed .card-services__image-wrap {\n    justify-self: end;\n    grid-column: 2/3;\n  }\n  .card-services_reversed .card-services__text-wrap {\n    padding-left: 16.3rem;\n    grid-column: 1/2;\n    grid-row: 1/2;\n  }\n  .card-services_reversed .card-services__num {\n    left: 3rem;\n  }\n}\n@media (max-width: 48em) {\n  .card-services {\n    padding-bottom: 3.2rem;\n    row-gap: 8rem;\n  }\n  .card-services::before {\n    top: auto;\n    bottom: 0;\n    width: 100%;\n  }\n  .card-services:last-child::after {\n    display: none;\n  }\n}\n.card-services__image-wrap {\n  position: relative;\n  min-height: 50rem;\n  overflow: hidden;\n}\n@media (max-width: 48em) {\n  .card-services__image-wrap {\n    min-height: none;\n    height: 40rem;\n  }\n}\n.card-services__image {\n  height: 100%;\n  object-fit: cover;\n}\n.card-services__text-wrap {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n@media (min-width: 48em) {\n  .card-services__text-wrap {\n    padding-left: 20.3rem;\n    justify-content: center;\n    align-self: center;\n    height: 100%;\n  }\n}\n.card-services__heading {\n  margin-bottom: 2.4rem;\n}\n@media (max-width: 48em) {\n  .card-services__heading {\n    margin-bottom: 3.2rem;\n  }\n}\n.card-services__text {\n  max-width: 56.9rem;\n}\n@media (max-width: 48em) {\n  .card-services__text {\n    max-width: 68rem;\n  }\n}\n.card-services__num {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 7rem;\n  font-family: Assistant;\n  font-size: 22.4rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  line-height: 129%;\n  color: rgba(255, 255, 255, 0.1);\n}\n@media (max-width: 48em) {\n  .card-services__num {\n    top: -12rem;\n    left: -5.4rem;\n    font-size: 18rem;\n  }\n}\n\n.privileges {\n  margin-bottom: 18rem;\n}\n.privileges__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.privileges__container::before {\n  top: -18rem;\n  height: calc(100% + 18rem - 2px);\n}\n.scroll-trigger .privileges__container::before {\n  transform: scaleY(var(--scaleY));\n}\n.privileges__container::after {\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  width: 161rem;\n}\n.scroll-trigger .privileges__container::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .privileges__container {\n    grid-column: 2/3;\n  }\n}\n@media (max-width: 48em) {\n  .privileges__container::before {\n    display: none;\n  }\n}\n.privileges__head {\n  position: relative;\n  padding-left: 3rem;\n  padding-bottom: 2.4rem;\n}\n.privileges__head::after {\n  bottom: 0;\n  left: 2px;\n  width: 161rem;\n  height: 2px;\n}\n.scroll-trigger .privileges__head::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (max-width: 48em) {\n  .privileges__head {\n    margin-bottom: 3.2rem;\n    padding-left: 0;\n    padding-bottom: 3.2rem;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  }\n  .privileges__head::after {\n    display: none;\n  }\n}\n@media (max-width: 48em) {\n  .privileges__title {\n    display: block;\n    max-width: 50rem;\n  }\n}\n.privileges__body {\n  display: grid;\n}\n@media (min-width: 48em) {\n  .privileges__body {\n    grid-template-columns: 4fr 7fr;\n  }\n}\n.privileges__image-wrap::after {\n  top: 0;\n  right: 0;\n}\n.scroll-trigger .privileges__image-wrap::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .privileges__image-wrap {\n    position: relative;\n    padding: 3.6rem 3rem;\n  }\n}\n@media (max-width: 48em) {\n  .privileges__image-wrap {\n    padding-bottom: 3.2rem;\n    height: 37rem;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  }\n  .privileges__image-wrap::after {\n    display: none;\n  }\n}\n.privileges__image, .privileges__card-image {\n  height: 100%;\n  object-fit: cover;\n}\n.privileges__cards {\n  position: relative;\n  display: grid;\n}\n.privileges__cards::after {\n  top: 0;\n  right: 50%;\n  width: 2px;\n}\n.scroll-trigger .privileges__cards::after {\n  transform: scaleY(var(--scaleY));\n}\n.privileges__row {\n  position: relative;\n  display: grid;\n}\n.privileges__row:not(:last-child)::after {\n  bottom: 0;\n  left: 0;\n  width: calc(50% - 2px);\n  height: 2px;\n}\n.scroll-trigger .privileges__row:not(:last-child)::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .privileges__row {\n    grid-template-columns: repeat(2, 50%);\n  }\n}\n.privileges__card {\n  position: relative;\n  justify-content: center;\n  height: 100%;\n}\n.privileges__card_text {\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n}\n@media (min-width: 48em) {\n  .privileges__card_text {\n    padding: 10.4rem 3rem;\n  }\n}\n@media (max-width: 48em) {\n  .privileges__card {\n    padding: 3.2rem 0;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  }\n  .privileges__card::before, .privileges__card::after {\n    display: none;\n  }\n}\n.privileges__card_img {\n  width: calc(100% + 23.2rem);\n  height: 34.7rem;\n  transform: translateY(-2px);\n}\n@media (max-width: 48em) {\n  .privileges__card_img {\n    display: none;\n  }\n}\n.privileges__heading {\n  margin-bottom: 2.4rem;\n}\n@media (max-width: 48em) {\n  .privileges__heading {\n    margin-bottom: 1.6rem;\n  }\n}\n@media (min-width: 48em) {\n  .privileges__text {\n    max-width: 32.4rem;\n  }\n}\n\n.team {\n  margin-bottom: 18rem;\n}\n.team__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.team__container::before, .team__container::after {\n  top: -18rem;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .team__container::before, .scroll-trigger .team__container::after {\n  transform: scaleY(var(--scaleY));\n}\n.team__container::before {\n  right: 63.2rem;\n}\n.team__container::after {\n  left: 0;\n}\n.scroll-trigger .team__container::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .team__container {\n    grid-column: 2/3;\n  }\n}\n@media (max-width: 48em) {\n  .team__container {\n    padding: 0 3.2rem;\n  }\n  .team__container::before, .team__container::after {\n    display: none;\n  }\n}\n.team__head {\n  position: relative;\n}\n.team__head::after {\n  bottom: 0;\n  left: 2px;\n  width: 161rem;\n  height: 2px;\n}\n.scroll-trigger .team__head::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .team__head {\n    padding-left: 3rem;\n    padding-bottom: 2.4rem;\n  }\n}\n@media (max-width: 48em) {\n  .team__head {\n    margin-bottom: 3.2rem;\n  }\n  .team__head::after {\n    display: none;\n  }\n}\n.team__title {\n  font-family: Assistant;\n}\n.team__body {\n  position: relative;\n  display: grid;\n}\n.team__body::after {\n  bottom: 0;\n  left: 0;\n  width: 161rem;\n  height: 2px;\n}\n.scroll-trigger .team__body::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .team__body {\n    grid-template-columns: 6fr 63.2rem;\n  }\n}\n@media (max-width: 48em) {\n  .team__body::after {\n    display: none;\n  }\n}\n.team__content {\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 48em) {\n  .team__content {\n    padding: 3rem;\n  }\n}\n.team__info {\n  display: flex;\n  justify-content: space-between;\n}\n@media (min-width: 48em) {\n  .team__info {\n    margin-bottom: 40rem;\n    max-width: 66.3rem;\n  }\n}\n@media (max-width: 48em) {\n  .team__info {\n    padding-bottom: 3rem;\n    justify-content: flex-start;\n    column-gap: 16rem;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  }\n}\n.team__group {\n  display: flex;\n  flex-direction: column;\n}\n.team__group-heading {\n  text-transform: uppercase;\n}\n.team__group-txt {\n  color: #9a9a9a;\n}\n@media (max-width: 48em) {\n  .team__text {\n    padding: 3rem 0;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  }\n}\n@media (min-width: 48em) {\n  .team__image-wrap {\n    padding: 3rem 0 3rem 3rem;\n    min-height: 70rem;\n    width: calc(100% + 23.2rem);\n  }\n}\n@media (max-width: 48em) {\n  .team__image-wrap {\n    margin-bottom: 3.2rem;\n    height: 58rem;\n    grid-row: 1/2;\n  }\n}\n.team__image {\n  height: 100%;\n  object-fit: cover;\n}\n\n.request {\n  margin-bottom: 18rem;\n}\n.request__container {\n  position: relative;\n  padding: 0 3.2rem;\n  display: grid;\n}\n.request__container::before {\n  left: 0;\n  top: -18rem;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .request__container::before {\n  transform: scaleY(var(--scaleY));\n}\n.request__container::after {\n  bottom: 0;\n  left: 2px;\n  width: 161rem;\n  height: 2px;\n}\n.scroll-trigger .request__container::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .request__container {\n    padding: 3rem;\n    grid-column: 2/3;\n    grid-template-columns: 5fr 6fr;\n  }\n}\n@media (max-width: 48em) {\n  .request__container::before, .request__container::after {\n    display: none;\n  }\n}\n.request__image-wrap::before {\n  top: -3rem;\n  left: calc(2px - 3rem);\n  width: 161rem;\n  height: 2px;\n}\n.scroll-trigger .request__image-wrap::before {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .request__image-wrap {\n    position: relative;\n    min-height: 54.2rem;\n  }\n}\n@media (max-width: 48em) {\n  .request__image-wrap {\n    margin-bottom: 3.2rem;\n    height: 39rem;\n  }\n  .request__image-wrap::before {\n    display: none;\n  }\n}\n.request__image {\n  height: 100%;\n  object-fit: cover;\n}\n.request__content {\n  display: flex;\n  flex-direction: column;\n}\n.contacts-page .request__content {\n  position: relative;\n}\n.contacts-page .request__content::before {\n  top: -21rem;\n  right: calc(69.8rem - 2px);\n  height: calc(100% + 6rem + 18rem);\n}\n.contacts-page .request__content::after {\n  top: -21rem;\n  right: -3rem;\n  height: calc(100% + 6rem + 18rem);\n}\n.projects-page .request__content {\n  position: relative;\n}\n.projects-page .request__content::after {\n  top: -21rem;\n  right: 0;\n  height: calc(100% + 24rem - 2px);\n}\n.scroll-trigger .projects-page .request__content::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .request__content {\n    padding-left: 15.6rem;\n  }\n}\n@media (max-width: 48em) {\n  .contacts-page .request__content::before, .contacts-page .request__content::after {\n    display: none;\n  }\n  .projects-page .request__content::after {\n    display: none;\n  }\n}\n.request__text-wrap {\n  margin-bottom: 5.6rem;\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 48em) {\n  .request__text-wrap {\n    margin-bottom: 4.8rem;\n  }\n}\n.request__title {\n  margin-bottom: 2.4rem;\n}\n@media (max-width: 48em) {\n  .request__title {\n    margin-bottom: 3.2rem;\n  }\n}\n.request__form {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 49.9rem;\n}\n@media (max-width: 48em) {\n  .request__form {\n    display: grid;\n    grid-template-columns: repeat(2, auto);\n    column-gap: 2rem;\n    width: 100%;\n  }\n}\n.request__fields {\n  margin-bottom: 5.6rem;\n  display: flex;\n  flex-direction: column;\n  row-gap: 3rem;\n  width: 100%;\n}\n@media (max-width: 48em) {\n  .request__fields {\n    margin-bottom: 4.8rem;\n    grid-column: span 2;\n    row-gap: 4.8rem;\n  }\n}\n.request__btn {\n  min-width: 15.3rem;\n}\n@media (max-width: 48em) {\n  .request__btn {\n    min-width: 24.6rem;\n    order: 1;\n  }\n}\n\n.our-team {\n  margin-bottom: 18rem;\n}\n@media (max-width: 48em) {\n  .our-team {\n    display: none;\n  }\n}\n.our-team__container {\n  display: grid;\n}\n.our-team__container::before {\n  z-index: 3;\n  left: 0;\n  top: -18rem;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .our-team__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .our-team__container {\n    position: relative;\n    grid-template-columns: 6fr 6fr;\n    grid-column: 2/3;\n  }\n}\n@media (max-width: 48em) {\n  .our-team__container::before {\n    display: none;\n  }\n}\n.our-team__text-wrap {\n  position: relative;\n  padding: 3rem;\n  display: flex;\n  flex-direction: column;\n}\n.our-team__text-wrap::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  top: -1%;\n  right: 0;\n  width: calc(161.3rem - 2px);\n  height: 101%;\n  background-color: #242424;\n}\n.our-team__title {\n  position: relative;\n  z-index: 3;\n  margin-bottom: 2.4rem;\n}\n.our-team__text {\n  position: relative;\n  z-index: 3;\n  margin-bottom: 3.2rem;\n}\n.our-team__slider-control {\n  position: relative;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  column-gap: 3rem;\n}\n.our-team__slider-btn {\n  flex: 0 0 5rem;\n  width: 5rem;\n}\n.our-team__slider-btn svg {\n  width: 5rem;\n}\n.our-team__slider {\n  position: relative;\n  padding: 4rem 0;\n  min-width: 0;\n}\n.our-team__slider::before, .our-team__slider::after {\n  z-index: 3;\n  right: calc((31.4rem - 4px) / -2);\n  width: calc(161.3rem - 4px);\n  height: 2px;\n}\n.scroll-trigger .our-team__slider::before, .scroll-trigger .our-team__slider::after {\n  transform: scaleX(var(--scaleX));\n}\n.our-team__slider::before {\n  top: 0;\n}\n.our-team__slider::after {\n  bottom: 0;\n}\n@media (min-width: 48em) {\n  .our-team__slider.swiper {\n    overflow: visible;\n  }\n}\n.slide-our-team {\n  display: flex;\n  flex-direction: column;\n}\n.slide-our-team__image-wrap {\n  margin-bottom: 2.4rem;\n  height: 37.8rem;\n}\n.slide-our-team__image {\n  height: 100%;\n  object-fit: cover;\n}\n.slide-our-team__heading {\n  margin-bottom: 0.4rem;\n}\n.slide-our-team__text {\n  color: #9a9a9a;\n}\n\n.projects {\n  margin-bottom: 18rem;\n}\n.projects__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.projects__container::before {\n  top: -18rem;\n  height: calc(100% + 36rem);\n}\n.scroll-trigger .projects__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .projects__container {\n    grid-column: 2/3;\n  }\n}\n@media (max-width: 48em) {\n  .projects__container {\n    margin-bottom: 2.4rem;\n  }\n  .projects__container::before {\n    display: none;\n  }\n}\n.projects__title {\n  margin-bottom: 1.6rem;\n}\n@media (min-width: 48em) {\n  .projects__title {\n    margin-bottom: 3rem;\n    transform: translateX(3rem);\n  }\n}\n.projects__tabs.swiper {\n  overflow: visible;\n}\n@media (max-width: 48em) {\n  .projects__tabs {\n    margin-bottom: 5rem;\n  }\n}\n.projects__tabs-wrapper {\n  position: relative;\n}\n.projects__tabs-wrapper::before, .projects__tabs-wrapper::after {\n  left: 2px;\n  width: calc(161.3rem - 4px);\n  height: 2px;\n}\n.scroll-trigger .projects__tabs-wrapper::before, .scroll-trigger .projects__tabs-wrapper::after {\n  transform: scaleX(var(--scaleX));\n}\n.projects__tabs-wrapper::before {\n  top: -2px;\n}\n.projects__tabs-wrapper::after {\n  bottom: -2px;\n}\n@media (min-width: 48em) {\n  .projects__tabs-wrapper.swiper-wrapper {\n    display: grid;\n    grid-template-columns: repeat(2, 50%);\n  }\n}\n@media (max-width: 48em) {\n  .projects__tabs-wrapper::before, .projects__tabs-wrapper::after {\n    display: none;\n  }\n}\n.projects__tabs-col {\n  display: flex;\n  justify-content: space-between;\n}\n.projects__tabs-col:first-child {\n  margin-left: 2px;\n}\n@media (max-width: 48em) {\n  .projects__tabs-col {\n    display: none;\n  }\n}\n.scroll-trigger .projects__tab .tab__text::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .projects__tab {\n    flex: 1 1 auto;\n  }\n}\n.projects__body {\n  position: relative;\n  margin-bottom: 9.6rem;\n  display: grid;\n  row-gap: 9.6rem;\n}\n.projects__body::before, .projects__body::after {\n  top: 2px;\n}\n.scroll-trigger .projects__body::before, .scroll-trigger .projects__body::after {\n  transform: scaleY(var(--scaleY));\n}\n.projects__body::before {\n  left: calc(50% - 2px);\n}\n.projects__body::after {\n  right: 0;\n  height: calc(100% + 11.1rem + 18rem);\n}\n@media (max-width: 48em) {\n  .projects__body::before, .projects__body::after {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .projects__body {\n    margin-bottom: 6.2rem;\n    grid-template-columns: repeat(2, 50%);\n    row-gap: 8.6rem;\n  }\n}\n.projects__btn {\n  min-width: 29.6rem;\n  align-self: flex-start;\n}\n@media (min-width: 48em) {\n  .projects__btn {\n    align-self: center;\n    min-width: 18.2rem;\n  }\n}\n\n@media (any-hover: hover) {\n  .card-projects:hover .card-projects__image-wrap {\n    filter: grayscale(1);\n  }\n  .card-projects:hover .card-projects__link {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n@media (min-width: 48em) {\n  .card-projects {\n    padding: 3rem 3rem 0 3rem;\n    user-select: none;\n  }\n}\n.card-projects__inner {\n  display: flex;\n  flex-direction: column;\n}\n.card-projects__image-wrap {\n  margin-bottom: 3.2rem;\n  height: 48rem;\n  width: 100%;\n}\n@media (min-width: 48em) {\n  .card-projects__image-wrap {\n    margin-bottom: 2.4rem;\n    height: 50rem;\n    will-change: contents;\n    transition: filter 0.3s ease;\n  }\n}\n.card-projects__image {\n  height: 100%;\n  object-fit: cover;\n}\n.card-projects__heading-wrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n@media (max-width: 48em) {\n  .card-projects__heading {\n    font-weight: 400;\n  }\n}\n.card-projects__link {\n  opacity: 0;\n  visibility: hidden;\n  transform: translateX(-0.8rem);\n  transition: all 0.3s ease;\n}\n.card-projects__info-wrap {\n  padding: 1.6rem 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n.image-text {\n  margin-bottom: 18rem;\n}\n.image-text__container {\n  position: relative;\n  display: flex;\n  flex-direction: column-reverse;\n}\n.image-text__container::before {\n  top: -18rem;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .image-text__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .image-text__container {\n    display: grid;\n    grid-template-columns: 8fr 2fr;\n    grid-column: 2/3;\n  }\n}\n@media (max-width: 48em) {\n  .image-text__container {\n    margin-bottom: 2.4rem;\n  }\n  .image-text__container::before {\n    display: none;\n  }\n}\n.image-text__text-wrap {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.image-text__text-wrap::after {\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 2px;\n}\n.scroll-trigger .image-text__text-wrap::after {\n  transform: scaleX(var(--scaleX));\n}\n.image-text__head {\n  position: relative;\n}\n.image-text__head::before, .image-text__head::after {\n  left: 0;\n  width: 100%;\n  height: 2px;\n}\n.scroll-trigger .image-text__head::before, .scroll-trigger .image-text__head::after {\n  transform: scaleX(var(--scaleX));\n}\n.image-text__head::before {\n  top: 0;\n}\n.image-text__head::after {\n  bottom: 0;\n}\n@media (min-width: 48em) {\n  .image-text__head {\n    padding: 3.2rem 3rem;\n  }\n}\n@media (max-width: 48em) {\n  .image-text__head {\n    margin-bottom: 3.2rem;\n  }\n  .image-text__head::before, .image-text__head::after {\n    display: none;\n  }\n}\n.image-text__title {\n  display: flex;\n  flex-direction: column;\n}\n.image-text__body {\n  padding: 3.2rem 0;\n  position: relative;\n  display: flex;\n  column-gap: 9.8rem;\n}\n.image-text__body::before {\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 2px;\n}\n.scroll-trigger .image-text__body::before {\n  transform: scaleX(var(--scaleX));\n}\n@media (max-width: 48em) {\n  .image-text__body {\n    flex-direction: column;\n    row-gap: 2rem;\n  }\n}\n@media (min-width: 48em) {\n  .image-text__body {\n    padding: 3.2rem 3rem;\n  }\n  .image-text__body::before {\n    display: none;\n  }\n}\n.image-text__col {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n}\n@media (max-width: 48em) {\n  .image-text__col {\n    row-gap: 2rem;\n  }\n}\n@media (min-width: 48em) {\n  .image-text__text {\n    max-width: 42.5rem;\n  }\n}\n.image-text__image-wrap {\n  height: 37rem;\n}\n@media (min-width: 48em) {\n  .image-text__image-wrap {\n    width: calc(100% + 23.2rem);\n    height: 100%;\n    min-height: 77.1rem;\n  }\n}\n@media (max-width: 48em) {\n  .image-text__image-wrap {\n    margin-bottom: 3.2rem;\n  }\n}\n.image-text__image {\n  height: 100%;\n  object-fit: cover;\n}\n\n.hero-project {\n  margin-bottom: 23.6rem;\n}\n@media (max-width: 48em) {\n  .hero-project {\n    margin-bottom: 18rem;\n  }\n}\n.hero-project__body {\n  position: relative;\n}\n@media (min-width: 48em) {\n  .hero-project__body {\n    grid-column: 2/3;\n  }\n}\n.hero-project__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.hero-project__container::before {\n  top: 0;\n  left: 0;\n}\n.scroll-trigger .hero-project__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (max-width: 48em) {\n  .hero-project__container {\n    padding: 0;\n  }\n  .hero-project__container::before {\n    display: none;\n  }\n}\n.hero-project__grid {\n  display: grid;\n}\n@media (min-width: 48em) {\n  .hero-project__grid {\n    margin-bottom: 1.7rem;\n    grid-template-columns: 4fr 7fr;\n  }\n}\n.hero-project__text-wrap {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n@media (min-width: 48em) {\n  .hero-project__text-wrap {\n    padding: 36.2rem 6.4rem 24.9rem 3rem;\n    height: 100%;\n  }\n}\n.hero-project__title {\n  margin-bottom: 3.2rem;\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 48em) {\n  .hero-project__title {\n    margin-bottom: 2rem;\n    max-width: 40rem;\n  }\n}\n.hero-project__slider-nav {\n  display: flex;\n  align-items: center;\n  gap: 1.6rem;\n}\n@media (max-width: 48em) {\n  .hero-project__slider-nav {\n    flex-direction: column;\n    align-items: flex-end;\n  }\n}\n.hero-project__carousel {\n  width: 100%;\n  overflow: hidden;\n}\n@media (min-width: 48em) {\n  .hero-project__carousel {\n    padding-top: 10rem;\n    width: calc(100% + 129.2rem);\n  }\n  .two-slides .hero-project__carousel {\n    margin-left: 9rem;\n    width: 112rem;\n  }\n  .three-slides .hero-project__carousel {\n    margin-left: 9rem;\n    width: 163rem;\n  }\n}\n@media (max-width: 48em) {\n  .hero-project__carousel {\n    margin-bottom: 3.2rem;\n    order: -1;\n  }\n}\n@media (min-width: 48em) {\n  .hero-project__slide {\n    width: 52rem;\n  }\n  .one-slide .hero-project__slide {\n    width: 100%;\n  }\n}\n.hero-project__bg-image {\n  height: 72.1rem;\n}\n@media (max-width: 48em) {\n  .hero-project__bg-image {\n    height: 91rem;\n  }\n}\n.hero-project__image {\n  height: 100%;\n  object-fit: cover;\n}\n.hero-project__group {\n  display: grid;\n}\n@media (min-width: 48em) {\n  .hero-project__group {\n    padding-left: 3rem;\n    grid-template-columns: 4fr 7fr;\n  }\n}\n@media (max-width: 48em) {\n  .hero-project__group {\n    padding: 0 4rem;\n    grid-template-columns: repeat(2, auto);\n    column-gap: 10rem;\n  }\n}\n.hero-project__group-text-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  row-gap: 3.2rem;\n}\n@media (max-width: 48em) {\n  .hero-project__group-text-wrap {\n    column-gap: 5rem;\n  }\n}\n@media (max-width: 48em) {\n  .hero-project__text {\n    max-width: 45rem;\n  }\n}\n.hero-project__btn {\n  min-width: 20rem;\n}\n@media (max-width: 48em) {\n  .hero-project__btn {\n    min-width: 32.8rem;\n  }\n}\n@media (min-width: 48em) {\n  .hero-project__slider-fraction.sl-fraction {\n    column-gap: 9.8rem;\n  }\n  .hero-project__slider-fraction.sl-fraction .sl-fraction__progress {\n    flex: 1 1 auto;\n    width: 100%;\n  }\n}\n@media (max-width: 48em) {\n  .hero-project__slider-fraction {\n    order: -1;\n  }\n}\n.one-slide .hero-project__slider-control .sl-fraction__progress {\n  display: none;\n}\n@media (max-width: 48em) {\n  .hero-project__slider-control {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    row-gap: 8rem;\n  }\n}\n@media (min-width: 48em) {\n  .hero-project__slider-control {\n    align-self: flex-end;\n  }\n}\n\n.project-info {\n  margin-bottom: 18rem;\n}\n.project-info__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.project-info__container::before {\n  top: -23.6rem;\n  left: 0;\n  height: calc(100% + 23.6rem);\n}\n.scroll-trigger .project-info__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (max-width: 48em) {\n  .project-info__container::before {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .project-info__container {\n    grid-column: 2/3;\n  }\n}\n.project-info__head {\n  padding-bottom: 3.2rem;\n}\n@media (min-width: 48em) {\n  .project-info__head {\n    padding-left: 3rem;\n  }\n}\n.project-info__body {\n  position: relative;\n  padding: 3.2rem 0 0 0;\n  display: grid;\n}\n.project-info__body::before, .project-info__body::after {\n  left: 0;\n  height: 2px;\n  width: 100%;\n}\n.scroll-trigger .project-info__body::before, .scroll-trigger .project-info__body::after {\n  transform: scaleX(var(--scaleX));\n}\n.project-info__body::before {\n  top: 0;\n}\n.project-info__body::after {\n  bottom: 0;\n}\n@media (min-width: 48em) {\n  .project-info__body {\n    padding: 3rem 3.2rem;\n    grid-template-columns: 7fr 4fr;\n    column-gap: 3rem;\n  }\n  .project-info__body::before, .project-info__body::after {\n    width: calc(100% + 23.2rem);\n  }\n}\n@media (max-width: 48em) {\n  .project-info__slider {\n    margin-bottom: 3.2rem;\n  }\n}\n.project-info__slide {\n  display: flex;\n  min-height: 67.8rem;\n}\n@media (max-width: 48em) {\n  .project-info__slide {\n    height: 52.8rem;\n    min-height: auto;\n  }\n}\n.project-info__slider-nav {\n  display: flex;\n  align-items: center;\n  column-gap: 1.6rem;\n}\n@media (max-width: 48em) {\n  .project-info__slider-nav {\n    justify-content: space-between;\n  }\n}\n.project-info__image-wrap {\n  height: 100%;\n}\n.project-info__image {\n  height: 100%;\n  object-fit: cover;\n}\n.project-info__content {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 48em) {\n  .project-info__content {\n    order: -1;\n  }\n}\n.project-info__text-wrap {\n  margin-bottom: 3.2rem;\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n}\n@media (max-width: 48em) {\n  .project-info__text-wrap {\n    row-gap: 2rem;\n  }\n}\n@media (min-width: 48em) {\n  .project-info__text {\n    max-width: 52rem;\n  }\n}\n.project-layout {\n  margin-bottom: 18rem;\n}\n.project-layout__container {\n  position: relative;\n  display: grid;\n}\n.project-layout__container::before, .project-layout__container::after {\n  left: 0;\n  width: calc(100% + 129.2rem);\n  height: 2px;\n}\n.scroll-trigger .project-layout__container::before, .scroll-trigger .project-layout__container::after {\n  transform: scaleX(var(--scaleX));\n}\n.project-layout__container::before {\n  top: 0;\n}\n.project-layout__container::after {\n  bottom: 0;\n}\n@media (min-width: 48em) {\n  .project-layout__container {\n    grid-template-columns: 4fr 7fr;\n    grid-column: 2/3;\n    column-gap: 3rem;\n  }\n}\n@media (max-width: 48em) {\n  .project-layout__container::before, .project-layout__container::after {\n    display: none;\n  }\n}\n.project-layout__content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.scroll-trigger .project-layout__content::before, .scroll-trigger .project-layout__content::after {\n  transform: scaleY(var(--scaleY));\n}\n.project-layout__content::before {\n  top: -18rem;\n  left: 0;\n  height: calc(100% + 18rem);\n}\n.project-layout__content::after {\n  top: 0;\n  right: 0;\n  height: 100%;\n}\n@media (max-width: 48em) {\n  .project-layout__content::before, .project-layout__content::after {\n    display: none;\n  }\n}\n.project-layout__head {\n  position: relative;\n  padding: 3.2rem;\n  width: 100%;\n}\n.project-layout__head::after {\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 2px;\n}\n.scroll-trigger .project-layout__head::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (max-width: 48em) {\n  .project-layout__head {\n    margin-bottom: 3.2rem;\n    padding: 0 0 3.2rem 0;\n  }\n}\n.project-layout__body {\n  padding: 0 0 3.2rem 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n@media (min-width: 48em) {\n  .project-layout__body {\n    padding: 3rem;\n    flex: 1 1 auto;\n  }\n}\n@media (min-width: 48em) {\n  .project-layout__text-wrap {\n    margin-bottom: auto;\n    max-width: 38.3rem;\n  }\n}\n.project-layout__slider-nav {\n  display: flex;\n  align-items: center;\n  column-gap: 1.6rem;\n}\n@media (max-width: 48em) {\n  .project-layout__slider-nav {\n    justify-content: space-between;\n  }\n}\n.project-layout__slider {\n  position: relative;\n}\n.project-layout__slider::after {\n  top: 0;\n  right: 0;\n}\n.scroll-trigger .project-layout__slider::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .project-layout__slider {\n    padding: 3rem 3rem 3rem 0;\n  }\n}\n@media (max-width: 48em) {\n  .project-layout__slider {\n    margin-bottom: 3.2rem;\n  }\n  .project-layout__slider::after {\n    display: none;\n  }\n}\n.project-layout__slide {\n  display: flex;\n  min-height: 67.8rem;\n}\n@media (max-width: 48em) {\n  .project-layout__slide {\n    height: 52.8rem;\n    min-height: auto;\n  }\n}\n.project-layout__image-wrap {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n}\n.project-layout__image {\n  object-fit: contain;\n}\n.project-interiors {\n  margin-bottom: 18rem;\n}\n.project-interiors__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.project-interiors__container::before {\n  top: -18rem;\n  left: 0;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .project-interiors__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (max-width: 48em) {\n  .project-interiors__container::before {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .project-interiors__container {\n    grid-column: 2/3;\n  }\n}\n.project-interiors__head {\n  margin-bottom: 3.2rem;\n  display: flex;\n  justify-content: space-between;\n}\n@media (min-width: 48em) {\n  .project-interiors__head {\n    padding-left: 3rem;\n  }\n}\n.project-interiors__slider-nav {\n  display: flex;\n  align-items: center;\n  column-gap: 1.6rem;\n}\n@media (min-width: 48em) {\n  .project-interiors__slider-nav {\n    align-self: flex-end;\n  }\n}\n@media (max-width: 48em) {\n  .project-interiors__slider-nav {\n    justify-content: space-between;\n  }\n}\n.project-interiors__body {\n  position: relative;\n  padding: 3rem 0 3rem 3rem;\n}\n.project-interiors__body::before, .project-interiors__body::after {\n  left: 0;\n  width: calc(100% + 129.2rem);\n  height: 2px;\n}\n.scroll-trigger .project-interiors__body::before, .scroll-trigger .project-interiors__body::after {\n  transform: scaleX(var(--scaleX));\n}\n.project-interiors__body::before {\n  top: 0;\n}\n.project-interiors__body::after {\n  bottom: 0;\n}\n@media (max-width: 48em) {\n  .project-interiors__body {\n    padding: 3.2rem 0;\n  }\n  .project-interiors__body::before {\n    width: 100%;\n  }\n  .project-interiors__body::after {\n    display: none;\n  }\n}\n.project-interiors__image-wrap {\n  height: 84rem;\n}\n@media (max-width: 48em) {\n  .project-interiors__image-wrap {\n    height: 100rem;\n  }\n}\n.project-interiors__image {\n  height: 100%;\n  object-fit: cover;\n}\n\n.portfolio {\n  margin-bottom: 18rem;\n}\n.portfolio__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.portfolio__container::before {\n  top: -18rem;\n  left: 0;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .portfolio__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (max-width: 48em) {\n  .portfolio__container::before {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .portfolio__container {\n    grid-column: 2/3;\n  }\n}\n.portfolio__head {\n  position: relative;\n  margin-bottom: 3.2rem;\n}\n.portfolio__head::after {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n}\n@media (min-width: 48em) {\n  .portfolio__head {\n    padding-left: 3rem;\n  }\n  .portfolio__head::after {\n    display: none;\n  }\n  .scroll-trigger .portfolio__head::after {\n    transform: scaleX(var(--scaleX));\n  }\n}\n@media (max-width: 48em) {\n  .portfolio__head {\n    margin-bottom: 5rem;\n    padding-bottom: 3.2rem;\n  }\n}\n.portfolio__body {\n  position: relative;\n  display: grid;\n}\n.portfolio__body::after {\n  right: 0;\n  top: 0;\n}\n@media (max-width: 48em) {\n  .portfolio__body {\n    row-gap: 10rem;\n  }\n  .portfolio__body::after {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .scroll-trigger .portfolio__body::after {\n    transform: scaleY(var(--scaleY));\n  }\n}\n.portfolio__row {\n  position: relative;\n  display: grid;\n}\n.portfolio__row:last-child::after, .portfolio__row::before {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n}\n.portfolio__row:last-child::after {\n  top: auto;\n  bottom: 0;\n  width: calc(100% + 23.2rem);\n}\n@media (min-width: 48em) {\n  .portfolio__row {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .scroll-trigger .portfolio__row::before, .scroll-trigger .portfolio__row:last-child::after {\n    transform: scaleX(var(--scaleX));\n  }\n}\n@media (max-width: 48em) {\n  .portfolio__row {\n    padding-bottom: 3.2rem;\n    row-gap: 3.2rem;\n  }\n  .portfolio__row::before {\n    top: auto;\n    bottom: 0;\n  }\n  .portfolio__row:last-child::after {\n    width: 100%;\n  }\n}\n.portfolio__cell {\n  position: relative;\n}\n.portfolio__cell:not(:last-child)::after {\n  top: 0;\n  right: 0;\n}\n@media (min-width: 48em) {\n  .portfolio__cell {\n    padding: 3rem;\n  }\n  .scroll-trigger .portfolio__cell::after {\n    transform: scaleY(var(--scaleY));\n  }\n}\n@media (max-width: 48em) {\n  .portfolio__cell:not(:last-child)::after {\n    display: none;\n  }\n  .portfolio__cell_info {\n    order: -1;\n  }\n}\n@media (min-width: 48em) {\n  .portfolio__cell_large {\n    grid-column: span 2;\n  }\n}\n.portfolio__image-wrap {\n  display: flex;\n  height: 44rem;\n}\n@media (max-width: 48em) {\n  .portfolio__image-wrap {\n    height: 59.2rem;\n  }\n}\n.portfolio__image {\n  height: 100%;\n  object-fit: cover;\n}\n.portfolio__info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n@media (min-width: 48em) {\n  .portfolio__info {\n    height: 100%;\n  }\n}\n.portfolio__heading {\n  margin-bottom: 2.4rem;\n}\n.portfolio__text {\n  margin-bottom: auto;\n  color: #9a9a9a;\n}\n@media (max-width: 48em) {\n  .portfolio__text {\n    margin-bottom: 2.4rem;\n  }\n}\n@media (max-width: 48em) {\n  .portfolio__square {\n    font-weight: 400;\n  }\n}\n.portfolio__footer {\n  position: relative;\n  padding: 3rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.portfolio__footer::after {\n  bottom: 0;\n  left: 0;\n  width: calc(100% + 23.2rem);\n  height: 2px;\n}\n@media (max-width: 48em) {\n  .portfolio__footer {\n    padding: 3.2rem 0;\n  }\n  .portfolio__footer::after {\n    width: 100%;\n  }\n}\n@media (min-width: 48em) {\n  .scroll-trigger .portfolio__footer::after {\n    transform: scaleX(var(--scaleX));\n  }\n}\n.portfolio__page-control {\n  display: flex;\n  align-items: center;\n  column-gap: 1.6rem;\n}\n.contacts {\n  margin-bottom: 18rem;\n}\n.contacts__container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.contacts__container::before {\n  top: 0;\n  left: 0;\n}\n.scroll-trigger .contacts__container::before {\n  transform: scaleY(var(--scaleY));\n}\n.contacts__container::after {\n  top: 0;\n  right: 0;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .contacts__container::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (max-width: 48em) {\n  .contacts__container {\n    padding: 0;\n  }\n  .contacts__container::before, .contacts__container::after {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .contacts__container {\n    grid-column: 2/3;\n  }\n}\n.contacts__content {\n  padding-top: 13.6rem;\n  display: grid;\n}\n.contacts__content::after {\n  top: 0;\n  left: 72.8rem;\n}\n.scroll-trigger .contacts__content::after {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .contacts__content {\n    grid-template-columns: repeat(2, 72.8rem);\n  }\n}\n@media (max-width: 48em) {\n  .contacts__content {\n    margin-bottom: 10rem;\n  }\n  .contacts__content::after {\n    display: none;\n  }\n}\n.contacts__column {\n  display: flex;\n  flex-direction: column;\n}\n.contacts__column_info {\n  justify-content: flex-end;\n}\n@media (min-width: 48em) {\n  .contacts__column:not(.contacts__column_info) {\n    padding-bottom: 20.9rem;\n    padding-left: 18rem;\n    padding-right: 3rem;\n  }\n  .contacts__column_info {\n    padding-bottom: 10rem;\n    padding-left: 3rem;\n  }\n}\n@media (max-width: 48em) {\n  .contacts__column_info {\n    padding: 3.2rem 3.2rem 0 3.2rem;\n  }\n}\n.contacts__title {\n  margin-bottom: 5.6rem;\n}\n.contacts__image-wrap {\n  position: relative;\n  z-index: 2;\n  margin-bottom: 5.6rem;\n  height: 30.8rem;\n  width: 51rem;\n}\n.contacts__image-wrap_abs {\n  position: absolute;\n  top: 12rem;\n  right: -23.2rem;\n  width: 41.5rem;\n  height: 58.5rem;\n}\n.contacts__image-wrap::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(70, 74, 80, 0.2);\n}\n@media (max-width: 48em) {\n  .contacts__image-wrap {\n    margin: 0;\n    width: 100%;\n    height: 75.4rem;\n  }\n  .contacts__image-wrap_abs {\n    display: none;\n  }\n}\n.contacts__image {\n  height: 100%;\n  object-fit: cover;\n}\n@media (min-width: 48em) {\n  .contacts__image:not(.contacts__image-wrap_abs .contacts__image) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 63.3rem;\n  }\n}\n.contacts__tel {\n  margin-bottom: 3.4rem;\n  font-weight: 400;\n}\n@media (max-width: 48em) {\n  .contacts__tel {\n    margin-bottom: 2.4rem;\n    order: -1;\n  }\n}\n.contacts__btn {\n  min-width: 20.5rem;\n  align-self: flex-start;\n}\n@media (max-width: 48em) {\n  .contacts__btn {\n    margin-bottom: 5rem;\n    min-width: 32rem;\n  }\n}\n.contacts__info {\n  display: flex;\n  flex-direction: column;\n  row-gap: 2.4rem;\n}\n.contacts__group {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  row-gap: 0.8rem;\n}\n.contacts__group-subtitle {\n  color: #9a9a9a;\n}\n.contacts__group-text {\n  max-width: 29.2rem;\n}\n@media (max-width: 48em) {\n  .contacts__group-text {\n    max-width: 53.2rem;\n  }\n}\n.contacts__map {\n  position: relative;\n  z-index: 5;\n  padding-left: 16.2rem;\n  padding-right: 3rem;\n  width: 100%;\n  height: 69.5rem;\n}\n@media (max-width: 48em) {\n  .contacts__map {\n    padding: 0 3.2rem;\n    height: 84.4rem;\n    width: 100vw;\n  }\n}\n\n.company-info {\n  margin-bottom: 18rem;\n}\n.company-info__container {\n  position: relative;\n  display: grid;\n}\n@media (min-width: 48em) {\n  .company-info__container {\n    grid-column: 2/3;\n  }\n}\n.info-company-info {\n  position: relative;\n  display: grid;\n}\n.info-company-info::before {\n  top: -18rem;\n  left: 0;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .info-company-info::before {\n  transform: scaleY(var(--scaleY));\n}\n.info-company-info::after {\n  bottom: 0;\n  left: 0;\n  width: calc(100% + 23.2rem);\n  height: 2px;\n}\n.scroll-trigger .info-company-info::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .info-company-info {\n    grid-template-columns: 62.2rem 1fr;\n  }\n}\n@media (max-width: 48em) {\n  .info-company-info {\n    margin-bottom: 17.6rem;\n  }\n  .info-company-info::before {\n    display: none;\n  }\n  .info-company-info::after {\n    width: 100%;\n  }\n}\n.info-company-info__text-wrap {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.info-company-info__text-wrap::before {\n  top: -18rem;\n  right: 0;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .info-company-info__text-wrap::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .info-company-info__text-wrap {\n    padding: 0 3rem 3rem 3rem;\n  }\n}\n@media (max-width: 48em) {\n  .info-company-info__text-wrap .info-company-info__text {\n    padding: 3.2rem 0;\n    margin-bottom: 3.2rem;\n    padding-bottom: 3.2rem;\n    border-bottom: 2px solid #505050;\n  }\n  .info-company-info__text-wrap::before {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .info-company-info__heading {\n    margin-bottom: auto;\n  }\n}\n@media (max-width: 48em) {\n  .info-company-info__heading {\n    padding-bottom: 3.2rem;\n    border-bottom: 2px solid #505050;\n    font-weight: 500;\n  }\n}\n.info-company-info__text {\n  color: #9a9a9a;\n}\n@media (min-width: 48em) {\n  .info-company-info__text {\n    max-width: 54.5rem;\n  }\n}\n.info-company-info__image-wrap {\n  padding-left: 3rem;\n  padding-bottom: 3rem;\n  display: flex;\n  justify-content: space-between;\n  column-gap: 3rem;\n}\n.info-company-info__image-wrap .info-company-info__text {\n  max-width: 23.5rem;\n  text-transform: uppercase;\n}\n@media (max-width: 48em) {\n  .info-company-info__image-wrap {\n    padding: 0 0 3.2rem 0;\n    flex-direction: column;\n    border-bottom: 2px solid #505050;\n  }\n  .info-company-info__image-wrap .info-company-info__text {\n    margin-bottom: 3.2rem;\n    padding-right: 15rem;\n    padding-bottom: 3.2rem;\n    max-width: none;\n    border-bottom: 2px solid #505050;\n  }\n}\n.info-company-info__image {\n  width: 54rem;\n  min-height: 60rem;\n}\n.info-company-info__image img {\n  height: 100%;\n  object-fit: cover;\n}\n@media (max-width: 48em) {\n  .info-company-info__image {\n    width: 100%;\n    height: 59.2rem;\n  }\n}\n\n.numbers-company-info {\n  position: relative;\n  display: grid;\n}\n.numbers-company-info::before {\n  top: -18rem;\n  left: 0;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .numbers-company-info::before {\n  transform: scaleY(var(--scaleY));\n}\n.numbers-company-info::after {\n  bottom: 0;\n  left: 0;\n  width: calc(100% + 23.2rem);\n  height: 2px;\n}\n.scroll-trigger .numbers-company-info::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .numbers-company-info {\n    padding: 18rem 0;\n    grid-template-columns: 1fr 66.3rem 1fr;\n  }\n}\n@media (max-width: 48em) {\n  .numbers-company-info {\n    margin-bottom: 18rem;\n  }\n  .numbers-company-info::before, .numbers-company-info::after {\n    display: none;\n  }\n}\n.numbers-company-info__row {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.numbers-company-info__row_left {\n  position: relative;\n  padding-left: 3rem;\n}\n.numbers-company-info__row_left::after {\n  top: -18rem;\n  left: calc(62.2rem - 2px);\n  height: calc(100% + 36rem);\n}\n.scroll-trigger .numbers-company-info__row_left::after {\n  transform: scaleY(var(--scaleY));\n}\n.numbers-company-info__row_right {\n  align-items: flex-end;\n}\n.numbers-company-info__row_right .numbers-company-info__group {\n  align-items: flex-end;\n  text-align: right;\n}\n@media (max-width: 48em) {\n  .numbers-company-info__row {\n    margin-bottom: 3.2rem;\n    padding-bottom: 3.2rem;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 2px solid #505050;\n  }\n  .numbers-company-info__row::after {\n    display: none;\n  }\n  .numbers-company-info__row_right {\n    display: none;\n  }\n}\n.numbers-company-info__group {\n  display: flex;\n  flex-direction: column;\n}\n.numbers-company-info__group_bottom {\n  margin-top: auto;\n}\n.numbers-company-info__heading {\n  font-family: Assistant;\n  font-size: 5.4rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n@media (max-width: 48em) {\n  .numbers-company-info__heading {\n    margin-bottom: 0.8rem;\n    font-size: 4rem;\n  }\n}\n.numbers-company-info__text {\n  color: #9a9a9a;\n}\n.numbers-company-info__image-wrap {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: 44rem;\n}\n@media (max-width: 48em) {\n  .numbers-company-info__image-wrap {\n    height: 45.6rem;\n  }\n}\n.numbers-company-info__image {\n  height: 100%;\n  object-fit: cover;\n}\n\n.privileges-company-info {\n  position: relative;\n  display: grid;\n}\n.privileges-company-info::before {\n  top: 0;\n  left: 0;\n}\n.scroll-trigger .privileges-company-info::before {\n  transform: scaleY(var(--scaleY));\n}\n.privileges-company-info::after {\n  bottom: 0;\n  left: 0;\n  width: calc(100% + 23.2rem);\n  height: 2px;\n}\n.scroll-trigger .privileges-company-info::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .privileges-company-info {\n    grid-template-columns: 7fr 4fr;\n  }\n}\n@media (max-width: 48em) {\n  .privileges-company-info::before, .privileges-company-info::after {\n    display: none;\n  }\n}\n.privileges-company-info__column {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 0;\n}\n.privileges-company-info__column:last-child {\n  position: relative;\n  padding-right: 0;\n}\n.privileges-company-info__column:last-child::before {\n  top: 0;\n  left: 0;\n}\n.scroll-trigger .privileges-company-info__column:last-child::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .privileges-company-info__column {\n    padding: 3rem;\n  }\n}\n@media (max-width: 48em) and (max-width: 48em) {\n  .privileges-company-info__column:first-child .privileges-company-info__text {\n    margin-bottom: 3.2rem;\n    padding-bottom: 3.2rem;\n    max-width: none;\n    border-bottom: 2px solid #505050;\n  }\n}\n@media (max-width: 48em) {\n  .privileges-company-info__column:last-child::before {\n    display: none;\n  }\n}\n.privileges-company-info__heading {\n  margin-bottom: 2.4rem;\n  font-weight: 500;\n  line-height: 130%;\n  color: #9a9a9a;\n}\n@media (max-width: 48em) {\n  .privileges-company-info__heading {\n    margin-bottom: 1.6rem;\n    font-size: 3.6rem;\n  }\n}\n.privileges-company-info__text {\n  margin-bottom: auto;\n  max-width: 63.2rem;\n  font-weight: 500;\n  line-height: 130%;\n}\n.privileges-company-info__btn {\n  min-width: 20.5rem;\n}\n.privileges-company-info__slider {\n  margin-bottom: 3rem;\n  width: 100%;\n}\n.privileges-company-info__slide {\n  display: flex;\n  flex-direction: column;\n}\n.privileges-company-info__ellipse {\n  flex: 0 0 7.8rem;\n  width: 7.8rem;\n  height: 5.7rem;\n}\n@media (max-width: 48em) {\n  .privileges-company-info__ellipse {\n    flex: 0 0 10rem;\n    width: 10rem;\n    height: 8rem;\n  }\n}\n.privileges-company-info__text-wrap {\n  display: flex;\n  flex-direction: column;\n}\n.privileges-company-info__text-wrap .privileges-company-info__heading {\n  margin-bottom: 1.6rem;\n  color: #ffffff;\n}\n.privileges-company-info__text-wrap .privileges-company-info__text {\n  position: relative;\n  padding-bottom: 3rem;\n  color: #9a9a9a;\n}\n.privileges-company-info__text-wrap .privileges-company-info__text::after {\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 2px;\n}\n.scroll-trigger .privileges-company-info__text-wrap .privileges-company-info__text::after {\n  transform: scaleX(var(--scaleX));\n}\n@media (min-width: 48em) {\n  .privileges-company-info__text-wrap .privileges-company-info__text {\n    max-width: 39.8rem;\n  }\n  .privileges-company-info__text-wrap .privileges-company-info__heading {\n    margin-bottom: 0.8rem;\n  }\n}\n@media (max-width: 48em) {\n  .privileges-company-info__text-wrap .privileges-company-info__text::after {\n    width: 100vw;\n  }\n}\n.privileges-company-info__slide-content {\n  display: flex;\n  column-gap: 2.4rem;\n}\n@media (max-width: 48em) {\n  .privileges-company-info__slide-content {\n    padding-top: 3.2rem;\n    column-gap: 4rem;\n    border-top: 2px solid #505050;\n  }\n}\n@media (max-width: 48em) {\n  .privileges-company-info__slider-control {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n}\n@media (min-width: 48em) {\n  .privileges-company-info__slider-control {\n    margin-left: auto;\n  }\n}\n.privileges-company-info__slider-nav {\n  display: flex;\n  align-items: center;\n  align-self: flex-end;\n  column-gap: 1.6rem;\n}\n@media (max-width: 48em) {\n  .privileges-company-info__image-wrap {\n    margin-bottom: 3.2rem;\n    height: 45.6rem;\n    width: 100%;\n  }\n}\n@media (max-width: 48em) {\n  .privileges-company-info__image {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n.company-methods {\n  margin-bottom: 18rem;\n}\n.company-methods__container {\n  position: relative;\n  display: flex;\n  flex-direction: column-reverse;\n}\n.company-methods__container::before {\n  top: -18rem;\n  height: calc(100% + 18rem);\n}\n.scroll-trigger .company-methods__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (min-width: 48em) {\n  .company-methods__container {\n    grid-column: 2/3;\n  }\n}\n@media (max-width: 48em) {\n  .company-methods__container::before {\n    display: none;\n  }\n}\n.company-methods__body {\n  position: relative;\n  padding: 3.2rem 0;\n}\n.company-methods__body::before, .company-methods__body::after {\n  left: 0;\n  width: calc(100% + 23.2rem);\n  height: 2px;\n}\n.scroll-trigger .company-methods__body::before, .scroll-trigger .company-methods__body::after {\n  transform: scaleX(var(--scaleX));\n}\n.company-methods__body::before {\n  top: 0;\n}\n.company-methods__body::after {\n  bottom: 0;\n}\n@media (min-width: 48em) {\n  .company-methods__body {\n    padding: 3.2rem 3rem 0 3rem;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (max-width: 48em) {\n  .company-methods__body::before, .company-methods__body::after {\n    width: 100%;\n  }\n}\n.company-methods__text-wrap {\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 48em) {\n  .company-methods__text-wrap {\n    padding-bottom: 25.2rem;\n  }\n  .company-methods__text-wrap_lc {\n    justify-self: end;\n    text-align: right;\n  }\n}\n@media (max-width: 48em) {\n  .company-methods__text-wrap_fc {\n    margin-bottom: 10rem;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  .company-methods__text-wrap_fc .company-methods__group {\n    margin: 0;\n  }\n  .company-methods__text-wrap_fc .company-methods__group:last-child {\n    text-align: right;\n  }\n}\n.company-methods__group {\n  margin-bottom: 33.5rem;\n  display: flex;\n  flex-direction: column;\n}\n.company-methods__subtitle {\n  text-transform: uppercase;\n}\n.company-methods__subtext {\n  color: #9a9a9a;\n}\n@media (max-width: 48em) {\n  .company-methods__text {\n    margin-bottom: 3.2rem;\n    padding-top: 3.2rem;\n    border-top: 2px solid #505050;\n  }\n}\n.company-methods__image-wrap {\n  width: 64.3rem;\n}\n@media (max-width: 48em) {\n  .company-methods__image-wrap {\n    margin-bottom: 8rem;\n  }\n}\n@media (min-width: 48em) {\n  .company-methods__image-wrap {\n    padding-bottom: 3rem;\n  }\n}\n.company-methods__bg-text {\n  position: absolute;\n  z-index: -1;\n  top: 20rem;\n  left: 3rem;\n  font-size: 14.6rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  white-space: nowrap;\n  line-height: 170%;\n  opacity: 0.1;\n}\n@media (max-width: 48em) {\n  .company-methods__bg-text {\n    top: 22rem;\n    left: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 8rem;\n    transform: translateX(-50%);\n  }\n  .company-methods__bg-text span {\n    font-size: 21.8rem;\n  }\n}\n@media (max-width: 48em) {\n  .company-methods__link {\n    transform: none;\n  }\n}\n\n.hero-portfolio {\n  position: relative;\n  margin-bottom: 18rem;\n}\n.hero-portfolio__container {\n  position: relative;\n  min-width: 0;\n}\n.hero-portfolio__container::before {\n  z-index: 2;\n  top: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.scroll-trigger .hero-portfolio__container::before {\n  transform: scaleY(var(--scaleY));\n}\n@media (max-width: 48em) {\n  .hero-portfolio__container {\n    padding: 0;\n  }\n  .hero-portfolio__container::before {\n    display: none;\n  }\n}\n@media (min-width: 48em) {\n  .hero-portfolio__container {\n    grid-column: 2/3;\n  }\n}\n.hero-portfolio__carousel {\n  position: relative;\n}\n@media (min-width: 48em) {\n  .hero-portfolio__slider.swiper {\n    overflow: visible;\n  }\n}\n@media (max-width: 48em) {\n  .hero-portfolio__slider {\n    margin-bottom: 10rem;\n  }\n}\n.hero-portfolio__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n@media (min-width: 48em) {\n  .hero-portfolio__content {\n    position: absolute;\n    top: 12rem;\n    left: 3rem;\n    width: calc(72.7% - 3rem);\n    max-height: calc(100% - 12rem);\n  }\n}\n@media (max-width: 48em) {\n  .hero-portfolio__content {\n    padding: 0 3.2rem;\n  }\n}\n.hero-portfolio__group {\n  margin-bottom: 12rem;\n  display: flex;\n  align-items: center;\n  column-gap: 3rem;\n}\n.hero-portfolio__group::after {\n  content: \"\";\n  width: 90.4rem;\n  height: 2px;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n@media (max-width: 48em) {\n  .hero-portfolio__group {\n    position: absolute;\n    top: 77.2rem;\n    left: 3.2rem;\n    column-gap: 2rem;\n  }\n  .hero-portfolio__group::after {\n    width: 19.4rem;\n  }\n}\n.hero-portfolio__group-txt {\n  white-space: nowrap;\n}\n.hero-portfolio__group-txt:first-child {\n  order: -1;\n}\n.hero-portfolio__group-txt:last-child {\n  order: 1;\n}\n@media (max-width: 48em) {\n  .hero-portfolio__group-txt {\n    font-size: 2.8rem;\n  }\n}\n.hero-portfolio__text-wrap {\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 48em) {\n  .hero-portfolio__text-wrap {\n    margin-bottom: 10.2rem;\n  }\n}\n.hero-portfolio__title {\n  margin-bottom: 3.2rem;\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 48em) {\n  .hero-portfolio__title {\n    margin-bottom: 5rem;\n    flex-direction: row;\n    column-gap: 2rem;\n  }\n}\n@media (min-width: 48em) {\n  .hero-portfolio__text {\n    max-width: 36.4rem;\n    color: #b3b3b3;\n  }\n}\n.hero-portfolio__slider-control {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 48em) {\n  .hero-portfolio__slider-control {\n    position: absolute;\n    bottom: 0;\n    right: 3.2rem;\n    flex-direction: column-reverse;\n  }\n}\n.hero-portfolio__slider-nav {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.6rem;\n}\n@media (min-width: 48em) {\n  .hero-portfolio__slider-nav {\n    margin-bottom: 10.2rem;\n  }\n}\n@media (max-width: 48em) {\n  .hero-portfolio__slider-nav {\n    flex-direction: column-reverse;\n    align-items: flex-end;\n  }\n}\n@media (max-width: 48em) {\n  .hero-portfolio__slider-fraction {\n    margin-bottom: 8rem;\n    font-size: 3.6rem;\n  }\n}\n.hero-portfolio__thumbs-carousel {\n  position: absolute;\n  z-index: 5;\n  bottom: 10rem;\n  right: 0;\n  overflow: hidden;\n}\n.hero-portfolio__thumbs {\n  width: 68.2rem;\n  height: 23.3rem;\n}\n.hero-portfolio__thumbs.swiper {\n  overflow: visible;\n}\n.hero-portfolio__thumb {\n  width: 23.5rem;\n  cursor: pointer;\n}\n.hero-portfolio__thumb-image-wrap {\n  height: 100%;\n}\n.hero-portfolio__thumb-image {\n  height: 100%;\n  object-fit: cover;\n}\n\n.slide-hero-portfolio {\n  display: grid;\n  width: 100%;\n}\n@media (min-width: 48em) {\n  .slide-hero-portfolio {\n    grid-template-columns: 8fr 3fr;\n    min-height: 100rem;\n  }\n}\n.slide-hero-portfolio__image-wrap {\n  position: relative;\n}\n.slide-hero-portfolio__image-wrap::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -46.4rem;\n  height: 100%;\n  width: calc(46.4rem + 100%);\n  background: linear-gradient(70deg, rgba(46, 46, 46, 0.3) 20.45%, rgba(0, 0, 0, 0) 63.6%), linear-gradient(0deg, rgba(70, 74, 80, 0.2) 0%, rgba(70, 74, 80, 0.4) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.2) 100%);\n}\n@media (max-width: 48em) {\n  .slide-hero-portfolio__image-wrap {\n    margin-bottom: 3.2rem;\n    height: 84rem;\n  }\n}\n.slide-hero-portfolio__image {\n  height: 100%;\n  object-fit: cover;\n}\n@media (min-width: 48em) {\n  .slide-hero-portfolio__image {\n    position: absolute;\n    top: 0;\n    left: -46.4rem;\n    width: calc(46.4rem + 100%);\n  }\n}\n.slide-hero-portfolio__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n@media (min-width: 48em) {\n  .slide-hero-portfolio__content {\n    padding-top: 26.3rem;\n    padding-bottom: 43.3rem;\n    padding-left: 14.9rem;\n    width: calc(100% + 192rem - 145.6rem);\n  }\n}\n@media (max-width: 48em) {\n  .slide-hero-portfolio__content {\n    padding-left: 3.2rem;\n    max-width: 58rem;\n  }\n}\n.slide-hero-portfolio__title-wrap {\n  margin-bottom: 3.2rem;\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.8rem;\n}\n@media (max-width: 48em) {\n  .slide-hero-portfolio__title-wrap {\n    margin-bottom: 2.4rem;\n    flex-direction: column-reverse;\n  }\n}\n.slide-hero-portfolio__subtitle {\n  color: #b2b2b2;\n}\n.slide-hero-portfolio__text {\n  margin-bottom: 3.2rem;\n}\n@media (max-width: 48em) {\n  .slide-hero-portfolio__text {\n    margin-bottom: 2.4rem;\n  }\n}\n.slide-hero-portfolio__square {\n  margin-bottom: 4.8rem;\n  display: flex;\n  flex-direction: column;\n  row-gap: 4.8rem;\n}\n.slide-hero-portfolio__square::after {\n  content: \"\";\n  width: 4rem;\n  height: 2px;\n  background-color: #ffffff;\n}\n@media (max-width: 48em) {\n  .slide-hero-portfolio__square {\n    margin-bottom: 4rem;\n    row-gap: 4rem;\n  }\n  .slide-hero-portfolio__square::after {\n    width: 8rem;\n  }\n}\n.slide-hero-portfolio__link {\n  transform: none;\n}\n\n.lock body {\n  overflow: hidden;\n  touch-action: none;\n}\n.wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 192rem;\n  margin: 0 auto;\n  overflow: hidden;\n}\n.wrapper::before {\n  z-index: 5;\n  left: 0;\n  top: 0;\n}\n.wrapper::after {\n  z-index: 5;\n  right: 0;\n  top: 0;\n}\n@media (max-width: 120em) {\n  .wrapper::before, .wrapper::after {\n    display: none;\n  }\n}\n@media (max-width: 48em) {\n  .wrapper {\n    width: 100%;\n  }\n}\n.wrapper > main {\n  flex: 1 1 auto;\n}\n.wrapper > * {\n  min-width: 0;\n}","// fonts =======================================================================\n\n// &display=swap\n@import url('https://fonts.googleapis.com/css?family=Assistant:regular,600,700,800&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Poiret+One:regular&display=swap');\n\n// local fonts\n@import './fonts';\n\n// variables ===================================================================\n\n// main colors\n$black: #1a1a1a;\n$bg: #242424;\n$grey: #9a9a9a;\n$white: #ffffff;\n\n// css variables for animations\nbody {\n  --scaleY: 0;\n  --scaleX: 0;\n  --opacity: 0;\n  --progress: 0;\n  --transition: 'none';\n  --x: translateX(-100%);\n}\n\n// set.scss file ===============================================================\n@import 'base/set.scss';\n\n// base styles, templates (patterns), special classes ==========================\n\n// base styles\n@import 'base';\n\n// common styles\n@import 'common';\n\n// components\n@import 'components/_header';\n@import 'components/_footer';\n\n// sections\n@import 'sections/hero';\n@import 'sections/about-company';\n@import 'sections/services';\n@import 'sections/privileges';\n@import 'sections/team';\n@import 'sections/request';\n@import 'sections/our-team';\n@import 'sections/projects';\n@import 'sections/image-text';\n@import 'sections/hero-project';\n@import 'sections/project-info';\n@import 'sections/project-layout';\n@import 'sections/project-interiors';\n@import 'sections/portfolio';\n@import 'sections/contacts';\n@import 'sections/company-info';\n@import 'sections/company-methods';\n@import 'sections/hero-portfolio';\n\n// base styles =================================================================\n\nbody {\n  // scroll is blocked\n  .lock & {\n    overflow: hidden;\n    touch-action: none;\n  }\n  // site is loaded\n  .loaded & {\n  }\n}\n\n.wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 192rem;\n  margin: 0 auto;\n  overflow: hidden;\n  &::before {\n    @extend %line;\n    z-index: 5;\n    left: 0;\n    top: 0;\n  }\n  &::after {\n    @extend %line;\n    z-index: 5;\n    right: 0;\n    top: 0;\n  }\n  @media (max-width: 120em) {\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n  @media (max-width: 48em) {\n    width: 100%;\n  }\n  // press footer\n  > main {\n    flex: 1 1 auto;\n  }\n  // fix for sliders\n  > * {\n    min-width: 0;\n  }\n}\n","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\nhtml {\r\n  font-family: 'Gilroy';\r\n  font-size: 0.5208335vw;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  -webkit-animation: bugfix infinite 1s;\r\n  line-height: 1.2;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 2.5rem;\r\n  -webkit-animation: bugfix infinite 1s;\r\n  line-height: 1.2;\r\n  margin: 0;\r\n  padding: 0;\r\n  color: $white;\r\n  background-color: $bg;\r\n}\r\n\r\ninput,\r\ntextarea {\r\n  -webkit-animation: bugfix infinite 1s;\r\n  line-height: inherit;\r\n  margin: 0;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  border: none;\r\n  color: inherit;\r\n}\r\na {\r\n  color: unset;\r\n}\r\na,\r\na:hover {\r\n  text-decoration: none;\r\n}\r\n\r\nbutton,\r\ninput,\r\na,\r\ntextarea {\r\n  outline: none;\r\n  cursor: pointer;\r\n  font: inherit;\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n  &:active {\r\n    outline: none;\r\n  }\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  font: inherit;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\np {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\nimg {\r\n  width: 100%;\r\n  height: auto;\r\n  display: block;\r\n}\r\n\r\nbutton {\r\n  border: none;\r\n  color: inherit;\r\n  font: inherit;\r\n  text-align: inherit;\r\n  padding: 0;\r\n  background-color: transparent;\r\n}\r\nul {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\nul li {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.container {\r\n  width: 145.6rem;\r\n  margin: 0 auto;\r\n}\r\n\r\ninput[type='number']::-webkit-inner-spin-button,\r\ninput[type='number']::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\ninput[type='number'] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n  html {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 48em) {\r\n  html {\r\n    font-size: 5px;\r\n    font-size: 1.5625vw;\r\n    font-size: calc((100 / 375) * 5vw);\r\n    -webkit-text-size-adjust: none;\r\n  }\r\n\r\n  body {\r\n    -webkit-text-size-adjust: none;\r\n  }\r\n\r\n  .container {\r\n    padding: 0 4rem;\r\n    width: 100%;\r\n  }\r\n}\r\n",".form {\r\n  &__row {\r\n  }\r\n  &__column {\r\n  }\r\n  &__line {\r\n  }\r\n  &__input {\r\n  }\r\n  &__button {\r\n  }\r\n  &__error {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    font-size: 1.5rem;\r\n    font-weight: 500;\r\n    color: #f05757;\r\n    transform: translateY(0.3rem);\r\n    @media (max-width: 48em) {\r\n      font-size: 2.4rem;\r\n    }\r\n  }\r\n}\r\n\r\n// < buttons > ====================================================================================================\r\n\r\n// snippet ( HTML ): btn\r\n@import 'button';\r\n\r\n// < inputs > =====================================================================================================\r\n\r\n// snippet ( HTML ): inp\r\n@import 'input';\r\n\r\n// < check > ======================================================================================================\r\n\r\n// snippet ( HTML ): chk\r\n@import 'checkbox';\r\n\r\n// < radio > ======================================================================================================\r\n\r\n// snippet ( HTML ): opt\r\n// @import \"radio\";\r\n\r\n// < select > =====================================================================================================\r\n\r\n// snippet ( HTML ): sel\r\n// @import \"select\";\r\n\r\n// < rating > =====================================================================================================\r\n\r\n// snippet ( HTML ): rating\r\n// @import \"rating\";\r\n\r\n// < quantity > ===================================================================================================\r\n\r\n// snippet ( HTML ): qa\r\n// @import \"quantity\";\r\n\r\n// < range > ======================================================================================================\r\n\r\n// @import \"range\";\r\n",".btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n\r\n  // .btn_primary\r\n\r\n  &_primary {\r\n    position: relative;\r\n    padding: 1.6rem 2.4rem;\r\n    justify-content: space-between;\r\n    column-gap: 1rem;\r\n    min-width: 19.6rem;\r\n    height: 4.9rem;\r\n    border-radius: 10rem;\r\n    background-color: $black;\r\n    overflow: hidden;\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      width: 100%;\r\n      height: 100%;\r\n      top: 0;\r\n      left: 0;\r\n      background-color: $white;\r\n      transition: all 0.3s ease;\r\n    }\r\n    svg {\r\n      position: relative;\r\n      z-index: 2;\r\n      width: 1.6rem;\r\n      height: 1.6rem;\r\n    }\r\n    path {\r\n      transition: stroke 0.3s ease;\r\n    }\r\n    @media (any-hover: hover) {\r\n      &:hover {\r\n        &::after {\r\n          opacity: 0;\r\n          transform: scaleY(0);\r\n        }\r\n        path {\r\n          stroke: $white;\r\n        }\r\n        .btn__text {\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n    @media (max-width: 48em) {\r\n      padding: 2.2rem 3.2rem 2rem 3.2rem;\r\n      column-gap: 2rem;\r\n      height: 7.8rem;\r\n      min-width: 32rem;\r\n      border-radius: 20rem;\r\n      svg {\r\n        width: 2.2rem;\r\n        height: 2.2rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // .btn_link\r\n\r\n  &_link {\r\n    transform: translateX(1.6rem);\r\n    .btn__text {\r\n      color: $white;\r\n    }\r\n    svg {\r\n      width: 1.6rem;\r\n      height: 1.6rem;\r\n      transform: translateX(1.6rem);\r\n      transition: transform 0.3s ease;\r\n    }\r\n    &:hover {\r\n      svg {\r\n        transform: translateX(0.8rem);\r\n      }\r\n    }\r\n    @media (max-width: 48em) {\r\n      svg {\r\n        width: 2rem;\r\n        height: 2rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // .btn__text\r\n\r\n  &__text {\r\n    position: relative;\r\n    z-index: 2;\r\n    padding-top: 0.1rem;\r\n    color: $black;\r\n    white-space: nowrap;\r\n    transition: color 0.3s ease;\r\n    @media (max-width: 48em) {\r\n      padding-top: 0.4rem;\r\n      &.txt {\r\n        font-size: 2.8rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n","input[type='text'],\r\ninput[type='email'],\r\ninput[type='tel'],\r\ntextarea {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n}\r\ntextarea:focus,\r\ninput:focus {\r\n  outline: none;\r\n}\r\n\r\n.input {\r\n  position: relative;\r\n  &__field {\r\n    @extend .txt;\r\n    display: block;\r\n    width: 100%;\r\n    padding: 1.6rem 0;\r\n    border-radius: 0 !important;\r\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\r\n    font-size: 1.8rem;\r\n    transition: all 0.3s ease;\r\n    &::placeholder {\r\n      color: rgba(255, 255, 255, 0.6);\r\n    }\r\n    &._form-focus {\r\n      border-bottom: 2px solid $white;\r\n    }\r\n    &._form-error {\r\n      color: #f05757;\r\n      border-bottom: 2px solid #f05757;\r\n      &::placeholder {\r\n        color: #f05757;\r\n      }\r\n    }\r\n    &._filled {\r\n      color: $white;\r\n      border-bottom: 2px solid $white;\r\n    }\r\n    @media (max-width: 48em) {\r\n      padding: 1.6rem 0;\r\n    }\r\n  }\r\n}\r\ntextarea.input {\r\n  padding: 0;\r\n  resize: none;\r\n}\r\n",".checkbox {\r\n  position: relative;\r\n  &._form-error {\r\n    .checkbox__text {\r\n      color: #f05757;\r\n    }\r\n  }\r\n\r\n  // .checkbox__input\r\n  &__input {\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n    opacity: 0;\r\n    &._form-error + .checkbox__label::before {\r\n      border: 1px solid #f05757;\r\n    }\r\n    &:focus + .checkbox__label:before {\r\n    }\r\n    &:checked + .checkbox__label:before {\r\n      background-image: url(./assets/images/icons/check.svg);\r\n      background-position: center;\r\n      background-size: 1.4rem;\r\n      background-repeat: no-repeat;\r\n      @media (max-width: 48em) {\r\n        background-size: 3rem;\r\n      }\r\n    }\r\n  }\r\n  // .checkbox__label\r\n  &__label {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    position: relative;\r\n    column-gap: 2.4rem;\r\n    cursor: pointer;\r\n    &:before {\r\n      content: '';\r\n      flex: 0 0 2.4rem;\r\n      width: 2.4rem;\r\n      height: 2.4rem;\r\n      border: 1px solid $white;\r\n      transition: border 1px solid;\r\n    }\r\n    @media (max-width: 48em) {\r\n      column-gap: 2.5rem;\r\n      &::before {\r\n        flex: 0 0 4.8rem;\r\n        width: 4.8rem;\r\n        height: 4.8rem;\r\n      }\r\n    }\r\n  }\r\n  // .checkbox__text\r\n  &__text {\r\n    transition: color 0.3s ease;\r\n    &.txt {\r\n      line-height: 155%;\r\n      @media (max-width: 48em) {\r\n        font-size: 2.7rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n","body::before {\r\n  content: '';\r\n  position: fixed;\r\n  z-index: 90;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0;\r\n  background-color: $black;\r\n  pointer-events: none;\r\n  transition: opacity 0.8s ease 0s;\r\n  @media (min-width: 48em) {\r\n    background: rgba(106, 106, 106, 0.2);\r\n    backdrop-filter: blur(1.9rem);\r\n  }\r\n}\r\n.popup-show body::before {\r\n  opacity: 1;\r\n}\r\n.popup {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  padding: 3rem 1rem;\r\n  visibility: hidden;\r\n  pointer-events: none;\r\n  transition: visibility 0.8s ease 0s;\r\n &.request-modal {\r\n    @media (max-width: 48em) {\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n.popup_show {\r\n  z-index: 150;\r\n  visibility: visible;\r\n  overflow: auto;\r\n  pointer-events: auto;\r\n}\r\n.popup_show .popup__content {\r\n  visibility: visible;\r\n  transform: scale(1);\r\n}\r\n.popup__wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex: 1 1 auto;\r\n  min-height: 100%;\r\n  width: 100%;\r\n}\r\n.popup__content {\r\n  padding: 2rem;\r\n  width: 100%;\r\n  max-width: 127.8rem;\r\n  background-color: #242424;\r\n  visibility: hidden;\r\n  transform: scale(0);\r\n  transition: transform 0.3s ease 0s;\r\n  .lock & {\r\n    visibility: visible;\r\n  }\r\n  .request-modal & {\r\n    padding: 0;\r\n    display: grid;\r\n    @media (min-width: 48em) {\r\n      grid-template-columns: 59.9rem 1fr;\r\n    }\r\n  }\r\n}\r\n\r\n// --------------------------------------------------------------------------\r\n\r\n.request-modal {\r\n  @media (max-width: 48em) {\r\n    .popup__wrapper {\r\n      justify-content: stretch;\r\n    }\r\n    .popup__content {\r\n      flex: 1 1 auto;\r\n    }\r\n  }\r\n\r\n  // .request-modal__image-wrap\r\n\r\n  &__image-wrap {\r\n    @media (max-width: 48em) {\r\n      margin-bottom: 6.3rem;\r\n      width: 100%;\r\n      height: 46rem;\r\n    }\r\n  }\r\n\r\n  // .request-modal__image\r\n\r\n  &__image {\r\n    height: 100%;\r\n    object-fit: cover;\r\n  }\r\n\r\n  // .request-modal__body\r\n\r\n  &__body {\r\n    padding: 2.5rem 2.5rem 9.7rem 8rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    @media (max-width: 48em) {\r\n      padding: 5rem 0 21.4rem 0;\r\n      .request-modal_sent & {\r\n        align-items: center;\r\n        text-align: center;\r\n      }\r\n    }\r\n    @media (min-width: 48em) {\r\n      .request-modal_sent & {\r\n        padding: 2.5rem 2.5rem 23.6rem 8rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // .request-modal__close-btn\r\n\r\n  &__close-btn {\r\n    margin-bottom: 4.9rem;\r\n    width: 3rem;\r\n    height: 3rem;\r\n    align-self: flex-end;\r\n    @media (max-width: 48em) {\r\n      margin-bottom: 11rem;\r\n      width: 5rem;\r\n      height: 5rem;\r\n      transform: translateX(-3.2rem);\r\n    }\r\n    @media (min-width: 48em) {\r\n      .request-modal_sent & {\r\n        margin-bottom: 18.8rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // .request-modal__title\r\n\r\n  &__title {\r\n    margin-bottom: 3.2rem;\r\n    @media (max-width: 48em) {\r\n      padding: 0 3.2rem;\r\n    }\r\n    @media (min-width: 48em) {\r\n      .request-modal_sent & {\r\n        max-width: 53.3rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // .request-modal__text\r\n\r\n  &__text {\r\n    margin-bottom: 6rem;\r\n    .request-modal_sent & {\r\n      margin-bottom: 3.2rem;\r\n    }\r\n    @media (max-width: 48em) {\r\n      margin-bottom: 5rem;\r\n      padding: 0 3.2rem;\r\n      max-width: 58.2rem;\r\n    }\r\n  }\r\n\r\n  // .request-modal__form\r\n\r\n  &__form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    @media (max-width: 48em) {\r\n      padding: 0 3.2rem;\r\n    }\r\n  }\r\n\r\n  // .request-modal__fields\r\n\r\n  &__fields {\r\n    margin-bottom: 3rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 2.4rem;\r\n    width: 50rem;\r\n    @media (max-width: 48em) {\r\n      margin-bottom: 5rem;\r\n      row-gap: 5rem;\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  // .request-modal__input\r\n\r\n  &__input {\r\n  }\r\n\r\n  // .request-modal__actions\r\n\r\n  &__actions {\r\n    @media (max-width: 48em) {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      column-gap: 2rem;\r\n    }\r\n  }\r\n\r\n  // .request-modal__checkbox\r\n\r\n  &__checkbox {\r\n    @media (min-width: 48em) {\r\n      margin-bottom: 5.6rem;\r\n    }\r\n  }\r\n\r\n  // .request-modal__btn\r\n\r\n  &__btn {\r\n    min-width: 15.3rem;\r\n    @media (max-width: 48em) {\r\n      min-width: 24.6rem;\r\n    }\r\n    @media (min-width: 48em) {\r\n      align-self: flex-start;\r\n    }\r\n  }\r\n}\r\n",".ymaps3x0--main-engine-container {\r\n  filter: grayscale(1);\r\n  -ms-filter: grayscale(1);\r\n  -webkit-filter: grayscale(1);\r\n  -moz-filter: grayscale(1);\r\n  -o-filter: grayscale(1);\r\n}\r\n\r\n.marker {\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  width: 8.2rem;\r\n  transform: translate(-50%, calc(-50% - 24px));\r\n  cursor: pointer;\r\n  @media (max-width: 48em) {\r\n    width: 10rem;\r\n  }\r\n}\r\n","@import 'base/forms/forms';\r\n\r\n// popup styles\r\n@import 'base/popup';\r\n\r\n// spoiler styles\r\n// @import \"base/spoilers\";\r\n\r\n// tab styles\r\n// @import \"base/tabs\";\r\n\r\n// map styles\r\n@import 'base/maps';\r\n\r\n// showmore styles\r\n// @import \"base/showmore\";\r\n\r\n// fullscreen styles\r\n// @import \"base/fullscreen\";\r\n\r\n// sticky block styles\r\n// @import \"base/sticky\";\r\n\r\n// ibg styles\r\n[class*='-ibg'] {\r\n  position: relative;\r\n  img {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    object-fit: cover;\r\n  }\r\n}\r\n[class*='-ibg_contain'] {\r\n  img {\r\n    object-fit: contain;\r\n  }\r\n}\r\n\r\n// templates ===================================================================\r\n\r\n// @extend %pattern name;\r\n// snippet ( SCSS ): ex\r\n\r\n// list counter\r\n%listCounter {\r\n  list-style-type: none;\r\n  counter-reset: item;\r\n  li {\r\n    position: relative;\r\n    &:before {\r\n      counter-increment: item;\r\n      content: counter(item);\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// responsive video\r\n%responsiveVideo {\r\n  position: relative;\r\n  overflow: hidden;\r\n  height: 0;\r\n  padding-bottom: 56.25%;\r\n  video,\r\n  iframe,\r\n  object,\r\n  embed {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n// video as background\r\n%videoBackground {\r\n  video,\r\n  iframe,\r\n  object,\r\n  embed {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    min-width: 100%;\r\n    min-height: 100%;\r\n    width: auto;\r\n    height: auto;\r\n    z-index: -100;\r\n    transform: translateX(-50%) translateY(-50%);\r\n    background-size: cover;\r\n  }\r\n}\r\n\r\n// gray filter\r\n%grayfilter {\r\n  transition: all 0.3s ease 0s;\r\n  filter: grayscale(1);\r\n  @media (any-hover: hover) {\r\n    &:hover {\r\n      filter: grayscale(0);\r\n    }\r\n  }\r\n}\r\n\r\n// no select\r\n%noselect {\r\n  user-select: none;\r\n}\r\n\r\n// mirror reflection\r\n%mirror {\r\n  transform: scale(-1, 1);\r\n}\r\n\r\n// smooth scroll\r\n%smoothscroll {\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n// hide scroll\r\n%hidescroll {\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n}\r\n\r\n%line {\r\n  content: '';\r\n  position: absolute;\r\n  width: 2px;\r\n  height: 100%;\r\n  background-color: #505050;\r\n  transform-origin: left top;\r\n}\r\n\r\n%swiperFix {\r\n  &.swiper-slide {\r\n    opacity: 0 !important;\r\n    visibility: hidden !important;\r\n  }\r\n  &.swiper-slide-active {\r\n    opacity: 1 !important;\r\n    visibility: visible !important;\r\n  }\r\n}\r\n","body {\n  position: relative;\n  &::after {\n    content: '';\n    position: fixed;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: rgba(255, 255, 255, 0.05);\n    backdrop-filter: blur(4rem);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n  }\n  @media (max-width: 48em) {\n    .menu-open & {\n      &::after {\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n  }\n}\n\n// -------------------------------- elements --------------------------------\n\n.main {\n  position: relative;\n  @media (max-width: 48em) {\n    &::before {\n      content: '';\n      position: fixed;\n      z-index: 100;\n      width: 100%;\n      height: 16.4rem;\n      top: 0;\n      left: 0;\n      background-color: rgba(255, 255, 255, 0.05);\n      backdrop-filter: blur(4.6rem);\n      transition: transform 0.3s ease;\n      ._header-scroll & {\n        transform: translateY(-110%);\n      }\n      ._header-show & {\n        transform: translateY(0);\n      }\n      .menu-open & {\n        transform: translateY(-110%);\n      }\n    }\n  }\n}\n\n// sidebar\n.sidebar {\n  position: absolute;\n  z-index: 100;\n  top: 0;\n  left: auto;\n  padding: 3.6rem 2.3rem 9rem 2.3rem;\n  height: 100%;\n  background-color: rgba(106, 106, 106, 0.2);\n  backdrop-filter: blur(1.9rem);\n  @media (max-width: 48em) {\n    position: fixed;\n    left: 0;\n    padding: 4rem 0;\n    width: 100%;\n    height: 16.4rem;\n    background-color: transparent;\n    backdrop-filter: blur(0);\n    transition: all 0.3s ease;\n    ._header-scroll & {\n      transform: translateY(-110%);\n    }\n    ._header-show & {\n      transform: translateY(0);\n    }\n    .menu-open & {\n    }\n  }\n  @media (min-width: 48em) {\n    position: fixed;\n    width: 15rem;\n    transition: width 0.4s ease;\n    .menu-open & {\n      width: 30.7rem;\n    }\n  }\n\n  // .sidebar__inner\n\n  &__inner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    @media (min-width: 48em) {\n      flex-direction: column;\n    }\n    @media (max-width: 48em) {\n      padding: 0 3.2rem;\n    }\n  }\n\n  // .sidebar__logo-wrap\n\n  &__logo-wrap {\n    width: 10.4rem;\n    @media (max-width: 48em) {\n      position: relative;\n      z-index: 105;\n      width: 13.6rem;\n    }\n    @media (min-width: 48em) {\n      margin-bottom: 8.6rem;\n    }\n  }\n\n  // .sidebar__logo\n\n  &__logo {\n    object-fit: contain;\n  }\n\n  // .sidebar__menu\n\n  &__menu {\n  }\n  // .sidebar__socials\n\n  &__socials {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 1.9rem;\n    @media (max-width: 48em) {\n      margin-bottom: 2rem;\n      flex-direction: row;\n      column-gap: 5rem;\n    }\n  }\n\n  // .sidebar__socials-item\n\n  &__socials-item {\n    @media (min-width: 48em) {\n      &._mobile-only {\n        display: none;\n      }\n    }\n  }\n\n  // .sidebar__socials-link\n\n  &__socials-link {\n    display: inline-block;\n    width: 3.2rem;\n    @media (max-width: 48em) {\n      width: 6rem;\n    }\n  }\n\n  // .sidebar__socials-icon\n\n  &__socials-icon {\n    object-fit: contain;\n  }\n\n  // .sidebar__tel\n\n  &__tel {\n    font-family: Assistant;\n    opacity: 0;\n    visibility: hidden;\n    white-space: nowrap;\n    transition: all 0.4s ease;\n    .menu-open & {\n      opacity: 1;\n      visibility: visible;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 5rem;\n      &.txt {\n        font-size: 6rem;\n        font-weight: 700;\n      }\n    }\n  }\n}\n\n// hamburger\n.hamburger {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 0.6rem;\n  width: 3.4rem;\n  &::before,\n  &::after {\n    content: '';\n  }\n  &::before,\n  &::after,\n  span {\n    width: 100%;\n    height: 0.2rem;\n    background-color: $white;\n  }\n  span {\n    transform: scaleX(0.7);\n    transition: transform 0.4s ease;\n  }\n  @media (max-width: 48em) {\n    row-gap: 1.2rem;\n    width: 6.5rem;\n    &::before,\n    &::after,\n    span {\n      height: 0.4rem;\n      transition: all 0.3s ease;\n    }\n    .menu-open & {\n      position: absolute;\n      &::before,\n      &::after,\n      span {\n        opacity: 0;\n        visibility: hidden;\n      }\n    }\n  }\n  @media (min-width: 48em) {\n    transition: all 0.3s ease;\n    .menu-open & {\n      opacity: 0;\n      visibility: hidden;\n    }\n  }\n}\n\n// menu\n.menu {\n  position: relative;\n  @media (min-width: 48em) {\n    display: flex;\n    align-items: center;\n    flex: 1 1 auto;\n  }\n\n  // .menu__hamburger-wrap\n\n  &__hamburger-wrap {\n    @media (any-hover: hover) {\n      &:hover {\n        .hamburger {\n          span {\n            transform: scaleX(0.99);\n          }\n        }\n      }\n    }\n    @media (max-width: 48em) {\n      position: relative;\n      z-index: 105;\n      display: flex;\n      align-items: center;\n      &::after {\n        content: '';\n        position: absolute;\n        width: 6.5rem;\n        height: 6.5rem;\n        background-image: url(./assets/images/icons/cross.svg);\n        background-size: contain;\n        background-position: center;\n        background-repeat: no-repeat;\n        opacity: 0;\n        visibility: hidden;\n        transition: all 0.3s ease;\n      }\n      .menu-open & {\n        &::after {\n          position: static;\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n    }\n    @media (min-width: 48em) {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      row-gap: 1.6rem;\n      transform: translate(-50%, -50%);\n      .menu-open & {\n        opacity: 0;\n        visibility: hidden;\n      }\n    }\n  }\n\n  // .menu__hamburger\n\n  &__hamburger {\n  }\n\n  // .menu__hamburger-txt\n\n  &__hamburger-txt {\n    text-transform: uppercase;\n    color: $white;\n  }\n\n  // .menu__body\n\n  &__body {\n    opacity: 0;\n    visibility: hidden;\n    // transition: all 0.4s ease;\n    @media (max-width: 48em) {\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      padding-top: 40rem;\n      padding-bottom: 12rem;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      height: 100vh;\n      overflow: auto;\n    }\n    .menu-open & {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  // .menu__list\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 4.8rem;\n    text-align: center;\n    @media (max-width: 48em) {\n      margin-bottom: 39.6rem;\n      row-gap: 6.4rem;\n    }\n  }\n\n  // .menu__item\n\n  &__item {\n  }\n\n  // .menu__link\n\n  &__link {\n    position: relative;\n    text-transform: uppercase;\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: -0.3rem;\n      left: 0;\n      width: 100%;\n      height: 1px;\n      background-color: $white;\n      opacity: 0;\n      transform: scaleX(0);\n      transform-origin: center;\n      transition: all 0.5s ease;\n    }\n    @media (any-hover: hover) {\n      &:hover {\n        &::after {\n          opacity: 1;\n          transform: scaleX(1);\n        }\n      }\n    }\n    @media (max-width: 48em) {\n      font-size: 4rem;\n    }\n  }\n}\n\n// slider nav btn\n.nav-btn {\n  flex: 0 0 6rem;\n  width: 6rem;\n  height: 6rem;\n  border-radius: 50%;\n  svg {\n    width: 6rem;\n    height: 6rem;\n    transition: fill 0.4s ease;\n    path {\n      transition: stroke 0.4s ease;\n    }\n  }\n  @media (any-hover: hover) {\n    &:hover {\n      svg {\n        fill: $white;\n        path {\n          stroke: $black;\n        }\n      }\n    }\n  }\n  @media (max-width: 48em) {\n    flex: 0 0 8rem;\n    width: 8rem;\n    height: 8rem;\n    svg {\n      width: 8rem;\n      height: 8rem;\n    }\n  }\n}\n\n// slider fraction\n.sl-fraction {\n  display: flex;\n  align-items: center;\n  column-gap: 5rem;\n\n  // .sl-fraction__progress\n\n  &__progress {\n    display: none;\n    @media (min-width: 48em) {\n      position: relative;\n      display: block;\n      flex: 0 0 36.8rem;\n      width: 36.8rem;\n      height: 2px;\n      background-color: rgb(255, 255, 255, 0.6);\n      &::after {\n        content: '';\n        position: absolute;\n        width: 100%;\n        height: 2px;\n        top: 0;\n        left: 0;\n        background-color: $white;\n        transform-origin: left;\n        transform: scaleX(var(--progress));\n      }\n    }\n  }\n\n  // .sl-fraction__content\n\n  &__content {\n    white-space: nowrap;\n  }\n}\n\n// tab\n.tab {\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.3s ease;\n  &._active {\n    .tab__text {\n      background-color: rgba(255, 255, 255, 0.2);\n      &::after {\n        opacity: 0;\n      }\n    }\n  }\n  @media (max-width: 48em) {\n    border-top: 2px solid rgba(255, 255, 255, 0.2);\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n    border-right: 2px solid rgba(255, 255, 255, 0.2);\n    &_fc {\n      border-left: 2px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n\n  // .tab__text\n\n  &__text {\n    position: relative;\n    padding: 3.2rem 3.8rem;\n    width: 100%;\n    text-align: center;\n    text-transform: uppercase;\n    transition: all 0.3s ease;\n    &::after {\n      @extend %line;\n      top: 0;\n      right: 0;\n      height: 100%;\n      transition: opacity 0.3s ease;\n    }\n    @media (max-width: 48em) {\n      padding: 2.8rem 4rem;\n      &::after {\n        display: none;\n      }\n      &.txt {\n        font-size: 2.8rem;\n      }\n    }\n  }\n}\n\n// image gradient\n.image-gradient {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      to right,\n      rgba(36, 36, 36, 0) 0%,\n      rgba(36, 36, 36, 1) 100%\n    );\n    opacity: var(--opacity);\n    transform: var(--x);\n  }\n}\n\n// section footer\n.section-footer {\n  &::before,\n  &::after {\n    @extend %line;\n    left: 0;\n    width: 100%;\n    height: 2px;\n  }\n  &::before {\n    top: 0;\n  }\n  &::after {\n    bottom: 0;\n  }\n  @media (max-width: 48em) {\n    position: relative;\n    padding: 3.2rem 0;\n  }\n}\n\n// page navigation\n.page-nav {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n\n  // .page-nav__num\n\n  &__num {\n    &:not(:last-child) {\n      margin-right: 2.4rem;\n      &._active {\n        margin-right: 12rem;\n      }\n    }\n    &:not(&._active) {\n      color: #9a9a9a;\n    }\n    @media (max-width: 48em) {\n      &:not(:last-child) {\n        margin-right: 1rem;\n        &._active {\n          margin-right: 5rem;\n        }\n      }\n    }\n  }\n}\n\n// ------------------------------- typography -------------------------------\n\n// tl1\n.tl1 {\n  font-size: 5.4rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.2rem;\n  line-height: 130%;\n  @media (max-width: 48em) {\n    font-size: 6rem;\n  }\n}\n\n// tl2\n.tl2 {\n  font-size: 3rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  line-height: 120%;\n  letter-spacing: 0.1rem;\n  @media (max-width: 48em) {\n    font-size: 4.2rem;\n  }\n}\n\n// tl3\n.tl3 {\n  font-size: 2.6rem;\n  font-weight: 600;\n  @media (max-width: 48em) {\n    font-size: 4rem;\n  }\n}\n\n// reg\n.reg {\n  font-weight: 400;\n}\n\n// txt\n.txt {\n  font-family: Gilroy;\n  line-height: 130%;\n  @media (max-width: 48em) {\n    font-size: 3.2rem;\n  }\n\n  // .txt_16\n\n  &_16 {\n    font-size: 1.6rem;\n    @media (max-width: 48em) {\n      font-size: 3.2rem;\n    }\n  }\n\n  // .txt_18\n\n  &_18 {\n    font-size: 1.8rem;\n    @media (max-width: 48em) {\n      font-size: 3.2rem;\n    }\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.grid {\n  display: grid;\n  @media (min-width: 48em) {\n    grid-template-columns: 15rem 1fr;\n  }\n}\n\n.desktop-only {\n  @media (max-width: 48em) {\n    display: none;\n  }\n}\n\n.mobile-only {\n  @media (min-width: 48em) {\n    display: none;\n  }\n}\n",".footer {\n  position: relative;\n  margin-bottom: 2.8rem;\n  &::after {\n    @extend %line;\n    bottom: 0;\n    left: 2px;\n    width: 100%;\n    height: 2px;\n    .scroll-trigger & {\n      transform: scaleX(var(--scaleX));\n    }\n  }\n  @media (max-width: 48em) {\n    margin: 0;\n    padding: 0 3.2rem;\n    &::after {\n      display: none;\n    }\n  }\n\n  // .footer__container\n\n  &__container {\n    padding: 8.8rem 0 8rem 3rem;\n    display: flex;\n    flex-direction: column;\n    &::after {\n      @extend %line;\n      left: 0;\n      top: -18rem;\n      height: calc(100% + 18rem + 2.8rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      position: relative;\n      grid-column: 2/3;\n      row-gap: 6.4rem;\n    }\n    @media (max-width: 48em) {\n      padding: 3.2rem 0 6rem 0;\n      border-top: 2px solid rgba(255, 255, 255, 0.2);\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .footer__row\n\n  &__row {\n    display: flex;\n    justify-content: space-between;\n\n    // .footer__row_upper\n\n    &_upper {\n      @media (max-width: 48em) {\n        margin-bottom: 6.4rem;\n      }\n    }\n\n    // .footer__row_lower\n\n    &_lower {\n      @media (max-width: 48em) {\n        margin-bottom: 8rem;\n        flex-direction: column;\n      }\n    }\n  }\n\n  // .footer__contacts\n\n  &__contacts {\n    display: flex;\n    flex-direction: column;\n    row-gap: 1.6rem;\n    @media (min-width: 48em) {\n      align-items: flex-start;\n      row-gap: 0.8rem;\n    }\n  }\n\n  // .footer__tel\n\n  &__tel {\n    font-family: Assistant;\n    @media (max-width: 48em) {\n      font-size: 700;\n    }\n  }\n\n  // .footer__mail\n\n  &__mail {\n    font-size: 2.4rem;\n    color: #9a9a9a;\n    @media (max-width: 48em) {\n      font-size: 3.2rem;\n    }\n  }\n\n  // .footer__socials\n\n  &__socials {\n    display: flex;\n    align-items: center;\n    align-self: flex-start;\n    column-gap: 3rem;\n    @media (max-width: 48em) {\n      column-gap: 6rem;\n    }\n  }\n\n  // .footer__socials-item\n\n  &__socials-item {\n  }\n\n  // .footer__socials-link\n\n  &__socials-link {\n    display: inline-block;\n    width: 5rem;\n    @media (max-width: 48em) {\n      width: 7rem;\n    }\n  }\n\n  // .footer__socials-icon\n\n  &__socials-icon {\n    object-fit: contain;\n  }\n\n  // .footer__address\n\n  &__address {\n    display: flex;\n    flex-direction: column;\n    row-gap: 0.8rem;\n    @media (max-width: 48em) {\n      margin-bottom: 9rem;\n      row-gap: 1.6rem;\n    }\n  }\n\n  // .footer__address-heading\n\n  &__address-heading {\n  }\n\n  // .footer__address-text\n\n  &__address-text {\n    color: #9a9a9a;\n  }\n\n  // .footer__navigation\n\n  &__navigation {\n    @media (min-width: 48em) {\n      align-self: flex-end;\n    }\n  }\n\n  // .footer__navigation-list\n\n  &__navigation-list {\n    display: flex;\n    column-gap: 4.8rem;\n    @media (max-width: 48em) {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      column-gap: 5rem;\n      row-gap: 5rem;\n    }\n  }\n\n  // .footer__navigation-item\n\n  &__navigation-item {\n  }\n\n  // .footer__navigation-link\n\n  &__navigation-link {\n    @extend .menu__link;\n    font-size: 1.6rem;\n    @media (max-width: 48em) {\n      font-size: 3.2rem;\n    }\n  }\n}\n",".hero {\n  position: relative;\n  margin-bottom: 18rem;\n  @media (max-width: 48em) {\n    .about-company-page & {\n      margin-bottom: 28rem;\n    }\n  }\n\n  // .hero__container\n\n  &__container {\n    position: relative;\n    z-index: 2;\n    display: grid;\n    height: 100%;\n    &::before {\n      @extend %line;\n      top: 0;\n      left: 0;\n      background-color: rgba(255, 255, 255, 0.2);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    .mainpage & {\n      &::before {\n        display: none;\n      }\n    }\n    @media (max-width: 48em) {\n      padding: 22.7rem 3.2rem 6.4rem 3.2rem;\n      row-gap: 26.2rem;\n      .projects-page & {\n        padding: 63.4rem 3.2rem 0 3.2rem;\n        row-gap: normal;\n      }\n      .about-company-page & {\n        padding: 0;\n        row-gap: normal;\n        height: auto;\n        &::before {\n          display: none;\n        }\n      }\n    }\n    @media (min-width: 48em) {\n      grid-template-columns: 6fr 5fr;\n      .about-company-page & {\n        grid-template-columns: 62.2rem 1fr;\n      }\n    }\n  }\n\n  // .hero__sidebar\n\n  &__sidebar {\n  }\n\n  // .hero__body\n\n  &__body {\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n      min-height: 100rem;\n    }\n  }\n\n  // .hero__text-wrap\n\n  &__text-wrap {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    height: 100%;\n    .about-company-page & {\n      padding-top: 39.8rem;\n      justify-content: flex-start;\n    }\n    &::before,\n    &::after {\n      @extend %line;\n      top: 0;\n      background-color: rgba(255, 255, 255, 0.2);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    &::before {\n      left: 0;\n    }\n    &::after {\n      right: -2.5rem;\n      .about-company-page & {\n        right: 0;\n      }\n    }\n    @media (min-width: 48em) {\n      padding: 5rem 0 8.8rem 3rem;\n    }\n    @media (max-width: 48em) {\n      .projects-page & {\n        margin-bottom: 26rem;\n        justify-content: flex-start;\n        height: auto;\n      }\n      .about-company-page & {\n        padding: 0 3.2rem;\n      }\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .hero__title\n\n  &__title {\n    margin-bottom: 3.2rem;\n    display: flex;\n    flex-direction: column;\n    .about-company-page & {\n      position: relative;\n      margin-bottom: 4rem;\n      flex-direction: row;\n      column-gap: 1rem;\n      &::after {\n        @extend %line;\n        left: -49.7rem;\n        bottom: -1.4rem;\n        width: 192rem;\n        height: 2px;\n        background-color: rgba(255, 255, 255, 0.2);\n        .scroll-trigger & {\n          transform: scaleX(var(--scaleX));\n        }\n      }\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 4.8rem;\n      .about-company-page & {\n        margin-bottom: 5rem;\n        column-gap: 2rem;\n        &::after {\n          display: none;\n        }\n      }\n    }\n  }\n\n  // .hero__title-txt\n\n  &__title-txt {\n  }\n\n  // .hero__text\n\n  &__text {\n    margin-bottom: 3.2rem;\n    .about-company-page & {\n      max-width: 37.5rem;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 4.8rem;\n      max-width: 57.8rem;\n      .about-company-page & {\n        margin-bottom: 10rem;\n        max-width: 61.5rem;\n      }\n    }\n  }\n\n  // .hero__btn\n\n  &__btn {\n    align-self: flex-start;\n  }\n\n  // .hero__facts\n\n  &__facts {\n    @media (max-width: 48em) {\n      order: -1;\n    }\n    @media (min-width: 48em) {\n      padding-top: 5rem;\n    }\n  }\n\n  // .hero__slider\n\n  &__slider {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    min-width: 0;\n    &.swiper {\n      overflow: visible;\n    }\n  }\n\n  // .hero__slide\n\n  &__slide {\n    position: relative;\n    .hero__slide-text {\n      display: none;\n    }\n    &.swiper-slide {\n      opacity: 0 !important;\n      visibility: hidden !important;\n    }\n    &.swiper-slide-active {\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n    @media (max-width: 48em) {\n      padding: 65rem 0 6.4rem 0;\n      .hero__text-wrap {\n        position: relative;\n        z-index: 2;\n        margin-bottom: 26rem;\n        justify-content: flex-start;\n        height: auto;\n      }\n    }\n  }\n\n  // .hero__video-wrap\n\n  &__video-wrap,\n  &__bg-image {\n    z-index: -1;\n    top: 0;\n    width: 192rem;\n    height: 100%;\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(\n          70deg,\n          rgba(46, 46, 46, 0.2) 20.45%,\n          rgba(0, 0, 0, 0) 63.6%\n        ),\n        linear-gradient(\n          0deg,\n          rgba(70, 74, 80, 0.2) 0%,\n          rgba(70, 74, 80, 0.2) 100%\n        );\n    }\n    @media (max-width: 48em) {\n      left: 0;\n    }\n  }\n\n  &__video-wrap {\n    position: absolute;\n    left: 0;\n    video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  // .hero__bg-image\n\n  &__bg-image {\n    position: absolute;\n    left: calc((192rem - 145.6rem + 15rem) / -2);\n    display: flex;\n    .about-company-page & {\n      left: 0;\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(\n            70deg,\n            rgba(46, 46, 46, 0.2) 20.45%,\n            rgba(0, 0, 0, 0) 63.6%\n          ),\n          linear-gradient(\n            0deg,\n            rgba(70, 74, 80, 0.2) 0%,\n            rgba(70, 74, 80, 0.2) 100%\n          ),\n          linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%);\n      }\n    }\n    picture {\n      display: flex;\n      width: 100%;\n    }\n    @media (max-width: 48em) {\n      top: -16.4rem;\n      left: -3.2rem;\n      width: calc(100% + 6.4rem);\n      height: calc(16.4rem + 100%);\n      .about-company-page & {\n        position: relative;\n        margin-bottom: 3.2rem;\n        height: 92.4rem;\n        width: 100%;\n        top: 0;\n        left: 0;\n        transform: none;\n      }\n    }\n  }\n\n  // .hero__image\n\n  &__image {\n    object-fit: cover;\n  }\n\n  // .hero__slider-control\n\n  &__slider-control {\n    z-index: 2;\n    padding-top: 5rem;\n    padding-bottom: 18.1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-end;\n    .hero__text {\n      margin-bottom: 37.8rem;\n      max-width: 23.5rem;\n      text-align: right;\n    }\n    @media (min-width: 48em) {\n      padding-left: 2.5rem;\n    }\n    @media (max-width: 48em) {\n      position: static;\n      padding: 0;\n      display: block;\n      width: 0;\n      height: 0;\n      .hero__text {\n        position: absolute;\n        top: 22.8rem;\n        right: 3.2rem;\n        margin: 0;\n        max-width: 35.4rem;\n      }\n    }\n  }\n\n  // .hero__slider-nav\n\n  &__slider-nav {\n    display: flex;\n    align-items: center;\n    column-gap: 1.6rem;\n  }\n\n  // .hero__slide-text\n\n  &__slide-text {\n    span {\n      display: block;\n    }\n  }\n\n  // .hero__slider-nav-wrap\n\n  &__slider-nav-wrap {\n    display: flex;\n    align-items: center;\n    column-gap: 3rem;\n    @media (min-width: 48em) {\n      margin-bottom: 27rem;\n    }\n    @media (max-width: 48em) {\n      position: absolute;\n      left: 3.2rem;\n      right: 3.2rem;\n      bottom: 6.4rem;\n      flex-direction: row-reverse;\n      justify-content: space-between;\n      column-gap: 0.8rem;\n    }\n  }\n\n  // .hero__slider-fraction\n\n  &__slider-fraction {\n    @media (max-width: 48em) {\n      position: absolute;\n      right: 3.2rem;\n      bottom: 18rem;\n    }\n  }\n\n  // .hero__info\n\n  &__info {\n    position: relative;\n    padding-top: 41.6rem;\n    padding-right: 10rem;\n    display: inline-flex;\n    flex-direction: column;\n    justify-self: flex-end;\n    align-items: flex-end;\n    text-align: right;\n    @media (max-width: 48em) {\n      padding: 0 10.2rem 0 0;\n    }\n  }\n\n  // .hero__info-ellipse\n\n  &__info-ellipse {\n    position: absolute;\n    z-index: -1;\n    top: 50%;\n    right: 0;\n    width: 26.9rem;\n    height: 26.9rem;\n    transform: translateY(-50%);\n    @media (max-width: 48em) {\n      right: 3.2rem;\n      width: 37.4rem;\n      height: 37.4rem;\n    }\n  }\n\n  // .hero__info-txt\n\n  &__info-txt {\n    margin-bottom: 5.5rem;\n    max-width: 23.2rem;\n    &::after {\n      @extend %line;\n      right: -10.2rem;\n      bottom: -3.2rem;\n      display: none;\n      width: 100vw;\n      height: 1px;\n    }\n    @media (max-width: 48em) {\n      position: relative;\n      margin-bottom: 6.4rem;\n      max-width: 46.2rem;\n      &::after {\n        display: inline-block;\n      }\n    }\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.facts-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  align-self: start;\n  justify-self: end;\n  row-gap: 4.8rem;\n  @media (max-width: 48em) {\n    row-gap: 6.4rem;\n  }\n\n  // .facts-hero__item\n\n  &__item {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    row-gap: 0.8rem;\n    text-align: right;\n  }\n\n  // .facts-hero__heading\n\n  &__heading {\n    font-family: Assistant;\n    @media (max-width: 48em) {\n      font-size: 4rem;\n    }\n  }\n\n  // .facts-hero__text\n\n  &__text {\n    letter-spacing: 0.05rem;\n    color: #9a9a9a;\n    @media (max-width: 48em) {\n      color: rgba(255, 255, 255, 0.6);\n    }\n  }\n}\n",".about-company {\n  margin-bottom: 18rem;\n\n  // .about-company__container\n\n  &__container {\n    position: relative;\n    display: grid;\n    &::after {\n      @extend %line;\n      bottom: 0;\n      width: 161rem;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (max-width: 48em) {\n      padding: 0 3.2rem;\n      &::after {\n        display: none;\n      }\n    }\n    @media (min-width: 48em) {\n      grid-template-columns: 6fr 5fr;\n      grid-column: 2/3;\n    }\n  }\n\n  // .about-company__text-wrap\n\n  &__text-wrap {\n    position: relative;\n    display: grid;\n    &::before,\n    &::after {\n      @extend %line;\n      top: -18rem;\n      height: calc(100% + 18rem - 2px);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    &::before {\n      left: 0;\n    }\n    &::after {\n      right: -2.5rem;\n    }\n    @media (max-width: 48em) {\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .about-company__head\n\n  &__head {\n    position: relative;\n    padding: 0 2.6rem 2rem 3rem;\n    display: flex;\n    align-items: flex-end;\n    &::after {\n      @extend %line;\n      left: 2px;\n      bottom: 0;\n      width: calc(100% + 2.5rem - 4px);\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (max-width: 48em) {\n      padding: 0 0 3.2rem 0;\n      border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .about-company__title\n\n  &__title {\n  }\n\n  // .about-company__title-txt\n\n  &__title-txt {\n  }\n\n  // .about-company__body\n\n  &__body {\n    display: grid;\n    @media (min-width: 48em) {\n      grid-template-columns: 4fr 2fr;\n      min-height: 54.8rem;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n    }\n  }\n\n  // .about-company__column\n\n  &__column {\n    padding: 3.2rem;\n    display: flex;\n    flex-direction: column;\n    &:first-child {\n      &::after {\n        @extend %line;\n        right: 0;\n        top: 0;\n        .scroll-trigger & {\n          transform: scaleY(var(--scaleY));\n        }\n      }\n    }\n    @media (min-width: 48em) {\n      position: relative;\n      margin-bottom: 2px;\n    }\n    @media (max-width: 48em) {\n      padding: 3.2rem 0;\n      row-gap: 2rem;\n      border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n      &:first-child {\n        &::after {\n          display: none;\n        }\n      }\n    }\n  }\n\n  // .about-company__txt-wrap\n\n  &__txt-wrap {\n    row-gap: 1rem;\n  }\n\n  // .about-company__text\n\n  &__text {\n  }\n\n  // .about-company__link\n\n  &__link {\n    align-self: flex-start;\n    @media (min-width: 48em) {\n      margin-top: auto;\n      align-self: center;\n    }\n  }\n\n  // .about-company__image-wrap\n\n  &__image-wrap {\n    width: 100%;\n    height: 52.8rem;\n    @media (min-width: 48em) {\n      width: calc(100% + ((192rem - 145.6rem) / 2));\n      height: 63.8rem;\n      align-self: end;\n      transform: translate(6rem, -3.4rem);\n      transform: translate(6rem, -3.4rem);\n    }\n  }\n\n  // .about-company__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n",".services {\n  margin-bottom: 18rem;\n  .scroll-trigger & {\n    --l1: 0;\n    --l2: 0;\n    --l3: 0;\n  }\n\n  // .services__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::after {\n      @extend %line;\n      bottom: 0;\n      left: 2px;\n      height: 2px;\n      width: calc(161rem - 2px);\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n    @media (max-width: 48em) {\n      padding: 0 3.2rem;\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .services__head\n\n  &__head {\n    position: relative;\n    margin-bottom: 2.4rem;\n    padding-left: 3rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    height: 6.5rem;\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      padding: 0;\n    }\n  }\n\n  // .services__title\n\n  &__title {\n  }\n\n  // .services__btn\n\n  &__btn {\n    min-width: 20.5rem;\n    @media (max-width: 48em) {\n      display: none;\n    }\n  }\n\n  // .services__body\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    @media (max-width: 48em) {\n      row-gap: 9.8rem;\n    }\n  }\n\n  // .services__card\n\n  &__card {\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.card-services {\n  position: relative;\n  display: grid;\n  &::after {\n    @extend %line;\n    top: 0;\n    left: 0;\n    .scroll-trigger & {\n      transform: scaleY(var(--scaleY));\n    }\n  }\n  &::before {\n    @extend %line;\n    top: 0;\n    left: 2px;\n    width: 161rem;\n    height: 2px;\n    .scroll-trigger & {\n      transform: scaleX(var(--scaleX));\n    }\n  }\n  &:first-child {\n    &::after {\n      top: -26.9rem;\n      height: calc(100% + 26.9rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n  }\n  &:not(&_reversed) {\n    .card-services__image {\n      transform: translateX(2px);\n    }\n  }\n\n  @media (min-width: 48em) {\n    grid-template-columns: 62.2rem 1fr;\n    &_reversed {\n      grid-template-columns: 1fr 62.2rem;\n      .card-services__image-wrap {\n        justify-self: end;\n        grid-column: 2/3;\n      }\n      .card-services__text-wrap {\n        padding-left: 16.3rem;\n        grid-column: 1/2;\n        grid-row: 1/2;\n      }\n      .card-services__num {\n        left: 3rem;\n      }\n    }\n  }\n  @media (max-width: 48em) {\n    padding-bottom: 3.2rem;\n    row-gap: 8rem;\n    &::before {\n      top: auto;\n      bottom: 0;\n      width: 100%;\n    }\n    &:last-child {\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .card-services__image-wrap\n\n  &__image-wrap {\n    position: relative;\n    min-height: 50rem;\n    overflow: hidden;\n    @media (max-width: 48em) {\n      min-height: none;\n      height: 40rem;\n    }\n  }\n\n  // .card-services__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  // .card-services__text-wrap\n\n  &__text-wrap {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    @media (min-width: 48em) {\n      padding-left: 20.3rem;\n      justify-content: center;\n      align-self: center;\n      height: 100%;\n    }\n  }\n\n  // .card-services__heading\n\n  &__heading {\n    margin-bottom: 2.4rem;\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n    }\n  }\n\n  // .card-services__text\n\n  &__text {\n    max-width: 56.9rem;\n    @media (max-width: 48em) {\n      max-width: 68rem;\n    }\n  }\n\n  // .card-services__num\n\n  &__num {\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 7rem;\n    font-family: Assistant;\n    font-size: 22.4rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    line-height: 129%;\n    color: rgba(255, 255, 255, 0.1);\n    @media (max-width: 48em) {\n      top: -12rem;\n      left: -5.4rem;\n      font-size: 18rem;\n    }\n  }\n}\n",".privileges {\n  margin-bottom: 18rem;\n\n  // .privileges__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::before {\n      @extend %line;\n      top: -18rem;\n      height: calc(100% + 18rem - 2px);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    &::after {\n      @extend %line;\n      bottom: 0;\n      left: 0;\n      height: 2px;\n      width: 161rem;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n    @media (max-width: 48em) {\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .privileges__head\n\n  &__head {\n    position: relative;\n    padding-left: 3rem;\n    padding-bottom: 2.4rem;\n    &::after {\n      @extend %line;\n      bottom: 0;\n      left: 2px;\n      width: 161rem;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      padding-left: 0;\n      padding-bottom: 3.2rem;\n      border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .privileges__title\n\n  &__title {\n    @media (max-width: 48em) {\n      display: block;\n      max-width: 50rem;\n    }\n  }\n\n  // .privileges__body\n\n  &__body {\n    display: grid;\n    @media (min-width: 48em) {\n      grid-template-columns: 4fr 7fr;\n    }\n  }\n\n  // .privileges__image-wrap\n\n  &__image-wrap {\n    &::after {\n      @extend %line;\n      top: 0;\n      right: 0;\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      position: relative;\n      padding: 3.6rem 3rem;\n    }\n    @media (max-width: 48em) {\n      padding-bottom: 3.2rem;\n      height: 37rem;\n      border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .privileges__image\n\n  &__image,\n  &__card-image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  // .privileges__cards\n\n  &__cards {\n    position: relative;\n    display: grid;\n    &::after {\n      @extend %line;\n      top: 0;\n      right: 50%;\n      width: 2px;\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n  }\n\n  // .privileges__row\n\n  &__row {\n    position: relative;\n    display: grid;\n    &:not(:last-child) {\n      &::after {\n        @extend %line;\n        bottom: 0;\n        left: 0;\n        width: calc(50% - 2px);\n        height: 2px;\n        .scroll-trigger & {\n          transform: scaleX(var(--scaleX));\n        }\n      }\n    }\n    @media (min-width: 48em) {\n      grid-template-columns: repeat(2, 50%);\n    }\n  }\n\n  // .privileges__card\n\n  &__card {\n    position: relative;\n    justify-content: center;\n    height: 100%;\n    &_text {\n      display: flex;\n      flex-direction: column;\n      align-self: center;\n      @media (min-width: 48em) {\n        padding: 10.4rem 3rem;\n      }\n    }\n    @media (max-width: 48em) {\n      padding: 3.2rem 0;\n      border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n\n    // .privileges__card_img\n\n    &_img {\n      width: calc(100% + ((192rem - 145.6rem) / 2));\n      height: 34.7rem;\n      transform: translateY(-2px);\n      @media (max-width: 48em) {\n        display: none;\n      }\n    }\n  }\n\n  // .privileges__heading\n\n  &__heading {\n    margin-bottom: 2.4rem;\n    @media (max-width: 48em) {\n      margin-bottom: 1.6rem;\n    }\n  }\n\n  // .privileges__text\n\n  &__text {\n    @media (min-width: 48em) {\n      max-width: 32.4rem;\n    }\n  }\n}\n",".team {\n  margin-bottom: 18rem;\n\n  // .team__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::before,\n    &::after {\n      @extend %line;\n      top: -18rem;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    &::before {\n      right: 63.2rem;\n    }\n    &::after {\n      left: 0;\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n    @media (max-width: 48em) {\n      padding: 0 3.2rem;\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .team__head\n\n  &__head {\n    position: relative;\n    &::after {\n      @extend %line;\n      bottom: 0;\n      left: 2px;\n      width: 161rem;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (min-width: 48em) {\n      padding-left: 3rem;\n      padding-bottom: 2.4rem;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .team__title\n\n  &__title {\n    font-family: Assistant;\n  }\n\n  // .team__body\n\n  &__body {\n    position: relative;\n    display: grid;\n    &::after {\n      @extend %line;\n      bottom: 0;\n      left: 0;\n      width: 161rem;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (min-width: 48em) {\n      grid-template-columns: 6fr 63.2rem;\n    }\n    @media (max-width: 48em) {\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .team__content\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    @media (min-width: 48em) {\n      padding: 3rem;\n    }\n  }\n\n  // .team__info\n\n  &__info {\n    display: flex;\n    justify-content: space-between;\n    @media (min-width: 48em) {\n      margin-bottom: 40rem;\n      max-width: 66.3rem;\n    }\n    @media (max-width: 48em) {\n      padding-bottom: 3rem;\n      justify-content: flex-start;\n      column-gap: 16rem;\n      border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n\n  // .team__group\n\n  &__group {\n    display: flex;\n    flex-direction: column;\n  }\n\n  // .team__group-heading\n\n  &__group-heading {\n    text-transform: uppercase;\n  }\n\n  // .team__group-txt\n\n  &__group-txt {\n    color: $grey;\n  }\n\n  // .team__text\n\n  &__text {\n    @media (max-width: 48em) {\n      padding: 3rem 0;\n      border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n\n  // .team__image-wrap\n\n  &__image-wrap {\n    @media (min-width: 48em) {\n      padding: 3rem 0 3rem 3rem;\n      min-height: 70rem;\n      width: calc(100% + (192rem - 145.6rem) / 2);\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      height: 58rem;\n      grid-row: 1/2;\n    }\n  }\n\n  // .team__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n",".request {\n  margin-bottom: 18rem;\n\n  // .request__container\n\n  &__container {\n    position: relative;\n    padding: 0 3.2rem;\n    display: grid;\n    &::before {\n      @extend %line;\n      left: 0;\n      top: -18rem;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    &::after {\n      @extend %line;\n      bottom: 0;\n      left: 2px;\n      width: 161rem;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (min-width: 48em) {\n      padding: 3rem;\n      grid-column: 2/3;\n      grid-template-columns: 5fr 6fr;\n    }\n    @media (max-width: 48em) {\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .request__image-wrap\n\n  &__image-wrap {\n    &::before {\n      @extend %line;\n      top: -3rem;\n      left: calc(2px - 3rem);\n      width: 161rem;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (min-width: 48em) {\n      position: relative;\n      min-height: 54.2rem;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      height: 39rem;\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .request__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  // .request__content\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    .contacts-page & {\n      position: relative;\n      &::before {\n        @extend %line;\n        top: -21rem;\n        right: calc(69.8rem - 2px);\n        height: calc(100% + 6rem + 18rem);\n      }\n      &::after {\n        @extend %line;\n        top: -21rem;\n        right: -3rem;\n        height: calc(100% + 6rem + 18rem);\n      }\n    }\n    .projects-page & {\n      position: relative;\n      &::after {\n        @extend %line;\n        top: -21rem;\n        right: 0;\n        height: calc(100% + 24rem - 2px);\n        .scroll-trigger & {\n          transform: scaleY(var(--scaleY));\n        }\n      }\n    }\n    @media (min-width: 48em) {\n      padding-left: 15.6rem;\n    }\n    @media (max-width: 48em) {\n      .contacts-page & {\n        &::before,\n        &::after {\n          display: none;\n        }\n      }\n      .projects-page & {\n        &::after {\n          display: none;\n        }\n      }\n    }\n  }\n\n  // .request__text-wrap\n\n  &__text-wrap {\n    margin-bottom: 5.6rem;\n    display: flex;\n    flex-direction: column;\n    @media (max-width: 48em) {\n      margin-bottom: 4.8rem;\n    }\n  }\n\n  // .request__title\n\n  &__title {\n    margin-bottom: 2.4rem;\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n    }\n  }\n\n  // .request__text\n\n  &__text {\n  }\n\n  // .request__form\n\n  &__form {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 49.9rem;\n    @media (max-width: 48em) {\n      display: grid;\n      grid-template-columns: repeat(2, auto);\n      column-gap: 2rem;\n      width: 100%;\n    }\n  }\n\n  // .request__fields\n\n  &__fields {\n    margin-bottom: 5.6rem;\n    display: flex;\n    flex-direction: column;\n    row-gap: 3rem;\n    width: 100%;\n    @media (max-width: 48em) {\n      margin-bottom: 4.8rem;\n      grid-column: span 2;\n      row-gap: 4.8rem;\n    }\n  }\n\n  // .request__input\n\n  &__input {\n  }\n\n  // .request__checkbox\n\n  &__checkbox {\n  }\n\n  // .request__btn\n\n  &__btn {\n    min-width: 15.3rem;\n    @media (max-width: 48em) {\n      min-width: 24.6rem;\n      order: 1;\n    }\n  }\n}\n",".our-team {\n  margin-bottom: 18rem;\n  @media (max-width: 48em) {\n    display: none;\n  }\n\n  // .our-team__container\n\n  &__container {\n    display: grid;\n    &::before {\n      @extend %line;\n      z-index: 3;\n      left: 0;\n      top: -18rem;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      position: relative;\n      grid-template-columns: 6fr 6fr;\n      grid-column: 2/3;\n    }\n    @media (max-width: 48em) {\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .our-team__text-wrap\n\n  &__text-wrap {\n    position: relative;\n    padding: 3rem;\n    display: flex;\n    flex-direction: column;\n    &::before {\n      content: '';\n      position: absolute;\n      z-index: 2;\n      top: -1%;\n      right: 0;\n      width: calc(145.6rem + (192rem - 145.6rem - 15rem) / 2 - 2px);\n      height: 101%;\n      background-color: $bg;\n    }\n  }\n\n  // .our-team__title\n\n  &__title {\n    position: relative;\n    z-index: 3;\n    margin-bottom: 2.4rem;\n  }\n\n  // .our-team__text\n\n  &__text {\n    position: relative;\n    z-index: 3;\n    margin-bottom: 3.2rem;\n  }\n\n  // .our-team__slider-control\n\n  &__slider-control {\n    position: relative;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    column-gap: 3rem;\n  }\n\n  // .our-team__slider-btn\n\n  &__slider-btn {\n    flex: 0 0 5rem;\n    width: 5rem;\n    svg {\n      width: 5rem;\n    }\n  }\n\n  // .our-team__slider\n\n  &__slider {\n    position: relative;\n    padding: 4rem 0;\n    min-width: 0;\n    &::before,\n    &::after {\n      @extend %line;\n      z-index: 3;\n      right: calc((192rem - 145.6rem - 15rem - 4px) / -2);\n      width: calc(145.6rem + (192rem - 145.6rem - 15rem) / 2 - 4px);\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    &::before {\n      top: 0;\n    }\n    &::after {\n      bottom: 0;\n    }\n\n    @media (min-width: 48em) {\n      &.swiper {\n        overflow: visible;\n      }\n    }\n  }\n\n  // .our-team__wrapper\n\n  &__wrapper {\n  }\n\n  // .our-team__slide\n\n  &__slide {\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.slide-our-team {\n  display: flex;\n  flex-direction: column;\n\n  // .slide-our-team__image-wrap\n\n  &__image-wrap {\n    margin-bottom: 2.4rem;\n    height: 37.8rem;\n  }\n\n  // .slide-our-team__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  // .slide-our-team__heading\n\n  &__heading {\n    margin-bottom: 0.4rem;\n  }\n\n  // .slide-our-team__text\n\n  &__text {\n    color: #9a9a9a;\n  }\n}\n",".projects {\n  margin-bottom: 18rem;\n\n  // .projects__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    &::before {\n      @extend %line;\n      top: -18rem;\n      height: calc(100% + 36rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 2.4rem;\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .projects__title\n\n  &__title {\n    margin-bottom: 1.6rem;\n    @media (min-width: 48em) {\n      margin-bottom: 3rem;\n      transform: translateX(3rem);\n    }\n  }\n\n  // .projects__tabs\n\n  &__tabs {\n    &.swiper {\n      overflow: visible;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 5rem;\n    }\n  }\n\n  // .projects__tabs-wrapper\n\n  &__tabs-wrapper {\n    position: relative;\n    &::before,\n    &::after {\n      @extend %line;\n      left: 2px;\n      width: calc(161.3rem - 4px);\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    &::before {\n      top: -2px;\n    }\n    &::after {\n      bottom: -2px;\n    }\n    @media (min-width: 48em) {\n      &.swiper-wrapper {\n        display: grid;\n        grid-template-columns: repeat(2, calc(100% / 2));\n      }\n    }\n    @media (max-width: 48em) {\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .projects__tabs-col\n\n  &__tabs-col {\n    display: flex;\n    justify-content: space-between;\n    &:first-child {\n      margin-left: 2px;\n    }\n    @media (max-width: 48em) {\n      display: none;\n    }\n  }\n\n  // .projects__tab\n\n  &__tab {\n    .tab__text::after {\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      flex: 1 1 auto;\n    }\n  }\n\n  // .projects__body\n\n  &__body {\n    position: relative;\n    margin-bottom: 9.6rem;\n    display: grid;\n    row-gap: 9.6rem;\n    &::before,\n    &::after {\n      @extend %line;\n      top: 2px;\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    &::before {\n      left: calc(50% - 2px);\n    }\n    &::after {\n      right: 0;\n      height: calc(100% + 11.1rem + 18rem);\n    }\n    @media (max-width: 48em) {\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n    @media (min-width: 48em) {\n      margin-bottom: 6.2rem;\n      grid-template-columns: repeat(2, calc(100% / 2));\n      row-gap: 8.6rem;\n    }\n  }\n\n  // .projects__card\n\n  &__card {\n  }\n\n  // .projects__btn\n\n  &__btn {\n    min-width: 29.6rem;\n    align-self: flex-start;\n    @media (min-width: 48em) {\n      align-self: center;\n      min-width: 18.2rem;\n    }\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.card-projects {\n  @media (any-hover: hover) {\n    &:hover {\n      .card-projects__image-wrap {\n        filter: grayscale(1);\n      }\n      .card-projects__link {\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n  }\n  @media (min-width: 48em) {\n    padding: 3rem 3rem 0 3rem;\n    user-select: none;\n  }\n\n  // .card-projects__inner\n\n  &__inner {\n    display: flex;\n    flex-direction: column;\n  }\n\n  // .card-projects__image-wrap\n\n  &__image-wrap {\n    margin-bottom: 3.2rem;\n    height: 48rem;\n    width: 100%;\n    @media (min-width: 48em) {\n      margin-bottom: 2.4rem;\n      height: 50rem;\n      will-change: contents;\n      transition: filter 0.3s ease;\n    }\n  }\n\n  // .card-projects__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  // .card-projects__heading-wrap\n\n  &__heading-wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  // .card-projects__heading\n\n  &__heading {\n    @media (max-width: 48em) {\n      font-weight: 400;\n    }\n  }\n\n  // .card-projects__link\n\n  &__link {\n    opacity: 0;\n    visibility: hidden;\n    transform: translateX(-0.8rem);\n    transition: all 0.3s ease;\n  }\n\n  // .card-projects__info-wrap\n\n  &__info-wrap {\n    padding: 1.6rem 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  }\n\n  // .card-projects__info\n\n  &__info {\n  }\n}\n",".image-text {\n  margin-bottom: 18rem;\n\n  // .image-text__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column-reverse;\n    &::before {\n      @extend %line;\n      top: -18rem;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      display: grid;\n      grid-template-columns: 8fr 2fr;\n      grid-column: 2/3;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 2.4rem;\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .image-text__text-wrap\n\n  &__text-wrap {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::after {\n      @extend %line;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n  }\n\n  // .image-text__head\n\n  &__head {\n    position: relative;\n    &::before,\n    &::after {\n      @extend %line;\n      left: 0;\n      width: 100%;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    &::before {\n      top: 0;\n    }\n    &::after {\n      bottom: 0;\n    }\n    @media (min-width: 48em) {\n      padding: 3.2rem 3rem;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .image-text__title\n\n  &__title {\n    display: flex;\n    flex-direction: column;\n  }\n\n  // .image-text__title-txt\n\n  &__title-txt {\n  }\n\n  // .image-text__body\n\n  &__body {\n    padding: 3.2rem 0;\n    position: relative;\n    display: flex;\n    column-gap: 9.8rem;\n    &::before {\n      @extend %line;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    @media (max-width: 48em) {\n      flex-direction: column;\n      row-gap: 2rem;\n    }\n    @media (min-width: 48em) {\n      padding: 3.2rem 3rem;\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .image-text__col\n\n  &__col {\n    display: flex;\n    flex-direction: column;\n    row-gap: 1rem;\n    @media (max-width: 48em) {\n      row-gap: 2rem;\n    }\n  }\n\n  // .image-text__text\n\n  &__text {\n    @media (min-width: 48em) {\n      max-width: 42.5rem;\n    }\n  }\n\n  // .image-text__image-wrap\n\n  &__image-wrap {\n    height: 37rem;\n    @media (min-width: 48em) {\n      width: calc(100% + 23.2rem);\n      height: 100%;\n      min-height: 77.1rem;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n    }\n  }\n\n  // .image-text__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n",".hero-project {\n  margin-bottom: 23.6rem;\n  @media (max-width: 48em) {\n    margin-bottom: 18rem;\n  }\n\n  // .hero-project__sidebar\n\n  &__sidebar {\n  }\n\n  // .hero-project__body\n\n  &__body {\n    position: relative;\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n  }\n\n  // .hero-project__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::before {\n      @extend %line;\n      top: 0;\n      left: 0;\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (max-width: 48em) {\n      padding: 0;\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .hero-project__grid\n\n  &__grid {\n    display: grid;\n    @media (min-width: 48em) {\n      margin-bottom: 1.7rem;\n      grid-template-columns: 4fr 7fr;\n    }\n  }\n\n  // .hero-project__text-wrap\n\n  &__text-wrap {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    @media (min-width: 48em) {\n      padding: 36.2rem 6.4rem 24.9rem 3rem;\n      height: 100%;\n    }\n  }\n\n  // .hero-project__title\n\n  &__title {\n    margin-bottom: 3.2rem;\n    display: flex;\n    flex-direction: column;\n    @media (max-width: 48em) {\n      margin-bottom: 2rem;\n      max-width: 40rem;\n    }\n  }\n\n  // .hero-project__slider-nav\n\n  &__slider-nav {\n    display: flex;\n    align-items: center;\n    gap: 1.6rem;\n    @media (max-width: 48em) {\n      flex-direction: column;\n      align-items: flex-end;\n    }\n  }\n\n  // .hero-project__slider-arr\n\n  &__slider-arr {\n  }\n\n  // .hero-project__carousel\n\n  &__carousel {\n    width: 100%;\n    overflow: hidden;\n    @media (min-width: 48em) {\n      padding-top: 10rem;\n      width: calc(100% + 129.2rem);\n      .two-slides & {\n        margin-left: 9rem;\n        width: 112rem;\n      }\n      .three-slides & {\n        margin-left: 9rem;\n        width: 163rem;\n      }\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      order: -1;\n    }\n  }\n\n  // .hero-project__slider\n\n  &__slider {\n  }\n\n  // .hero-project__wrapper\n\n  &__wrapper {\n  }\n\n  // .hero-project__slide\n\n  &__slide {\n    @media (min-width: 48em) {\n      width: 52rem;\n      .one-slide & {\n        width: 100%;\n      }\n    }\n  }\n\n  // .hero-project__slide-text\n\n  &__slide-text {\n  }\n\n  // .hero-project__bg-image\n\n  &__bg-image {\n    height: 72.1rem;\n    @media (max-width: 48em) {\n      height: 91rem;\n    }\n  }\n\n  // .hero-project__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  // .hero-project__group\n\n  &__group {\n    display: grid;\n    @media (min-width: 48em) {\n      padding-left: 3rem;\n      grid-template-columns: 4fr 7fr;\n    }\n    @media (max-width: 48em) {\n      padding: 0 4rem;\n      grid-template-columns: repeat(2, auto);\n      column-gap: 10rem;\n    }\n  }\n\n  // .hero-project__group-text-wrap\n\n  &__group-text-wrap {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    row-gap: 3.2rem;\n    @media (max-width: 48em) {\n      column-gap: 5rem;\n    }\n  }\n\n  // .hero-project__text\n\n  &__text {\n    @media (max-width: 48em) {\n      max-width: 45rem;\n    }\n  }\n\n  // .hero-project__btn\n\n  &__btn {\n    min-width: 20rem;\n    @media (max-width: 48em) {\n      min-width: 32.8rem;\n    }\n  }\n\n  // .hero-project__slider-fraction\n\n  &__slider-fraction {\n    @media (min-width: 48em) {\n      &.sl-fraction {\n        column-gap: 9.8rem;\n        .sl-fraction__progress {\n          flex: 1 1 auto;\n          width: 100%;\n        }\n      }\n    }\n    @media (max-width: 48em) {\n      order: -1;\n    }\n  }\n\n  // .hero-project__slider-control\n\n  &__slider-control {\n    .one-slide & {\n      .sl-fraction__progress {\n        display: none;\n      }\n    }\n    @media (max-width: 48em) {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n      row-gap: 8rem;\n    }\n    @media (min-width: 48em) {\n      align-self: flex-end;\n    }\n  }\n}\n",".project-info {\n  margin-bottom: 18rem;\n\n  // .project-info__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::before {\n      @extend %line;\n      top: -23.6rem;\n      left: 0;\n      height: calc(100% + 23.6rem);\n      .scroll-trigger & {\n        transform: scaleY((var(--scaleY)));\n      }\n    }\n    @media (max-width: 48em) {\n      &::before {\n        display: none;\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n  }\n\n  // .project-info__head\n\n  &__head {\n    padding-bottom: 3.2rem;\n    @media (min-width: 48em) {\n      padding-left: 3rem;\n    }\n  }\n\n  // .project-info__title\n\n  &__title {\n  }\n\n  // .project-info__body\n\n  &__body {\n    position: relative;\n    padding: 3.2rem 0 0 0;\n    display: grid;\n    &::before,\n    &::after {\n      @extend %line;\n      left: 0;\n      height: 2px;\n      width: 100%;\n      .scroll-trigger & {\n        transform: scaleX((var(--scaleX)));\n      }\n    }\n    &::before {\n      top: 0;\n    }\n    &::after {\n      bottom: 0;\n    }\n    @media (min-width: 48em) {\n      padding: 3rem 3.2rem;\n      grid-template-columns: 7fr 4fr;\n      column-gap: 3rem;\n      &::before,\n      &::after {\n        width: calc(100% + 23.2rem);\n      }\n    }\n  }\n\n  // .project-info__slider\n\n  &__slider {\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n    }\n  }\n\n  // .project-info__wrapper\n\n  &__wrapper {\n  }\n\n  // .project-info__slide\n\n  &__slide {\n    display: flex;\n    min-height: 67.8rem;\n    @media (max-width: 48em) {\n      height: 52.8rem;\n      min-height: auto;\n    }\n  }\n\n  // .project-info__slider-nav\n\n  &__slider-nav {\n    display: flex;\n    align-items: center;\n    column-gap: 1.6rem;\n    @media (max-width: 48em) {\n      justify-content: space-between;\n    }\n  }\n\n  // .project-info__image-wrap\n\n  &__image-wrap {\n    height: 100%;\n  }\n\n  // .project-info__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  // .project-info__content\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    @media (max-width: 48em) {\n      order: -1;\n    }\n  }\n\n  // .project-info__text-wrap\n\n  &__text-wrap {\n    margin-bottom: 3.2rem;\n    display: flex;\n    flex-direction: column;\n    row-gap: 1rem;\n    @media (max-width: 48em) {\n      row-gap: 2rem;\n    }\n  }\n\n  // .project-info__text\n\n  &__text {\n    @media (min-width: 48em) {\n      max-width: 52rem;\n    }\n  }\n\n  // .project-info__footer\n\n  &__footer {\n  }\n}\n",".project-layout {\n  margin-bottom: 18rem;\n\n  // .project-layout__container\n\n  &__container {\n    position: relative;\n    display: grid;\n    &::before,\n    &::after {\n      @extend %line;\n      left: 0;\n      width: calc(100% + 129.2rem);\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX((var(--scaleX)));\n      }\n    }\n    &::before {\n      top: 0;\n    }\n    &::after {\n      bottom: 0;\n    }\n    @media (min-width: 48em) {\n      grid-template-columns: 4fr 7fr;\n      grid-column: 2/3;\n      column-gap: 3rem;\n    }\n    @media (max-width: 48em) {\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .project-layout__content\n\n  &__content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    &::before,\n    &::after {\n      @extend %line;\n      .scroll-trigger & {\n        transform: scaleY((var(--scaleY)));\n      }\n    }\n    &::before {\n      top: -18rem;\n      left: 0;\n      height: calc(100% + 18rem);\n    }\n    &::after {\n      top: 0;\n      right: 0;\n      height: 100%;\n    }\n    @media (max-width: 48em) {\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .project-layout__head\n\n  &__head {\n    position: relative;\n    padding: 3.2rem;\n    width: 100%;\n    &::after {\n      @extend %line;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX((var(--scaleX)));\n      }\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      padding: 0 0 3.2rem 0;\n    }\n  }\n\n  // .project-layout__title\n\n  &__title {\n  }\n\n  // .project-layout__body\n\n  &__body {\n    padding: 0 0 3.2rem 0;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    @media (min-width: 48em) {\n      padding: 3rem;\n      flex: 1 1 auto;\n    }\n  }\n\n  // .project-layout__text-wrap\n\n  &__text-wrap {\n    @media (min-width: 48em) {\n      margin-bottom: auto;\n      max-width: 38.3rem;\n    }\n  }\n\n  // .project-layout__text\n\n  &__text {\n  }\n\n  // .project-layout__slider-nav\n\n  &__slider-nav {\n    display: flex;\n    align-items: center;\n    column-gap: 1.6rem;\n    @media (max-width: 48em) {\n      justify-content: space-between;\n    }\n  }\n\n  // .project-layout__slider-arr\n\n  &__slider-arr {\n    // .project-layout__slider-arr_prev\n\n    &_prev {\n    }\n\n    // .project-layout__slider-arr_next\n\n    &_next {\n    }\n  }\n\n  // .project-layout__slider\n\n  &__slider {\n    position: relative;\n    &::after {\n      @extend %line;\n      top: 0;\n      right: 0;\n      .scroll-trigger & {\n        transform: scaleY((var(--scaleY)));\n      }\n    }\n    @media (min-width: 48em) {\n      padding: 3rem 3rem 3rem 0;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .project-layout__wrapper\n\n  &__wrapper {\n  }\n\n  // .project-layout__slide\n\n  &__slide {\n    display: flex;\n    min-height: 67.8rem;\n    @media (max-width: 48em) {\n      height: 52.8rem;\n      min-height: auto;\n    }\n  }\n\n  // .project-layout__image-wrap\n\n  &__image-wrap {\n    display: flex;\n    align-items: center;\n    background-color: $white;\n  }\n\n  // .project-layout__image\n\n  &__image {\n    object-fit: contain;\n  }\n\n  // .project-layout__footer\n\n  &__footer {\n  }\n}\n",".project-interiors {\n  margin-bottom: 18rem;\n\n  // .project-interiors__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    &::before {\n      @extend %line;\n      top: -18rem;\n      left: 0;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY((var(--scaleY)));\n      }\n    }\n    @media (max-width: 48em) {\n      &::before {\n        display: none;\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n  }\n\n  // .project-interiors__head\n\n  &__head {\n    margin-bottom: 3.2rem;\n    display: flex;\n    justify-content: space-between;\n    @media (min-width: 48em) {\n      padding-left: 3rem;\n    }\n  }\n\n  // .project-interiors__title\n\n  &__title {\n  }\n\n  // .project-interiors__slider-nav\n\n  &__slider-nav {\n    display: flex;\n    align-items: center;\n    column-gap: 1.6rem;\n    @media (min-width: 48em) {\n      align-self: flex-end;\n    }\n    @media (max-width: 48em) {\n      justify-content: space-between;\n    }\n  }\n\n  // .project-interiors__slider-arr\n\n  &__slider-arr {\n    // .project-interiors__slider-arr_prev\n\n    &_prev {\n    }\n\n    // .project-interiors__slider-arr_next\n\n    &_next {\n    }\n  }\n\n  // .project-interiors__body\n\n  &__body {\n    position: relative;\n    padding: 3rem 0 3rem 3rem;\n    &::before,\n    &::after {\n      @extend %line;\n      left: 0;\n      width: calc(100% + 129.2rem);\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX((var(--scaleX)));\n      }\n    }\n    &::before {\n      top: 0;\n    }\n    &::after {\n      bottom: 0;\n    }\n    @media (max-width: 48em) {\n      padding: 3.2rem 0;\n      &::before {\n        width: 100%;\n      }\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .project-interiors__slider\n\n  &__slider {\n  }\n\n  // .project-interiors__wrapper\n\n  &__wrapper {\n  }\n\n  // .project-interiors__slide\n\n  &__slide {\n  }\n\n  // .project-interiors__image-wrap\n\n  &__image-wrap {\n    height: 84rem;\n    @media (max-width: 48em) {\n      height: 100rem;\n    }\n  }\n\n  // .project-interiors__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n",".portfolio {\n  margin-bottom: 18rem;\n\n  // .portfolio__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::before {\n      @extend %line;\n      top: -18rem;\n      left: 0;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (max-width: 48em) {\n      &::before {\n        display: none;\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n  }\n\n  // .portfolio__head\n\n  &__head {\n    position: relative;\n    margin-bottom: 3.2rem;\n    &::after {\n      @extend %line;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 2px;\n    }\n    @media (min-width: 48em) {\n      padding-left: 3rem;\n      &::after {\n        display: none;\n        .scroll-trigger & {\n          transform: scaleX(var(--scaleX));\n        }\n      }\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 5rem;\n      padding-bottom: 3.2rem;\n    }\n  }\n\n  // .portfolio__title\n\n  &__title {\n  }\n\n  // .portfolio__body\n\n  &__body {\n    position: relative;\n    display: grid;\n    &::after {\n      @extend %line;\n      right: 0;\n      top: 0;\n    }\n    @media (max-width: 48em) {\n      row-gap: 10rem;\n      &::after {\n        display: none;\n      }\n    }\n    @media (min-width: 48em) {\n      &::after {\n        .scroll-trigger & {\n          transform: scaleY(var(--scaleY));\n        }\n      }\n    }\n  }\n\n  // .portfolio__row\n\n  &__row {\n    position: relative;\n    display: grid;\n    &:last-child::after,\n    &::before {\n      @extend %line;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 2px;\n    }\n    &:last-child::after {\n      top: auto;\n      bottom: 0;\n      width: calc(100% + 23.2rem);\n    }\n    @media (min-width: 48em) {\n      grid-template-columns: repeat(4, 1fr);\n      &::before,\n      &:last-child::after {\n        .scroll-trigger & {\n          transform: scaleX(var(--scaleX));\n        }\n      }\n    }\n    @media (max-width: 48em) {\n      padding-bottom: 3.2rem;\n      row-gap: 3.2rem;\n      &::before {\n        top: auto;\n        bottom: 0;\n      }\n      &:last-child::after {\n        width: 100%;\n      }\n    }\n  }\n\n  // .portfolio__cell\n\n  &__cell {\n    position: relative;\n    &:not(:last-child) {\n      &::after {\n        @extend %line;\n        top: 0;\n        right: 0;\n      }\n    }\n    @media (min-width: 48em) {\n      padding: 3rem;\n      &::after {\n        .scroll-trigger & {\n          transform: scaleY(var(--scaleY));\n        }\n      }\n    }\n    @media (max-width: 48em) {\n      &:not(:last-child) {\n        &::after {\n          display: none;\n        }\n      }\n      &_info {\n        order: -1;\n      }\n    }\n\n    // .portfolio__cell_large\n\n    &_large {\n      @media (min-width: 48em) {\n        grid-column: span 2;\n      }\n    }\n  }\n\n  // .portfolio__image-wrap\n\n  &__image-wrap {\n    display: flex;\n    height: 44rem;\n    @media (max-width: 48em) {\n      height: 59.2rem;\n    }\n  }\n\n  // .portfolio__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  // .portfolio__info\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    @media (min-width: 48em) {\n      height: 100%;\n    }\n  }\n\n  // .portfolio__heading\n\n  &__heading {\n    margin-bottom: 2.4rem;\n  }\n\n  // .portfolio__text\n\n  &__text {\n    margin-bottom: auto;\n    color: #9a9a9a;\n    @media (max-width: 48em) {\n      margin-bottom: 2.4rem;\n    }\n  }\n\n  // .portfolio__square\n\n  &__square {\n    @media (max-width: 48em) {\n      font-weight: 400;\n    }\n  }\n\n  // .portfolio__footer\n\n  &__footer {\n    position: relative;\n    padding: 3rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    &::after {\n      @extend %line;\n      bottom: 0;\n      left: 0;\n      width: calc(100% + 23.2rem);\n      height: 2px;\n    }\n    @media (max-width: 48em) {\n      padding: 3.2rem 0;\n      &::after {\n        width: 100%;\n      }\n    }\n    @media (min-width: 48em) {\n      &::after {\n        .scroll-trigger & {\n          transform: scaleX(var(--scaleX));\n        }\n      }\n    }\n  }\n\n  // .portfolio__page-nav\n\n  &__page-nav {\n  }\n\n  // .portfolio__page-control\n\n  &__page-control {\n    display: flex;\n    align-items: center;\n    column-gap: 1.6rem;\n  }\n\n  // .portfolio__nav-btn\n\n  &__nav-btn {\n  }\n}\n",".contacts {\n  margin-bottom: 18rem;\n\n  // .contacts__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::before {\n      @extend %line;\n      top: 0;\n      left: 0;\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    &::after {\n      @extend %line;\n      top: 0;\n      right: 0;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (max-width: 48em) {\n      padding: 0;\n      &::before,\n      &::after {\n        display: none;\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n  }\n\n  // .contacts__content\n\n  &__content {\n    padding-top: 13.6rem;\n    display: grid;\n    &::after {\n      @extend %line;\n      top: 0;\n      left: calc(145.6rem / 2);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      grid-template-columns: repeat(2, calc(145.6rem / 2));\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 10rem;\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  // .contacts__column\n\n  &__column {\n    display: flex;\n    flex-direction: column;\n\n    // .contacts__column_info\n\n    &_info {\n      justify-content: flex-end;\n    }\n\n    @media (min-width: 48em) {\n      &:not(&_info) {\n        padding-bottom: 20.9rem;\n        padding-left: 18rem;\n        padding-right: 3rem;\n      }\n      &_info {\n        padding-bottom: 10rem;\n        padding-left: 3rem;\n      }\n    }\n    @media (max-width: 48em) {\n      &_info {\n        padding: 3.2rem 3.2rem 0 3.2rem;\n      }\n    }\n  }\n\n  // .contacts__title\n\n  &__title {\n    margin-bottom: 5.6rem;\n  }\n\n  // .contacts__image-wrap\n\n  &__image-wrap {\n    position: relative;\n    z-index: 2;\n    margin-bottom: 5.6rem;\n    height: 30.8rem;\n    width: 51rem;\n    &_abs {\n      position: absolute;\n      top: 12rem;\n      right: calc((192rem - 145.6rem) / -2);\n      width: 41.5rem;\n      height: 58.5rem;\n    }\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(70, 74, 80, 0.2);\n    }\n    @media (max-width: 48em) {\n      margin: 0;\n      width: 100%;\n      height: 75.4rem;\n      &_abs {\n        display: none;\n      }\n    }\n  }\n\n  // .contacts__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n    @media (min-width: 48em) {\n      &:not(.contacts__image-wrap_abs &) {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 63.3rem;\n      }\n    }\n  }\n\n  // .contacts__tel\n\n  &__tel {\n    margin-bottom: 3.4rem;\n    font-weight: 400;\n    @media (max-width: 48em) {\n      margin-bottom: 2.4rem;\n      order: -1;\n    }\n  }\n\n  // .contacts__btn\n\n  &__btn {\n    min-width: 20.5rem;\n    align-self: flex-start;\n    @media (max-width: 48em) {\n      margin-bottom: 5rem;\n      min-width: 32rem;\n    }\n  }\n\n  // .contacts__info\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    row-gap: 2.4rem;\n  }\n\n  // .contacts__group\n\n  &__group {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    row-gap: 0.8rem;\n  }\n\n  // .contacts__group-subtitle\n\n  &__group-subtitle {\n    color: #9a9a9a;\n  }\n\n  // .contacts__group-text\n\n  &__group-text {\n    max-width: 29.2rem;\n    @media (max-width: 48em) {\n      max-width: 53.2rem;\n    }\n  }\n\n  // .contacts__map\n\n  &__map {\n    position: relative;\n    z-index: 5;\n    padding-left: 16.2rem;\n    padding-right: 3rem;\n    width: 100%;\n    height: 69.5rem;\n    @media (max-width: 48em) {\n      padding: 0 3.2rem;\n      height: 84.4rem;\n      width: 100vw;\n    }\n  }\n}\n",".company-info {\n  margin-bottom: 18rem;\n\n  // .company-info__container\n\n  &__container {\n    position: relative;\n    display: grid;\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n  }\n\n  // .company-info__info\n\n  &__info {\n  }\n\n  // .company-info__numbers\n\n  &__numbers {\n  }\n\n  // .company-info__privileges\n\n  &__privileges {\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.info-company-info {\n  position: relative;\n  display: grid;\n  &::before {\n    @extend %line;\n    top: -18rem;\n    left: 0;\n    height: calc(100% + 18rem);\n    .scroll-trigger & {\n      transform: scaleY(var(--scaleY));\n    }\n  }\n  &::after {\n    @extend %line;\n    bottom: 0;\n    left: 0;\n    width: calc(100% + 23.2rem);\n    height: 2px;\n    .scroll-trigger & {\n      transform: scaleX(var(--scaleX));\n    }\n  }\n  @media (min-width: 48em) {\n    grid-template-columns: 62.2rem 1fr;\n  }\n  @media (max-width: 48em) {\n    margin-bottom: 17.6rem;\n    &::before {\n      display: none;\n    }\n    &::after {\n      width: 100%;\n    }\n  }\n\n  // .info-company-info__text-wrap\n\n  &__text-wrap {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    &::before {\n      @extend %line;\n      top: -18rem;\n      right: 0;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      padding: 0 3rem 3rem 3rem;\n    }\n    @media (max-width: 48em) {\n      .info-company-info__text {\n        padding: 3.2rem 0;\n        margin-bottom: 3.2rem;\n        padding-bottom: 3.2rem;\n        border-bottom: 2px solid #505050;\n      }\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .info-company-info__heading\n\n  &__heading {\n    @media (min-width: 48em) {\n      margin-bottom: auto;\n    }\n    @media (max-width: 48em) {\n      padding-bottom: 3.2rem;\n      border-bottom: 2px solid #505050;\n      font-weight: 500;\n    }\n  }\n\n  // .info-company-info__text\n\n  &__text {\n    color: #9a9a9a;\n    @media (min-width: 48em) {\n      max-width: 54.5rem;\n    }\n  }\n\n  // .info-company-info__image-wrap\n\n  &__image-wrap {\n    padding-left: 3rem;\n    padding-bottom: 3rem;\n    display: flex;\n    justify-content: space-between;\n    column-gap: 3rem;\n    .info-company-info__text {\n      max-width: 23.5rem;\n      text-transform: uppercase;\n    }\n    @media (max-width: 48em) {\n      padding: 0 0 3.2rem 0;\n      flex-direction: column;\n      border-bottom: 2px solid #505050;\n      .info-company-info__text {\n        margin-bottom: 3.2rem;\n        padding-right: 15rem;\n        padding-bottom: 3.2rem;\n        max-width: none;\n        border-bottom: 2px solid #505050;\n      }\n    }\n  }\n\n  // .info-company-info__image\n\n  &__image {\n    width: 54rem;\n    min-height: 60rem;\n    img {\n      height: 100%;\n      object-fit: cover;\n    }\n    @media (max-width: 48em) {\n      width: 100%;\n      height: 59.2rem;\n    }\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.numbers-company-info {\n  position: relative;\n  display: grid;\n  &::before {\n    @extend %line;\n    top: -18rem;\n    left: 0;\n    height: calc(100% + 18rem);\n    .scroll-trigger & {\n      transform: scaleY(var(--scaleY));\n    }\n  }\n  &::after {\n    @extend %line;\n    bottom: 0;\n    left: 0;\n    width: calc(100% + 23.2rem);\n    height: 2px;\n    .scroll-trigger & {\n      transform: scaleX(var(--scaleX));\n    }\n  }\n  @media (min-width: 48em) {\n    padding: 18rem 0;\n    grid-template-columns: 1fr 66.3rem 1fr;\n  }\n  @media (max-width: 48em) {\n    margin-bottom: 18rem;\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n\n  // .numbers-company-info__row\n\n  &__row {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    &_left {\n      position: relative;\n      padding-left: 3rem;\n      &::after {\n        @extend %line;\n        top: -18rem;\n        left: calc(62.2rem - 2px);\n        height: calc(100% + 36rem);\n        .scroll-trigger & {\n          transform: scaleY(var(--scaleY));\n        }\n      }\n    }\n    &_right {\n      align-items: flex-end;\n      .numbers-company-info__group {\n        align-items: flex-end;\n        text-align: right;\n      }\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      padding-bottom: 3.2rem;\n      flex-direction: row;\n      justify-content: space-between;\n      border-bottom: 2px solid #505050;\n      &::after {\n        display: none;\n      }\n      &_right {\n        display: none;\n      }\n    }\n  }\n\n  // .numbers-company-info__group\n\n  &__group {\n    display: flex;\n    flex-direction: column;\n    &_bottom {\n      margin-top: auto;\n    }\n  }\n\n  // .numbers-company-info__heading\n\n  &__heading {\n    font-family: Assistant;\n    font-size: 5.4rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    @media (max-width: 48em) {\n      margin-bottom: 0.8rem;\n      font-size: 4rem;\n    }\n  }\n\n  // .numbers-company-info__text\n\n  &__text {\n    color: #9a9a9a;\n  }\n\n  // .numbers-company-info__image-wrap\n\n  &__image-wrap {\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    height: 44rem;\n    @media (max-width: 48em) {\n      height: 45.6rem;\n    }\n  }\n\n  // .numbers-company-info__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.privileges-company-info {\n  position: relative;\n  display: grid;\n  &::before {\n    @extend %line;\n    top: 0;\n    left: 0;\n    .scroll-trigger & {\n      transform: scaleY(var(--scaleY));\n    }\n  }\n  &::after {\n    @extend %line;\n    bottom: 0;\n    left: 0;\n    width: calc(100% + 23.2rem);\n    height: 2px;\n    .scroll-trigger & {\n      transform: scaleX(var(--scaleX));\n    }\n  }\n  @media (min-width: 48em) {\n    grid-template-columns: 7fr 4fr;\n  }\n  @media (max-width: 48em) {\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n\n  // .privileges-company-info__column\n\n  &__column {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    min-width: 0;\n    &:last-child {\n      position: relative;\n      padding-right: 0;\n      &::before {\n        @extend %line;\n        top: 0;\n        left: 0;\n        .scroll-trigger & {\n          transform: scaleY(var(--scaleY));\n        }\n      }\n    }\n    @media (min-width: 48em) {\n      padding: 3rem;\n    }\n    @media (max-width: 48em) {\n      &:first-child {\n        .privileges-company-info__text {\n          @media (max-width: 48em) {\n            margin-bottom: 3.2rem;\n            padding-bottom: 3.2rem;\n            max-width: none;\n            border-bottom: 2px solid #505050;\n          }\n        }\n      }\n      &:last-child {\n        &::before {\n          display: none;\n        }\n      }\n    }\n  }\n\n  // .privileges-company-info__heading\n\n  &__heading {\n    margin-bottom: 2.4rem;\n    font-weight: 500;\n    line-height: 130%;\n    color: #9a9a9a;\n    @media (max-width: 48em) {\n      margin-bottom: 1.6rem;\n      font-size: 3.6rem;\n    }\n  }\n\n  // .privileges-company-info__text\n\n  &__text {\n    margin-bottom: auto;\n    max-width: 63.2rem;\n    font-weight: 500;\n    line-height: 130%;\n  }\n\n  // .privileges-company-info__btn\n\n  &__btn {\n    min-width: 20.5rem;\n  }\n\n  // .privileges-company-info__slider\n\n  &__slider {\n    margin-bottom: 3rem;\n    width: 100%;\n  }\n\n  // .privileges-company-info__wrapper\n\n  &__wrapper {\n  }\n\n  // .privileges-company-info__slide\n\n  &__slide {\n    display: flex;\n    flex-direction: column;\n  }\n\n  // .privileges-company-info__ellipse\n\n  &__ellipse {\n    flex: 0 0 7.8rem;\n    width: 7.8rem;\n    height: 5.7rem;\n    @media (max-width: 48em) {\n      flex: 0 0 10rem;\n      width: 10rem;\n      height: 8rem;\n    }\n  }\n\n  // .privileges-company-info__text-wrap\n\n  &__text-wrap {\n    display: flex;\n    flex-direction: column;\n    .privileges-company-info__heading {\n      margin-bottom: 1.6rem;\n      color: $white;\n    }\n    .privileges-company-info__text {\n      position: relative;\n      padding-bottom: 3rem;\n      color: #9a9a9a;\n      &::after {\n        @extend %line;\n        bottom: 0;\n        right: 0;\n        width: 100%;\n        height: 2px;\n        .scroll-trigger & {\n          transform: scaleX(var(--scaleX));\n        }\n      }\n    }\n    @media (min-width: 48em) {\n      .privileges-company-info__text {\n        max-width: 39.8rem;\n      }\n      .privileges-company-info__heading {\n        margin-bottom: 0.8rem;\n      }\n    }\n    @media (max-width: 48em) {\n      .privileges-company-info__text {\n        &::after {\n          width: 100vw;\n        }\n      }\n    }\n  }\n\n  // .privileges-company-info__slide-content\n\n  &__slide-content {\n    display: flex;\n    column-gap: 2.4rem;\n    @media (max-width: 48em) {\n      padding-top: 3.2rem;\n      column-gap: 4rem;\n      border-top: 2px solid #505050;\n    }\n  }\n\n  // .privileges-company-info__slider-control\n\n  &__slider-control {\n    @media (max-width: 48em) {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n    }\n    @media (min-width: 48em) {\n      margin-left: auto;\n    }\n  }\n\n  // .privileges-company-info__slider-nav\n\n  &__slider-nav {\n    display: flex;\n    align-items: center;\n    align-self: flex-end;\n    column-gap: 1.6rem;\n  }\n\n  // .privileges-company-info__image-wrap\n\n  &__image-wrap {\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      height: 45.6rem;\n      width: 100%;\n    }\n  }\n\n  // .privileges-company-info__image\n\n  &__image {\n    @media (max-width: 48em) {\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  // .privileges-company-info__slider-arr\n\n  &__slider-arr {\n    // .privileges-company-info__slider-arr_prev\n\n    &_prev {\n    }\n\n    // .privileges-company-info__slider-arr_next\n\n    &_next {\n    }\n  }\n}\n",".company-methods {\n  margin-bottom: 18rem;\n\n  // .company-methods__container\n\n  &__container {\n    position: relative;\n    display: flex;\n    flex-direction: column-reverse;\n    &::before {\n      @extend %line;\n      top: -18rem;\n      height: calc(100% + 18rem);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n    @media (max-width: 48em) {\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // .company-methods__body\n\n  &__body {\n    position: relative;\n    padding: 3.2rem 0;\n    &::before,\n    &::after {\n      @extend %line;\n      left: 0;\n      width: calc(100% + 23.2rem);\n      height: 2px;\n      .scroll-trigger & {\n        transform: scaleX(var(--scaleX));\n      }\n    }\n    &::before {\n      top: 0;\n    }\n    &::after {\n      bottom: 0;\n    }\n    @media (min-width: 48em) {\n      padding: 3.2rem 3rem 0 3rem;\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n    }\n    @media (max-width: 48em) {\n      &::before,\n      &::after {\n        width: 100%;\n      }\n    }\n  }\n\n  // .company-methods__text-wrap\n\n  &__text-wrap {\n    display: flex;\n    flex-direction: column;\n    @media (min-width: 48em) {\n      padding-bottom: 25.2rem;\n      &_lc {\n        justify-self: end;\n        text-align: right;\n      }\n    }\n    @media (max-width: 48em) {\n      &_fc {\n        margin-bottom: 10rem;\n        flex-direction: row;\n        justify-content: space-between;\n        .company-methods__group {\n          margin: 0;\n          &:last-child {\n            text-align: right;\n          }\n        }\n      }\n    }\n  }\n\n  // .company-methods__group\n\n  &__group {\n    margin-bottom: 33.5rem;\n    display: flex;\n    flex-direction: column;\n  }\n\n  // .company-methods__subtitle\n\n  &__subtitle {\n    text-transform: uppercase;\n  }\n\n  // .company-methods__subtext\n\n  &__subtext {\n    color: #9a9a9a;\n  }\n\n  // .company-methods__text\n\n  &__text {\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      padding-top: 3.2rem;\n      border-top: 2px solid #505050;\n    }\n  }\n\n  // .company-methods__image-wrap\n\n  &__image-wrap {\n    width: 64.3rem;\n    @media (max-width: 48em) {\n      margin-bottom: 8rem;\n    }\n    @media (min-width: 48em) {\n      padding-bottom: 3rem;\n    }\n  }\n\n  // .company-methods__bg-text\n\n  &__bg-text {\n    position: absolute;\n    z-index: -1;\n    top: 20rem;\n    left: 3rem;\n    font-size: 14.6rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    white-space: nowrap;\n    line-height: 170%;\n    opacity: 0.1;\n    @media (max-width: 48em) {\n      top: 22rem;\n      left: 50%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      font-size: 8rem;\n      transform: translateX(-50%);\n      span {\n        font-size: 21.8rem;\n      }\n    }\n  }\n\n  // .company-methods__link\n\n  &__link {\n    @media (max-width: 48em) {\n      transform: none;\n    }\n  }\n}\n",".hero-portfolio {\n  position: relative;\n  margin-bottom: 18rem;\n\n  // .hero-portfolio__container\n\n  &__container {\n    position: relative;\n    min-width: 0;\n    &::before {\n      @extend %line;\n      z-index: 2;\n      top: 0;\n      left: 0;\n      background-color: rgba(255, 255, 255, 0.2);\n      .scroll-trigger & {\n        transform: scaleY(var(--scaleY));\n      }\n    }\n    @media (max-width: 48em) {\n      padding: 0;\n      &::before {\n        display: none;\n      }\n    }\n    @media (min-width: 48em) {\n      grid-column: 2/3;\n    }\n  }\n\n  // .hero-portfolio__carousel\n\n  &__carousel {\n    position: relative;\n  }\n\n  // .hero-portfolio__slider\n\n  &__slider {\n    @media (min-width: 48em) {\n      &.swiper {\n        overflow: visible;\n      }\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 10rem;\n    }\n  }\n\n  // .hero-portfolio__wrapper\n\n  &__wrapper {\n  }\n\n  // .hero-portfolio__slide\n\n  &__slide {\n    @extend %swiperFix;\n  }\n\n  // .hero-portfolio__content\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    @media (min-width: 48em) {\n      position: absolute;\n      top: 12rem;\n      left: 3rem;\n      width: calc(72.7% - 3rem);\n      max-height: calc(100% - 12rem);\n    }\n    @media (max-width: 48em) {\n      padding: 0 3.2rem;\n    }\n  }\n\n  // .hero-portfolio__group\n\n  &__group {\n    margin-bottom: 12rem;\n    display: flex;\n    align-items: center;\n    column-gap: 3rem;\n    &::after {\n      content: '';\n      width: 90.4rem;\n      height: 2px;\n      background-color: rgba(255, 255, 255, 0.5);\n    }\n    @media (max-width: 48em) {\n      position: absolute;\n      top: 77.2rem;\n      left: 3.2rem;\n      column-gap: 2rem;\n      &::after {\n        width: 19.4rem;\n      }\n    }\n  }\n\n  // .hero-portfolio__group-txt\n\n  &__group-txt {\n    white-space: nowrap;\n    &:first-child {\n      order: -1;\n    }\n    &:last-child {\n      order: 1;\n    }\n    @media (max-width: 48em) {\n      font-size: 2.8rem;\n    }\n  }\n\n  // .hero-portfolio__text-wrap\n\n  &__text-wrap {\n    display: flex;\n    flex-direction: column;\n    @media (min-width: 48em) {\n      margin-bottom: 10.2rem;\n    }\n  }\n\n  // .hero-portfolio__title\n\n  &__title {\n    margin-bottom: 3.2rem;\n    display: flex;\n    flex-direction: column;\n    @media (max-width: 48em) {\n      margin-bottom: 5rem;\n      flex-direction: row;\n      column-gap: 2rem;\n    }\n  }\n\n  // .hero-portfolio__text\n\n  &__text {\n    @media (min-width: 48em) {\n      max-width: 36.4rem;\n      color: #b3b3b3;\n    }\n  }\n\n  // .hero-portfolio__slider-control\n\n  &__slider-control {\n    display: flex;\n    flex-direction: column;\n    @media (max-width: 48em) {\n      position: absolute;\n      bottom: 0;\n      right: 3.2rem;\n      flex-direction: column-reverse;\n    }\n  }\n\n  // .hero-portfolio__slider-nav\n\n  &__slider-nav {\n    display: flex;\n    flex-direction: column;\n    row-gap: 1.6rem;\n    @media (min-width: 48em) {\n      margin-bottom: 10.2rem;\n    }\n    @media (max-width: 48em) {\n      flex-direction: column-reverse;\n      align-items: flex-end;\n    }\n  }\n\n  // .hero-portfolio__slider-fraction\n\n  &__slider-fraction {\n    @media (max-width: 48em) {\n      margin-bottom: 8rem;\n      font-size: 3.6rem;\n    }\n  }\n\n  // .hero-portfolio__thumbs-carousel\n\n  &__thumbs-carousel {\n    position: absolute;\n    z-index: 5;\n    bottom: 10rem;\n    right: 0;\n    overflow: hidden;\n  }\n\n  // .hero-portfolio__thumbs\n\n  &__thumbs {\n    width: 68.2rem;\n    height: 23.3rem;\n    &.swiper {\n      overflow: visible;\n    }\n  }\n\n  // .hero-portfolio__thumb\n\n  &__thumb {\n    width: 23.5rem;\n    cursor: pointer;\n  }\n\n  // .hero-portfolio__thumb-image-wrap\n\n  &__thumb-image-wrap {\n    height: 100%;\n  }\n\n  // .hero-portfolio__thumb-image\n\n  &__thumb-image {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n// --------------------------------------------------------------------------\n\n.slide-hero-portfolio {\n  display: grid;\n  width: 100%;\n  @media (min-width: 48em) {\n    grid-template-columns: 8fr 3fr;\n    min-height: 100rem;\n  }\n\n  // .slide-hero-portfolio__image-wrap\n\n  &__image-wrap {\n    position: relative;\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: calc(145.6rem - 192rem);\n      height: 100%;\n      width: calc(192rem - 145.6rem + 100%);\n      background: linear-gradient(\n          70deg,\n          rgba(46, 46, 46, 0.3) 20.45%,\n          rgba(0, 0, 0, 0) 63.6%\n        ),\n        linear-gradient(\n          0deg,\n          rgba(70, 74, 80, 0.2) 0%,\n          rgba(70, 74, 80, 0.4) 100%\n        ),\n        linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.2) 100%);\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 3.2rem;\n      height: 84rem;\n    }\n  }\n\n  // .slide-hero-portfolio__image\n\n  &__image {\n    height: 100%;\n    object-fit: cover;\n    @media (min-width: 48em) {\n      position: absolute;\n      top: 0;\n      left: calc(145.6rem - 192rem);\n      width: calc(192rem - 145.6rem + 100%);\n    }\n  }\n\n  // .slide-hero-portfolio__content\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    @media (min-width: 48em) {\n      padding-top: 26.3rem;\n      padding-bottom: 43.3rem;\n      padding-left: 14.9rem;\n      width: calc(100% + 192rem - 145.6rem);\n    }\n    @media (max-width: 48em) {\n      padding-left: 3.2rem;\n      max-width: 58rem;\n    }\n  }\n\n  // .slide-hero-portfolio__title-wrap\n\n  &__title-wrap {\n    margin-bottom: 3.2rem;\n    display: flex;\n    flex-direction: column;\n    row-gap: 0.8rem;\n    @media (max-width: 48em) {\n      margin-bottom: 2.4rem;\n      flex-direction: column-reverse;\n    }\n  }\n\n  // .slide-hero-portfolio__subtitle\n\n  &__subtitle {\n    color: #b2b2b2;\n  }\n\n  // .slide-hero-portfolio__title\n\n  &__title {\n  }\n\n  // .slide-hero-portfolio__text\n\n  &__text {\n    margin-bottom: 3.2rem;\n    @media (max-width: 48em) {\n      margin-bottom: 2.4rem;\n    }\n  }\n\n  // .slide-hero-portfolio__square\n\n  &__square {\n    margin-bottom: 4.8rem;\n    display: flex;\n    flex-direction: column;\n    row-gap: 4.8rem;\n    &::after {\n      content: '';\n      width: 4rem;\n      height: 2px;\n      background-color: $white;\n    }\n    @media (max-width: 48em) {\n      margin-bottom: 4rem;\n      row-gap: 4rem;\n      &::after {\n        width: 8rem;\n      }\n    }\n  }\n\n  // .slide-hero-portfolio__link\n\n  &__link {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
